{
    "app.demo_banner": "Mode démo · données fictives",
    "common.action.back": "Retour",
    "common.loading": "Chargement…",
    "common.navigation.main": "Navigation principale",
    "error.gps.body": "Vérifiez que la localisation est activée. Sortez en plein air si besoin.",
    "error.gps.title": "GPS introuvable.",
    "error.network.body": "Vous pouvez continuer. Tout est sauvegardé. Synchronisation dès que possible.",
    "error.network.title": "Pas de réseau.",
    "error.permission.camera.cta": "Activer dans les paramètres",
    "error.permission.camera.title": "Accès caméra refusé.",
    "error.retry.cta": "Réessayer",
    "error.server.body": "Réessayez dans une minute. Si ça persiste, appelez le bureau.",
    "error.server.title": "Petit problème de notre côté.",
    "launch.explainer60.doubt.1": "Viendra-t-elle ?",
    "launch.explainer60.doubt.2": "À l’heure ?",
    "launch.explainer60.doubt.3": "Le mois prochain ?",
    "launch.explainer60.prepare.1": "Vous préparez l’essentiel.",
    "launch.explainer60.prepare.2": "Eau, savon, seau.",
    "launch.explainer60.prepare.3": "Le linge reste chez vous.",
    "launch.explainer60.prices.1": "Six formules.",
    "launch.explainer60.prices.2": "Dès {price} / mois.",
    "launch.explainer60.promise.1": "Le linge fait.",
    "launch.explainer60.promise.2": "Sans vous.",
    "launch.explainer60.promise.3": "Washed, à Lomé.",
    "launch.explainer60.relay.1": "Une laveuse vérifiée prend le relais.",
    "launch.explainer60.relay.2": "Votre laveuse habituelle revient.",
    "launch.explainer60.relay.3": "Si elle est indisponible, Washed la remplace.",
    "launch.explainer60.rhythm.1": "Vous choisissez le rythme.",
    "launch.explainer60.rhythm.2": "Une ou deux visites par mois.",
    "launch.explainer60.rhythm.3": "Le jour et le créneau qui vous vont.",
    "launch.explainer60.tie.1": "Pause gratuite, annulation libre.",
    "launch.explainer60.tie.2": "Partout à Lomé : washedafrica.com",
    "launch.explainer60.track.1": "Abonnez-vous sur WhatsApp, payez avant la visite.",
    "launch.explainer60.track.2": "Mixx by Yas ou Flooz. Jamais en espèces.",
    "launch.explainer60.vetted.1": "Identité.",
    "launch.explainer60.vetted.2": "Références.",
    "launch.explainer60.vetted.3": "Entretien.",
    "launch.explainer60.vetted.4": "Chaque laveuse est vérifiée.",
    "launch.explainer60.weekend.1": "Le week-end",
    "launch.explainer60.weekend.2": "est court.",
    "launch.explainer60.weekend.3": "Et la lessive prend tout le dimanche.",
    "launch.spot30.knots.1": "Une laveuse vérifiée.",
    "launch.spot30.knots.2": "Chez vous.",
    "launch.spot30.knots.3": "Votre eau, votre savon.",
    "launch.spot30.price.1": "Dès {price} / mois.",
    "launch.spot30.price.2": "Solo · Duo · Foyer",
    "launch.spot30.promise.1": "Le linge fait.",
    "launch.spot30.promise.2": "Sans vous.",
    "launch.spot30.sunday.1": "Dimanche.",
    "launch.spot30.sunday.2": "14 h.",
    "launch.spot30.sunday.3": "Encore la lessive ?",
    "launch.spot30.tie.1": "Partout à Lomé.",
    "launch.spot30.tie.2": "Abonnez-vous sur WhatsApp",
    "launch.spot30.track.1": "Abonnez-vous sur WhatsApp.",
    "launch.spot30.track.2": "Payé d’avance par Mixx by Yas ou Flooz.",
    "launch.story.ablavi.caption_continuity": "Votre laveuse habituelle revient. Si elle est indisponible, Washed organise son remplacement.",
    "launch.story.ablavi.caption_dates": "Pour Ablavi : le 3, le 12, le 21. Le même message.",
    "launch.story.ablavi.caption_pay": "Vous payez avant la visite. Jamais en espèces.",
    "launch.story.ablavi.caption_waiting": "Le linge attend. Et elle cherche quelqu’un d’autre.",
    "launch.story.ablavi.caption_whatsapp": "Ablavi a écrit à Washed sur WhatsApp.",
    "launch.story.ablavi.contact": "Laveuse",
    "launch.story.ablavi.end_line": "Une laveuse vérifiée, chaque mois.",
    "launch.story.ablavi.msg_choice": "Un passage.",
    "launch.story.ablavi.msg_day": "Vendredi matin.",
    "launch.story.ablavi.msg_hello": "Bonjour, nous sommes trois : mon mari, notre fils et moi. Je cherche une laveuse régulière.",
    "launch.story.ablavi.no_show": "Bonjour madame, je ne pourrai pas venir aujourd’hui.",
    "launch.story.ablavi.tag_regular": "Votre laveuse",
    "launch.story.ablavi.tag_regular_sub": "revient chaque mois",
    "launch.story.ablavi.tag_unavailable": "Indisponible ?",
    "launch.story.ablavi.tag_unavailable_sub": "Washed la remplace",
    "launch.story.afi.caption_done": "Jeudi, Afi a révisé. Le linge était fait.",
    "launch.story.afi.caption_exam": "Lundi. Afi passe son examen dans 3 jours.",
    "launch.story.afi.caption_piling": "Le linge s’accumule. Les révisions aussi.",
    "launch.story.afi.caption_whatsapp": "Afi a écrit à Washed sur WhatsApp.",
    "launch.story.afi.countdown": "3 jours",
    "launch.story.afi.end_line": "Une laveuse vérifiée, chez vous.",
    "launch.story.afi.msg_choice": "Un passage.",
    "launch.story.afi.msg_day": "Mercredi matin ?",
    "launch.story.afi.msg_hello": "Bonjour, je suis étudiante, je vis seule et je révise mes examens.",
    "launch.story.afi.subject": "droit constitutionnel",
    "launch.story.afi.tag_exam": "Examen",
    "launch.story.afi.tag_jeans": "Jeans",
    "launch.story.afi.tag_laundry": "Linge",
    "launch.story.afi.tag_sheets": "Draps",
    "launch.story.afi.tag_tshirts": "T-shirts",
    "launch.story.agenda.laundry": "Lessive",
    "launch.story.agenda.laundry_length": "3 heures",
    "launch.story.agenda.today": "Aujourd’hui",
    "launch.story.akossiwa.caption_family": "Le linge d’une famille de cinq.",
    "launch.story.akossiwa.caption_free": "Le samedi lui appartient de nouveau.",
    "launch.story.akossiwa.caption_saturday": "Et un seul samedi pour tout laver.",
    "launch.story.akossiwa.caption_visit": "Sa laveuse vérifiée lave le linge de toute la maison. Si elle est indisponible, Washed la remplace.",
    "launch.story.akossiwa.caption_whatsapp": "Maman Akossiwa a écrit à Washed sur WhatsApp.",
    "launch.story.akossiwa.end_line": "Le linge de toute la maison, chez vous.",
    "launch.story.akossiwa.msg_choice": "Deux passages. À cinq, il le faut.",
    "launch.story.akossiwa.msg_day": "Le jeudi matin.",
    "launch.story.akossiwa.msg_hello": "Bonjour, nous sommes cinq à la maison : mon mari, nos trois enfants et moi.",
    "launch.story.akossiwa.saturday": "samedi",
    "launch.story.akossiwa.tag_children": "Les enfants",
    "launch.story.akossiwa.tag_market": "Le marché",
    "launch.story.akossiwa.tag_nap": "Une sieste",
    "launch.story.akossiwa.tag_sheets": "draps",
    "launch.story.akossiwa.tag_towels": "serviettes",
    "launch.story.akossiwa.tag_uniforms": "uniformes",
    "launch.story.akossiwa.tag_wrappers": "pagnes",
    "launch.story.amivi.caption_party": "Dimanche, Amivi n’a pensé qu’à la fête.",
    "launch.story.amivi.caption_pile": "Sauf la lessive.",
    "launch.story.amivi.caption_ready": "Dimanche, tout est prêt.",
    "launch.story.amivi.caption_sunday": "Voici Amivi. Dimanche, elle a tout prévu.",
    "launch.story.amivi.caption_tuesday": "Mardi matin, Akouvi est venue laver chez elle. Avec son eau et son savon.",
    "launch.story.amivi.caption_whatsapp": "Jeudi, Amivi a écrit à Washed sur WhatsApp.",
    "launch.story.amivi.caption_who": "Qui va s’en occuper ?",
    "launch.story.amivi.contact_mum": "Maman",
    "launch.story.amivi.end_line": "Une laveuse vérifiée, chez vous.",
    "launch.story.amivi.end_price": "Dès {price} / mois",
    "launch.story.amivi.event_baptism": "Baptême de Kafui",
    "launch.story.amivi.event_birthday": "Anniversaire de Tata Ama",
    "launch.story.amivi.event_mass": "Messe",
    "launch.story.amivi.msg_choice": "Un passage.",
    "launch.story.amivi.msg_day": "Mardi matin.",
    "launch.story.amivi.msg_hello": "Bonjour, je vis seule et je n’ai plus le temps pour ma lessive.",
    "launch.story.amivi.mum_beautiful": "Tu es très belle ce matin.",
    "launch.story.amivi.mum_calls": "Amivi !",
    "launch.story.amivi.mum_dress": "Ta robe pour le baptême est propre ?",
    "launch.story.amivi.ready_note": "Linge prêt depuis mardi",
    "launch.story.amivi.reply_not_yet": "Pas encore…",
    "launch.story.amivi.reply_ready": "Le linge était prêt depuis mardi.",
    "launch.story.assistant.ask_day": "Très bien. Quel jour vous arrangerait, du lundi au samedi ?",
    "launch.story.assistant.ask_household": "Vous êtes combien à la maison ?",
    "launch.story.assistant.greet": "{hello} ! Bienvenue chez Washed 👋 {question}",
    "launch.story.assistant.held": "Réservé 30 minutes : {day} {window}. Réglez le premier mois par Mixx by Yas ou Flooz ; nous confirmons dès le paiement vérifié.",
    "launch.story.assistant.hello_day": "Bonjour",
    "launch.story.assistant.hello_evening": "Bonsoir",
    "launch.story.assistant.menu_intro": "Pour {people}, la formule {plan} :",
    "launch.story.assistant.menu_one": "• 1 passage par mois : {price}",
    "launch.story.assistant.menu_question": "Vous préférez 1 ou 2 passages ?",
    "launch.story.assistant.menu_two": "• 2 passages par mois : {price}",
    "launch.story.assistant.people_duo": "deux personnes",
    "launch.story.assistant.people_foyer": "3 à 5 personnes",
    "launch.story.assistant.people_solo": "une personne",
    "launch.story.assistant.status": "Assistant · WhatsApp",
    "launch.story.assistant.window_afternoon": "après-midi (13h-17h)",
    "launch.story.assistant.window_morning": "matin (8h-12h)",
    "launch.story.cta": "Abonnez-vous sur WhatsApp",
    "launch.story.day.friday": "Vendredi",
    "launch.story.day.monday": "Lundi",
    "launch.story.day.saturday": "Samedi",
    "launch.story.day.sunday": "Dimanche",
    "launch.story.day.thursday": "Jeudi",
    "launch.story.day.tuesday": "Mardi",
    "launch.story.day.wednesday": "Mercredi",
    "launch.story.dzifa.caption_outfits": "Trois cérémonies, trois tenues à laver.",
    "launch.story.dzifa.caption_ready": "Jeudi matin, sa laveuse est venue. Les trois tenues sont prêtes.",
    "launch.story.dzifa.caption_weekend": "Le week-end de Dzifa, à Lomé.",
    "launch.story.dzifa.caption_whatsapp": "Lundi, Dzifa a écrit à Washed sur WhatsApp.",
    "launch.story.dzifa.end_line": "Une laveuse vérifiée, chez vous.",
    "launch.story.dzifa.funeral": "enterrement",
    "launch.story.dzifa.msg_choice": "Deux passages, avec toutes ces tenues.",
    "launch.story.dzifa.msg_day": "Jeudi matin, avant le week-end.",
    "launch.story.dzifa.msg_hello": "Bonjour ! Je vis seule, et j’ai des cérémonies presque chaque week-end.",
    "launch.story.dzifa.tag_funeral": "Enterrement",
    "launch.story.dzifa.tag_wake": "Veillée",
    "launch.story.dzifa.tag_wedding": "Mariage",
    "launch.story.dzifa.wake": "veillée",
    "launch.story.dzifa.wedding": "mariage",
    "launch.story.edem_sena.caption_deal": "Moitié chacun. Plus de dispute.",
    "launch.story.edem_sena.caption_fight": "Edem et Sena. Ça fait trois semaines que ça dure.",
    "launch.story.edem_sena.caption_whatsapp": "Le lendemain, Edem a écrit à Washed sur WhatsApp.",
    "launch.story.edem_sena.contact": "Edem",
    "launch.story.edem_sena.deal_1": "J’ai demandé à Washed. Une laveuse chez nous, {price} par mois pour nous deux.",
    "launch.story.edem_sena.deal_2": "Tu mets {half}, je mets {half} ?",
    "launch.story.edem_sena.deal_3": "Marché conclu ❤️",
    "launch.story.edem_sena.end_line": "Le linge à deux, sans dispute.",
    "launch.story.edem_sena.fight_1": "C’est ton tour pour la lessive.",
    "launch.story.edem_sena.fight_2": "J’ai fait la vaisselle.",
    "launch.story.edem_sena.fight_3": "Mardi dernier.",
    "launch.story.edem_sena.fight_4": "Ça compte.",
    "launch.story.edem_sena.fight_5": "Edem.",
    "launch.story.edem_sena.msg_choice": "Un passage, pour commencer.",
    "launch.story.edem_sena.msg_day": "Samedi matin, nous serons là tous les deux.",
    "launch.story.edem_sena.msg_hello": "Bonjour, nous sommes deux à la maison, ma femme et moi.",
    "launch.story.kossi.caption_match": "Samedi à 16 h, Kossi regarde le match.",
    "launch.story.kossi.caption_port": "Kossi rentre du port à 21 h.",
    "launch.story.kossi.caption_saturday": "Samedi, le match à 16 h. Et une bassine qui l’attend.",
    "launch.story.kossi.caption_week": "Toute la semaine, une chemise propre par jour.",
    "launch.story.kossi.caption_whatsapp": "Lundi soir, Kossi a écrit à Washed sur WhatsApp.",
    "launch.story.kossi.end_line": "Une laveuse vérifiée, chez vous.",
    "launch.story.kossi.msg_choice": "Deux passages. Une chemise par jour, ça fait beaucoup.",
    "launch.story.kossi.msg_day": "Samedi matin.",
    "launch.story.kossi.msg_hello": "Bonsoir. Je vis seul et mes chemises s’accumulent toute la semaine.",
    "launch.story.kossi.shirts": "chemises propres",
    "launch.story.kossi.tag_match": "Le match",
    "launch.story.kossi.tag_match_when": "samedi, 16 h",
    "launch.story.kossi.tag_tub": "La bassine",
    "launch.story.kossi.tag_tub_when": "samedi, toute la journée",
    "launch.story.price_from": "{plan} : dès {price} / mois",
    "launch.story.yawa.at_market": "au marché",
    "launch.story.yawa.caption_days": "Du mardi au samedi au marché. Le dimanche, c’est la famille.",
    "launch.story.yawa.caption_monday": "Lundi matin, sa laveuse s’occupe du linge.",
    "launch.story.yawa.caption_none": "Son lundi de repos part en lessive.",
    "launch.story.yawa.caption_open": "Yawa ouvre sa boutique au Grand Marché à 6 h.",
    "launch.story.yawa.caption_whatsapp": "Mercredi, entre deux clientes, Yawa a écrit à Washed.",
    "launch.story.yawa.end_line": "Vous gérez votre commerce. Elle s’occupe du linge.",
    "launch.story.yawa.msg_choice": "Un passage.",
    "launch.story.yawa.msg_day": "Le lundi matin, je suis à la maison.",
    "launch.story.yawa.msg_hello": "Bonjour, je vis seule et je suis au marché du mardi au samedi.",
    "launch.story.yawa.place": "Assigamé",
    "launch.story.yawa.tag_laundry": "Lessive ?",
    "launch.video.phone.request": "Bonjour, je voudrais une laveuse. Juste moi.",
    "launch.video.prices.unit": "F CFA / mois",
    "launch.video.prices.visits_1": "1 visite / mois",
    "launch.video.prices.visits_2": "2 visites / mois",
    "launch.video.rhythm.day": "Mardi",
    "launch.video.rhythm.per_month": "par mois",
    "launch.video.rhythm.slot": "Matin",
    "launch.video.rhythm.visits_1": "1 visite",
    "launch.video.rhythm.visits_2": "2 visites",
    "marketing.availability.body": "Où que vous soyez dans la ville, une laveuse vérifiée peut venir chez vous.",
    "marketing.availability.head": "Washed, partout à Lomé.",
    "marketing.closing.eyebrow": "L'invitation",
    "marketing.closing.fine": "Vos coordonnées restent privées. Vous pouvez quitter la liste à tout moment.",
    "marketing.closing.form.loading": "Envoi…",
    "marketing.closing.form.placeholder.email": "votre@email.com (optionnel)",
    "marketing.closing.form.placeholder.phone": "+228 90 12 34 56",
    "marketing.closing.form.placeholder.quartier": "Votre quartier (optionnel)",
    "marketing.closing.form.submit": "Rejoindre la liste",
    "marketing.closing.form.success": "Place #{position} gardée. À très vite.",
    "marketing.closing.h2": "Inscrivez-vous, Washed vous recontacte.",
    "marketing.closing.invitation": "Laissez-nous votre numéro et votre quartier. L’inscription est gratuite et ne vous engage pas à vous abonner.",
    "marketing.closing.lead": "Partout à Lomé, dans chaque quartier.",
    "marketing.compare.avec.h3": "Un rendez-vous prévu.",
    "marketing.compare.avec.item1": "Une ou deux visites par mois, selon le jour et le créneau choisis.",
    "marketing.compare.avec.item2": "Votre laveuse habituelle revient, sauf indisponibilité.",
    "marketing.compare.avec.item3": "Une laveuse vérifiée : identité, références et entretien.",
    "marketing.compare.avec.item4": "Paiement Mixx by Yas ou Flooz et reçu dans l’application.",
    "marketing.compare.avec.item5": "Pause gratuite jusqu’à 2 mois par an. Annulation libre.",
    "marketing.compare.avec.tag": "Avec Washed",
    "marketing.compare.head.body": "Le linge reste à la maison. Ce qui change, c’est la façon de prévoir la prochaine lessive.",
    "marketing.compare.head.note": "Des formules pour une personne, un couple ou une famille.",
    "marketing.compare.head.title": "Le même linge. Moins à organiser.",
    "marketing.compare.sans.h3": "Tout repose sur vous.",
    "marketing.compare.sans.item1": "Trouver une personne disponible pour chaque lessive.",
    "marketing.compare.sans.item2": "Reprendre contact et convenir d’un créneau.",
    "marketing.compare.sans.item3": "Réexpliquer vos habitudes quand la personne change.",
    "marketing.compare.sans.item4": "Gérer le paiement directement, parfois sans trace écrite.",
    "marketing.compare.sans.item5": "Chercher seul une solution si la visite n’a pas lieu.",
    "marketing.compare.sans.tag": "Sans Washed",
    "marketing.compare.summary.avec": "Gérée par Washed",
    "marketing.compare.summary.label": "Organisation",
    "marketing.compare.summary.sans": "À votre charge",
    "marketing.consent.label": "J'accepte les conditions et la politique de confidentialité.",
    "marketing.footer.col.mentions.h5": "Mentions",
    "marketing.footer.col.mentions.link1": "Confidentialité",
    "marketing.footer.col.mentions.link2": "Conditions générales",
    "marketing.footer.col.mentions.link3": "Suppression des données",
    "marketing.footer.col.mentions.link4": "Plan du site",
    "marketing.footer.col.service.h5": "Le service",
    "marketing.footer.col.service.link1": "Comment ça marche",
    "marketing.footer.col.service.link2": "Tarif",
    "marketing.footer.col.service.link3": "Disponibilité",
    "marketing.footer.col.service.link4": "Garanties",
    "marketing.footer.col.washed.h5": "Washed",
    "marketing.footer.col.washed.link1": "Devenir laveuse",
    "marketing.footer.col.washed.link2": "Le fondateur",
    "marketing.footer.col.washed.link3": "Presse",
    "marketing.footer.col.washed.link4": "contact@washedafrica.com",
    "marketing.footer.colophon": "La plateforme qui met les foyers de Lomé en relation avec des laveuses indépendantes vérifiées. Abonnement mensuel, paiement par Mixx by Yas & Flooz. Le savon, l'eau et le seau restent les vôtres.",
    "marketing.footer.composed": "Composé en Geist & Cormorant Garamond",
    "marketing.footer.copyright": "© 2026 Washed SAS · Tous droits réservés",
    "marketing.form.error.challenge": "La vérification anti-robot n'a pas abouti. Réessayez.",
    "marketing.form.error.consent": "Cochez la case pour accepter les conditions.",
    "marketing.form.error.email": "Cette adresse e-mail semble incorrecte.",
    "marketing.form.error.network": "Pas de connexion. Vérifiez votre réseau et réessayez.",
    "marketing.form.error.phone": "Ce numéro semble incomplet. Ex. 90 12 34 56.",
    "marketing.form.error.server": "Un souci de notre côté. Réessayez dans un instant.",
    "marketing.form.hint.phone": "Ex. 90 12 34 56 — nous ajoutons le +228.",
    "marketing.form.label.email": "E-mail (optionnel)",
    "marketing.form.label.name": "Votre prénom",
    "marketing.form.label.phone": "Numéro de téléphone",
    "marketing.form.label.quartier": "Quartier (optionnel)",
    "marketing.form.verifying": "Vérification…",
    "marketing.hero.eyebrow": "Lomé · tous les quartiers",
    "marketing.hero.form.error": "Vérifiez votre numéro et réessayez.",
    "marketing.hero.form.loading": "Envoi…",
    "marketing.hero.form.placeholder.email": "votre@email.com (optionnel)",
    "marketing.hero.form.placeholder.phone": "+228 90 12 34 56",
    "marketing.hero.form.placeholder.quartier": "Votre quartier (optionnel)",
    "marketing.hero.form.submit": "Rejoindre la liste",
    "marketing.hero.form.success": "Place #{position} gardée. Washed vous recontacte.",
    "marketing.hero.headline.line1": "Le linge fait.",
    "marketing.hero.headline.line2": "Sans vous.",
    "marketing.hero.label.akouvi": "Akouvi passera mardi matin",
    "marketing.hero.label.payment": "Paiement Mixx by Yas confirmé",
    "marketing.hero.photo.alt": "Une laveuse Washed étend du linge blanc au soleil, sur une terrasse à Lomé.",
    "marketing.hero.subhead": "Une laveuse formée, chez vous. Votre eau, votre savon. Une ou deux visites par mois pour faire une place à tout le reste.",
    "marketing.hero.trust": "Laveuses vérifiées · Mixx by Yas & Flooz · Annulation libre",
    "marketing.interlude.alt": "Lumière du matin sur du linge propre.",
    "marketing.interlude.body": "Washed met les foyers de Lomé en relation avec des laveuses indépendantes vérifiées, et organise les rendez-vous et le paiement. Le linge reste chez vous.",
    "marketing.interlude.claim": "Une relation se tisse, visite après visite.",
    "marketing.interlude.tagline": "Votre maison. Vos habitudes. Un coup de main régulier.",
    "marketing.lettre.body.p1": "La vie va vite. Le week-end est court. Faire son linge à la main, le dimanche après-midi, n'est pas une option pour ma génération.",
    "marketing.lettre.body.p2": "À Lomé, le modèle qui marche depuis toujours, c'est une laveuse à la maison. Elle utilise votre eau et votre savon. Ce n'est pas toujours le moins cher. Tout le monde n'a pas les moyens. Et il y a la fiabilité. On ne sait jamais si elle viendra. Si elle viendra à l'heure. Si elle reviendra le mois suivant. Washed apporte un service moins cher, avec la même qualité, ou meilleure.",
    "marketing.lettre.body.p3": "Washed reprend ce modèle. Une laveuse formée vient chez vous une ou deux fois par mois. Elle utilise votre eau et votre savon. Vous, vous payez votre abonnement sur la plateforme. Jamais à la laveuse directement. J'ai construit ça pour tous les Africains qui veulent racheter leur temps. Les jeunes. Les femmes d'affaires. Tous ceux qui ne veulent plus passer leur week-end là-dessus.",
    "marketing.lettre.eyebrow": "Le mot du fondateur",
    "marketing.lettre.h2": "Pour acheter du temps. À petit prix.",
    "marketing.lettre.signature.name": "Ryan T.",
    "marketing.lettre.signature.title": "Fondateur. Washed",
    "marketing.lettre.who": "De Ryan T.",
    "marketing.marketplace.body": "Washed n'est pas une laverie. C'est la plateforme qui vous met en relation avec une laveuse indépendante, vérifiée — et qui s'occupe du planning et du paiement, en toute sécurité.",
    "marketing.marketplace.tagline": "Vous gardez votre laveuse, mois après mois.",
    "marketing.nav.lang_aria": "Changer de langue",
    "marketing.nav.quartiers": "Quartiers",
    "marketing.nav.service": "Service",
    "marketing.nav.skip": "Aller au contenu",
    "marketing.nav.tarif": "Tarif",
    "marketing.nav.waitlist": "S’inscrire",
    "marketing.nav.worker": "Devenir laveuse",
    "marketing.phone.cta.book": "Programmer une visite",
    "marketing.seo.coverage.body": "Washed sert tous les quartiers de Lomé. Inscrivez-vous avec votre numéro et votre quartier : l’équipe Washed vous recontacte.",
    "marketing.seo.coverage.faq.answer": "Tous, dans chaque commune de la ville. Il suffit d’indiquer votre quartier à l’inscription.",
    "marketing.seo.coverage.short": "Washed sert tous les quartiers de Lomé.",
    "marketing.seo.workers.assignments": "L’inscription à la liste ne garantit pas de missions immédiates : elles dépendent de la demande des foyers proches et de la capacité opérationnelle.",
    "marketing.seo.zones.link": "Voir les quartiers desservis à Lomé",
    "marketing.service.act1.body": "Une ou deux visites par mois. Un jour et un créneau qui vous conviennent. Votre abonnement se règle par Mixx by Yas ou Flooz.",
    "marketing.service.act1.day": "Le rendez-vous",
    "marketing.service.act1.meta_label": "Le choix",
    "marketing.service.act1.meta_value": "1 ou 2 visites / mois",
    "marketing.service.act1.title": "Vous choisissez le rythme.",
    "marketing.service.act2.body": "Le linge, de l’eau, du savon et un seau. La visite se passe chez vous, avec ce que vous utilisez déjà.",
    "marketing.service.act2.day": "Les préparatifs",
    "marketing.service.act2.meta_label": "À prévoir",
    "marketing.service.act2.meta_value": "Eau · savon · seau",
    "marketing.service.act2.title": "Vous préparez l’essentiel.",
    "marketing.service.act3.body": "Une laveuse vérifiée vient laver sur place. Votre laveuse habituelle revient par défaut ; si elle est indisponible, Washed organise son remplacement.",
    "marketing.service.act3.day": "La visite",
    "marketing.service.act3.meta_label": "Le suivi",
    "marketing.service.act3.meta_value": "Une relation qui se construit",
    "marketing.service.act3.title": "Elle prend le relais.",
    "marketing.service.after.body": "Une fois la visite terminée, retrouvez son suivi dans l’application. Votre linge, lui, reste à la maison.",
    "marketing.service.after.head": "Le linge fait. La journée continue.",
    "marketing.service.head": "Votre linge a son rythme. Vous gardez le vôtre.",
    "marketing.service.photo.alt": "Une laveuse Washed remet du linge propre à une cliente chez elle.",
    "marketing.service.subhead": "Du choix de votre formule à la visite chez vous, voici comment le service s’organise.",
    "marketing.stats.2.desc": "Une ou deux visites par mois. La même laveuse à chaque fois, vous la connaissez.",
    "marketing.stats.2.label": "Le rythme",
    "marketing.stats.2.unit": "visites / mois",
    "marketing.stats.3.desc": "Tout par Mixx by Yas ou Flooz. Le paiement passe par la plateforme, jamais en main propre.",
    "marketing.stats.3.label": "Le paiement",
    "marketing.stats.3.unit": "mobile money",
    "marketing.technology.body": "Le rendez-vous, le paiement, le suivi : tout se retrouve dans l’application. Une trace claire, du début à la fin de la visite.",
    "marketing.technology.eyebrow": "Le suivi, simplement",
    "marketing.technology.feature.continuity.body": "Votre laveuse habituelle reste affectée au foyer par défaut.",
    "marketing.technology.feature.continuity.title": "Relation suivie",
    "marketing.technology.feature.payment.body": "Mixx by Yas ou Flooz, traité par la plateforme.",
    "marketing.technology.feature.payment.title": "Paiement",
    "marketing.technology.feature.proof.body": "Check-in GPS et photos avant/après pour documenter le service.",
    "marketing.technology.feature.proof.title": "Preuve de visite",
    "marketing.technology.feature.schedule.body": "Jour et créneau sont visibles avant chaque visite.",
    "marketing.technology.feature.schedule.title": "Planning",
    "marketing.technology.head": "Vous savez qui vient. Et où en est la visite.",
    "marketing.technology.preview": "Exemple de visite",
    "marketing.technology.sample.arrival": "Arrivée le jour J",
    "marketing.technology.sample.arrivalDetail": "Check-in GPS",
    "marketing.technology.sample.confirmed": "Visite confirmée",
    "marketing.technology.sample.confirmedDetail": "Créneau réservé",
    "marketing.technology.sample.day": "Mardi",
    "marketing.technology.sample.nextVisit": "Prochaine visite",
    "marketing.technology.sample.paid": "Paiement reçu",
    "marketing.technology.sample.photos": "Photos de fin",
    "marketing.technology.sample.photosDetail": "Preuve de visite",
    "marketing.technology.sample.status": "À venir",
    "marketing.technology.sample.washerRole": "Votre laveuse habituelle",
    "marketing.worker.apply": "Voir le métier et postuler",
    "marketing.worker.bullet1": "Avant les premières visites : vérification d’identité, références et entretien en personne.",
    "marketing.worker.bullet2": "La rémunération et les éventuels bonus sont définis à l’avance et versés par la plateforme.",
    "marketing.worker.bullet3": "Vous travaillez chez les foyers avec leur eau, leur savon, leur seau, ce que vous savez déjà faire.",
    "marketing.worker.bullet4": "Les visites sont regroupées par zone et par créneau pour limiter les déplacements inutiles.",
    "marketing.worker.bullet5": "Quand la capacité le permet, la même laveuse revient auprès des mêmes foyers pour construire la confiance.",
    "marketing.worker.card.eyebrow": "Postuler · saison 2026",
    "marketing.worker.card.h3": "« Je veux devenir laveuse Washed. »",
    "marketing.worker.card.loading": "Envoi…",
    "marketing.worker.card.placeholder.email": "votre@email.com (optionnel)",
    "marketing.worker.card.placeholder.name": "Votre prénom",
    "marketing.worker.card.placeholder.phone": "Votre numéro · +228 …",
    "marketing.worker.card.placeholder.quartier": "Votre quartier",
    "marketing.worker.card.submit": "Envoyer ma candidature",
    "marketing.worker.card.success": "Candidature reçue. Nous vous contactons sous 7 jours.",
    "marketing.worker.eyebrow": "Devenir laveuse",
    "marketing.worker.h2": "Un savoir-faire qui mérite sa place.",
    "marketing.worker.lede": "Le service repose sur le savoir-faire de laveuses indépendantes. Washed organise les visites, définit la rémunération à l’avance et accompagne la relation avec les foyers.",
    "marketing.worker.photo.alt": "Une laveuse Washed, dans une cour à Lomé.",
    "marketing.zones.intro": "Washed sert tout Lomé. Cette page regroupe les principaux quartiers et communes de la ville pour vous aider à repérer le vôtre.",
    "marketing.zones.list.intro": "Les noms ci-dessous sont regroupés par commune pour aider les habitants de Lomé à repérer leur quartier.",
    "marketing.zones.list.name": "Quartiers de Lomé desservis par Washed",
    "marketing.zones.note.body": "S’il se trouve à Lomé, il est desservi. Indiquez-le simplement à l’inscription.",
    "marketing.zones.note.title": "Votre quartier n’est pas dans la liste ?",
    "marketing.zones.title": "Laveuse à domicile dans tous les quartiers de Lomé",
    "ops.access_error.assignment_already_active": "Ce rôle est déjà actif.",
    "ops.access_error.assignment_not_found": "Ce rôle n’est plus actif.",
    "ops.access_error.capability_required": "Cette action est réservée aux administrateurs.",
    "ops.access_error.invalid_request": "Demande invalide : choisissez un rôle connu et donnez une raison (1 000 caractères au plus).",
    "ops.access_error.last_administrator": "Le dernier administrateur ne peut pas être retiré : nommez-en d’abord un autre.",
    "ops.access_error.operator_not_found": "Aucun opérateur de ce pays ne correspond.",
    "ops.access_error.self_change": "Vous ne pouvez pas changer vos propres accès : un autre administrateur le fait.",
    "ops.access_error.unavailable": "Les accès ne peuvent pas être modifiés pour le moment : réessayez.",
    "ops.audit.cta_filter": "Filtrer",
    "ops.audit.current_filter": "Filtre courant",
    "ops.audit.description": "Journal des actions d’audit disponibles.",
    "ops.audit.detail.back": "Retour au journal →",
    "ops.audit.detail.load_error": "Impossible de charger cet événement.",
    "ops.audit.detail.missing_id": "Identifiant manquant.",
    "ops.audit.detail.not_found": "Événement introuvable.",
    "ops.audit.event.matching": "Matching",
    "ops.audit.event.privacy": "Confidentialité",
    "ops.audit.event.refund": "Remboursement",
    "ops.audit.filter": "Filtrer",
    "ops.audit.filter_all": "Tout",
    "ops.audit.immutable": "Historique immuable",
    "ops.audit.title": "Audit",
    "ops.brand": "Washed Operator Console",
    "ops.console.boundary.failed": "Cette page n’a pas pu s’afficher.",
    "ops.console.boundary.keep": "Rechargez pour continuer. La console vous redemandera de vous connecter.",
    "ops.console.boundary.reload": "Recharger",
    "ops.console.boundary.updated": "La console a été mise à jour pendant que cet onglet était ouvert.",
    "ops.console.brand": "washed",
    "ops.console.command_palette.close": "Fermer la palette",
    "ops.console.command_palette.empty": "Aucun résultat. Essayez « visites », « laveuse Ama », « refund »…",
    "ops.console.command_palette.hint_dismiss": "Échap",
    "ops.console.command_palette.hint_navigate": "Flèches",
    "ops.console.command_palette.hint_open": "Entrée",
    "ops.console.command_palette.open": "Ouvrir la palette de commandes",
    "ops.console.command_palette.placeholder": "Tapez une commande ou une recherche…",
    "ops.console.drawer.close": "Fermer le tiroir",
    "ops.console.drawer.empty": "Sélectionnez une ligne pour afficher le détail à droite.",
    "ops.console.idle.continue": "Rester connecté(e)",
    "ops.console.idle.signout": "Se déconnecter maintenant",
    "ops.console.idle.warn_body": "Aucune activité depuis 28 minutes. Cliquez ou appuyez sur une touche pour rester connecté(e).",
    "ops.console.idle.warn_title": "Vous serez bientôt déconnecté(e)",
    "ops.console.offline_banner.body": "Les écritures (assigner, rembourser, suspendre) sont indisponibles jusqu’au retour du réseau.",
    "ops.console.offline_banner.title": "Bureau hors ligne",
    "ops.console.placeholder.body": "Cet écran fait partie de la console opérateur en cours de construction. Le composant réel arrive au Sprint {sprint}.",
    "ops.console.placeholder.kicker": "CHANTIER · SPRINT {sprint}",
    "ops.console.sidebar.collapse": "Réduire le menu",
    "ops.console.sidebar.expand": "Déployer le menu",
    "ops.console.skip_to_main": "Aller au contenu principal",
    "ops.console.subtitle": "Console bureau · Lomé",
    "ops.console.topbar.notifications": "Notifications",
    "ops.console.topbar.operator_menu": "Menu opérateur",
    "ops.console.topbar.search_placeholder": "Rechercher abonné·e, laveuse, visite…",
    "ops.console.topbar.settings": "Réglages",
    "ops.console.topbar.shortcut_hint": "⌘ K",
    "ops.console.topbar.signout": "Se déconnecter",
    "ops.dashboard.assign": "Affecter",
    "ops.dashboard.description": "Vue prioritaire sur la journée et la chaîne d’exécution.",
    "ops.dashboard.drawer_eta": "Créneau",
    "ops.dashboard.drawer_status": "Statut",
    "ops.dashboard.drawer_subscriber": "Abonné",
    "ops.dashboard.drawer_title": "Détail de ligne",
    "ops.dashboard.drawer_worker": "Laveuse",
    "ops.dashboard.metrics": "Indicateurs",
    "ops.dashboard.notifications_due": "notifications dues",
    "ops.dashboard.open": "Ouvrir",
    "ops.dashboard.open_route": "Ouvrir la planification",
    "ops.dashboard.readiness": "Prêt de service",
    "ops.dashboard.risks": "risques",
    "ops.dashboard.shortcut.matching_desc": "Lancer un appairage en priorité.",
    "ops.dashboard.shortcut.routing": "Routage",
    "ops.dashboard.shortcut.routing_desc": "Ajuster la charge des tournées.",
    "ops.dashboard.shortcuts": "Raccourcis",
    "ops.dashboard.tabs.all": "Tous",
    "ops.dashboard.tabs.modified": "Modifiées",
    "ops.dashboard.tabs.risk": "Risque",
    "ops.dashboard.tabs.unassigned": "Non affectées",
    "ops.dashboard.title": "Tableau de bord",
    "ops.disputes.badge_open": "ouverts",
    "ops.disputes.cta_escalate": "Escalader",
    "ops.disputes.cta_resolve": "Résoudre",
    "ops.disputes.description": "Traitement des litiges entrants.",
    "ops.disputes.escalated": "Escaladés",
    "ops.disputes.evidence": "Éléments",
    "ops.disputes.evidence_value": "Aucun élément",
    "ops.disputes.list_label": "Liste des litiges",
    "ops.disputes.resolved": "Résolus",
    "ops.disputes.title": "Litiges",
    "ops.drawer.label": "Panneau latéral",
    "ops.economy.active_subs": "Abonnements actifs",
    "ops.economy.badge_alarm": "Alerte",
    "ops.economy.badge_ok": "OK",
    "ops.economy.churn_hint": "Actifs × churn mensuel (rétention annuelle de 70 %).",
    "ops.economy.churn_replacement": "Remplacement du churn (estimé)",
    "ops.economy.duration_column_avg": "Durée moyenne (min)",
    "ops.economy.duration_column_month": "Mois",
    "ops.economy.duration_column_visits": "Passages",
    "ops.economy.duration_empty": "Aucun passage mesuré.",
    "ops.economy.duration_hint": "6 derniers mois — vigie saison des pluies.",
    "ops.economy.duration_title": "Durée moyenne des passages",
    "ops.economy.error": "Impossible de charger les indicateurs.",
    "ops.economy.family_mix": "Part des formules Famille",
    "ops.economy.family_mix_hint": "Part FE + FC des abonnements actifs — alerte sous le seuil.",
    "ops.economy.gross_adds": "Nouvelles souscriptions ce mois-ci",
    "ops.economy.link": "Économie & leviers",
    "ops.economy.momo_trigger": "Négociation des frais MoMo",
    "ops.economy.momo_trigger_hint": "Déclencheur : {count} abonnements actifs.",
    "ops.economy.momo_volume": "Volume MoMo ce mois-ci",
    "ops.economy.repassage_dispatcher": "Seuil dispatch dédié",
    "ops.economy.repassage_jobs": "Missions repassage ce mois-ci",
    "ops.economy.repassage_recalibration": "Seuil de recalibrage du tarif",
    "ops.economy.subtitle": "Leviers, seuils et déclencheurs — calculés sur les données réelles.",
    "ops.economy.threshold_label": "Seuil",
    "ops.economy.threshold_reached": "Seuil atteint",
    "ops.economy.threshold_watching": "En veille",
    "ops.economy.title": "Économie",
    "ops.economy.unavailable": "Indisponible",
    "ops.economy.workers_smig": "Laveuses sous le SMIG (mois en cours)",
    "ops.economy.workers_smig_hint": "Rémunération du mois à date sous {amount}.",
    "ops.error.session_expired": "Session expirée. Reconnectez-vous pour continuer.",
    "ops.extrawash.confirm_cta": "Confirmer et assigner",
    "ops.extrawash.decline_cta": "Refuser",
    "ops.extrawash.decline_reason_label": "Motif du refus",
    "ops.extrawash.empty": "Aucune demande en attente",
    "ops.extrawash.error.cycle_limit": "Ce foyer a déjà un lavage supplémentaire confirmé pour ce cycle.",
    "ops.extrawash.error.date_out_of_window": "Cette date n'est plus réservable (de demain à J+14). Refusez la demande.",
    "ops.extrawash.error.slot_taken": "Cette laveuse a déjà une visite sur ce créneau. Choisissez-en une autre.",
    "ops.extrawash.status_confirmed": "Confirmé",
    "ops.extrawash.status_declined": "Refusé",
    "ops.extrawash.status_expired": "Expiré",
    "ops.extrawash.status_requested": "Demandé",
    "ops.fairuse.open_reviews": "Revues ouvertes",
    "ops.feedback.audit_filtered": "Filtre d’audit appliqué.",
    "ops.feedback.blocklist_added": "Restriction ajoutée.",
    "ops.feedback.dispute_escalated": "Litige escaladé.",
    "ops.feedback.dispute_resolved": "Litige résolu.",
    "ops.feedback.forced_update_toggled": "Mode forçage basculé.",
    "ops.feedback.login_otp_sent": "Code OTP envoyé.",
    "ops.feedback.login_verified": "Connexion vérifiée.",
    "ops.feedback.matching_accepted": "Matching accepté.",
    "ops.feedback.matching_rejected": "Matching refusé.",
    "ops.feedback.notifications_delivered": "Notifications envoyées.",
    "ops.feedback.payment_retry_queued": "Relance de paiement mise en file.",
    "ops.feedback.payout_batch_started": "Lot de paiement démarré.",
    "ops.feedback.payout_retry_queued": "Relance de versement planifiée.",
    "ops.feedback.readiness_checked": "Vérification de readiness faite.",
    "ops.feedback.refund_issued": "Remboursement effectué.",
    "ops.feedback.report_exported": "Rapport exporté.",
    "ops.feedback.route_plan_approved": "Planification approuvée.",
    "ops.feedback.route_plan_risk_acknowledged": "Risque identifié.",
    "ops.feedback.subscriber_privacy_handled": "Confidentialité abonné traitée.",
    "ops.feedback.worker_privacy_handled": "Confidentialité laveuse traitée.",
    "ops.flags.action_disable": "Désactiver",
    "ops.flags.action_enable": "Activer",
    "ops.flags.audience_all": "Tout le monde",
    "ops.flags.audience_beta": "Bêta",
    "ops.flags.column.action": "Action",
    "ops.flags.column.audience": "Audience",
    "ops.flags.column.flag": "Drapeau",
    "ops.flags.column.state": "État",
    "ops.flags.column.updated": "Mis à jour",
    "ops.flags.confirm_apply": "Confirmer",
    "ops.flags.confirm_cancel": "Annuler",
    "ops.flags.confirm_disable": "Désactiver « {flag} » pour tous les clients ?",
    "ops.flags.confirm_enable": "Activer « {flag} » pour tous les clients ?",
    "ops.flags.empty": "Aucun drapeau configuré.",
    "ops.flags.error": "Impossible de charger les drapeaux.",
    "ops.flags.link": "Drapeaux de fonctionnalités",
    "ops.flags.state_off": "Désactivé",
    "ops.flags.state_on": "Activé",
    "ops.flags.subtitle": "Activation par configuration — sans déploiement ni mise à jour d’app.",
    "ops.flags.title": "Drapeaux de fonctionnalités",
    "ops.flags.toggle_error": "Le changement n’a pas été enregistré. Réessayez.",
    "ops.header.command_palette": "Palette de commandes",
    "ops.inbox.attempts": "{count} tentative(s)",
    "ops.inbox.available": "Disponible à partir du",
    "ops.inbox.channel": "Canal",
    "ops.inbox.channel_in_app": "Dans l’application",
    "ops.inbox.channel_push": "Push",
    "ops.inbox.channel_sms": "SMS",
    "ops.inbox.channel_whatsapp": "WhatsApp",
    "ops.inbox.description": "Registre de traitement des notifications, pas une conversation ni une preuve de réception.",
    "ops.inbox.empty": "Aucune notification dans cette liste.",
    "ops.inbox.error": "Impossible de charger les notifications.",
    "ops.inbox.evidence": "Un envoi enregistré ne prouve ni la réception ni la lecture. Les simulations locales sont distinguées.",
    "ops.inbox.loading": "Chargement des notifications…",
    "ops.inbox.recipient": "Destinataire",
    "ops.inbox.refresh": "Actualiser",
    "ops.inbox.refresh_error": "Actualisation impossible : les lignes affichées datent du dernier chargement réussi.",
    "ops.inbox.retry": "Réessayer",
    "ops.inbox.role_operator": "Opérateur",
    "ops.inbox.role_subscriber": "Abonnée",
    "ops.inbox.role_worker": "Travailleuse",
    "ops.inbox.scope": "Togo · {count} lignes affichées, jusqu’à {limit} · ordre de disponibilité · heures de Lomé (UTC).",
    "ops.inbox.status": "Traitement",
    "ops.inbox.status_failed": "Échec",
    "ops.inbox.status_in_app": "Disponible dans l’application",
    "ops.inbox.status_local": "Simulation locale",
    "ops.inbox.status_pending": "En attente",
    "ops.inbox.status_quiet": "Non envoyée · heures calmes",
    "ops.inbox.status_sent": "Envoi enregistré",
    "ops.inbox.subject_assignment": "Affectation confirmée",
    "ops.inbox.subject_cancelled": "Visite annulée",
    "ops.inbox.subject_grace_first": "Premier rappel · membres du foyer",
    "ops.inbox.subject_grace_refused": "Linge non enregistré refusé",
    "ops.inbox.subject_grace_second": "Deuxième rappel · membres du foyer",
    "ops.inbox.subject_ironing_accepted": "Repassage accepté",
    "ops.inbox.subject_ironing_completed": "Repassage terminé",
    "ops.inbox.subject_offer": "Proposition d’affectation",
    "ops.inbox.subject_payment": "Échec de paiement",
    "ops.inbox.subject_referral": "Parrainage qualifié",
    "ops.inbox.subject_seat": "Invitation à ajouter un membre",
    "ops.inbox.subject_swap": "Demande de changement de travailleuse",
    "ops.inbox.template": "Modèle / message",
    "ops.kpi.disputes.open": "Litiges ouverts",
    "ops.kpi.payments.exceptions": "Exceptions paiement",
    "ops.kpi.privacy.pending": "Confidentialité en attente",
    "ops.kpi.queue.pending": "File en attente",
    "ops.kpi.routes.overload": "Surfaces à risque",
    "ops.kpi.sos.open": "SOS ouverts",
    "ops.kpi.visits.risk": "Visites à risque",
    "ops.liveops.description": "Cartographie temps réel des interventions.",
    "ops.liveops.drawer_alert_desc": "Alerte opérationnelle",
    "ops.liveops.drawer_alert_title": "Alerte",
    "ops.liveops.drawer_desc": "Flux temps réel des interventions.",
    "ops.liveops.drawer_support": "Support",
    "ops.liveops.drawer_support_detail": "Support opérationnel disponible 24h/7.",
    "ops.liveops.drawer_title": "Live ops",
    "ops.liveops.kpi.at_risk": "À risque",
    "ops.liveops.kpi.finished": "Terminées",
    "ops.liveops.kpi.in_progress": "En cours",
    "ops.liveops.kpi.unsolved": "Non résolues",
    "ops.liveops.kpi.upcoming": "À venir",
    "ops.liveops.map.detail.address": "Adresse",
    "ops.liveops.map.detail.close": "Fermer le détail de visite",
    "ops.liveops.map.detail.payment": "Paiement",
    "ops.liveops.map.detail.payment_unavailable": "Voir Paiements",
    "ops.liveops.map.detail.status": "Statut",
    "ops.liveops.map.detail.subscriber": "Cliente",
    "ops.liveops.map.detail.title": "Détail visite",
    "ops.liveops.map.detail.window": "Créneau",
    "ops.liveops.map.detail.worker": "Laveuse",
    "ops.liveops.map.detail.worker_unassigned": "Non assignée",
    "ops.liveops.title": "Suivi en direct",
    "ops.login.badge": "Connexion opérateur",
    "ops.login.cta_send": "Envoyer le code",
    "ops.login.cta_verify": "Valider",
    "ops.login.description": "Accédez au poste d’exploitation après vérification.",
    "ops.login.otp_label": "Code OTP",
    "ops.login.phone_label": "Numéro opérateur",
    "ops.login.title": "Connexion opérateur",
    "ops.matching.auto.awaiting": "Auto · en attente d’acceptation",
    "ops.matching.auto.awaiting_detail": "{worker}, expire dans {minutes} min",
    "ops.matching.auto.awaiting_detail_expired": "{worker}, offre expirée",
    "ops.matching.auto.due_in": "Échéance dans {minutes} min",
    "ops.matching.auto.fresh": "Auto · recherche d’une laveuse",
    "ops.matching.auto.needs_review": "À revoir · attribution manuelle",
    "ops.matching.auto.offered_count": "{count} laveuse(s) déjà sollicitée(s)",
    "ops.matching.auto.overdue": "Échéance dépassée",
    "ops.matching.auto.override": "Forcer une autre laveuse",
    "ops.matching.auto.why": "Pourquoi cette laveuse",
    "ops.matching.candidates.title": "Candidates — triées par proximité & charge",
    "ops.matching.cta_accept": "Accepter",
    "ops.matching.cta_propose": "Proposer",
    "ops.matching.cta_reject": "Refuser",
    "ops.matching.cta_send": "Envoyer la proposition",
    "ops.matching.current": "Matching actif",
    "ops.matching.current_detail": "Détails du matching en cours",
    "ops.matching.current_title": "Attribution en cours",
    "ops.matching.decision_log": "Journal de décision",
    "ops.matching.decision_log_body": "Décision consignée pour audit.",
    "ops.matching.description": "Appairage contrôlé des demandes aux laveuses disponibles.",
    "ops.matching.drawer_desc": "Détails matching",
    "ops.matching.drawer_stat_candidates": "Candidats actifs",
    "ops.matching.drawer_stat_score": "Score moyen",
    "ops.matching.drawer_stat_wait": "Temps d’attente",
    "ops.matching.drawer_title": "Matching",
    "ops.matching.empty": "Aucune demande en attente.",
    "ops.matching.lane.all": "Tout ({count})",
    "ops.matching.lane.needs_review": "À revoir ({count})",
    "ops.matching.lane.needs_review_empty": "Aucune attribution à revoir.",
    "ops.matching.queue.label": "File de matching",
    "ops.matching.queue.title": "{count} en attente",
    "ops.matching.reason.continuity": "Laveuse habituelle",
    "ops.matching.reason.proximity": "À {km} km",
    "ops.matching.reason.rating": "Note {rating}/5",
    "ops.matching.reason.workload": "Charge {remaining}/{max} dispo",
    "ops.matching.score.label": "Score",
    "ops.matching.sla.warning": "SLA {hours}h{minutes}",
    "ops.matching.status.accepted": "Accepté",
    "ops.matching.status.almost_full": "CHARGE PRESQUE PLEINE",
    "ops.matching.status.full": "PLEIN",
    "ops.matching.status.pending": "En attente",
    "ops.matching.status.rejected": "Refusé",
    "ops.matching.tabs.assigned": "Attribuées",
    "ops.matching.tabs.pending": "En attente",
    "ops.matching.tabs.rejected": "Refusées",
    "ops.matching.title": "Matching",
    "ops.matching.visits": "visites",
    "ops.metrics.updated": "Mis à jour",
    "ops.nav.audit": "Audit",
    "ops.nav.dashboard": "Tableau de bord",
    "ops.nav.disputes": "Litiges",
    "ops.nav.group.finance": "Finances",
    "ops.nav.group.org": "Organisation",
    "ops.nav.group.people": "Profils",
    "ops.nav.group.today": "Aujourd’hui",
    "ops.nav.live_ops": "Live ops",
    "ops.nav.matching": "Matching",
    "ops.nav.notifications": "Notifications",
    "ops.nav.payments": "Paiements",
    "ops.nav.planning": "Planification",
    "ops.nav.profiles": "Profils",
    "ops.nav.reports": "Rapports",
    "ops.nav.settings": "Paramètres",
    "ops.navigation.aria": "Navigation opérateur",
    "ops.notification.title.assignment": "Notification d’affectation",
    "ops.notification.title.reminder": "Rappel",
    "ops.notification.title.token": "Alerte token",
    "ops.notifications.cta_deliver": "Livrer",
    "ops.notifications.delivered": "Livrées",
    "ops.notifications.description": "Suivi des envois outbound abonnés et partenaires.",
    "ops.notifications.due": "À livrer",
    "ops.notifications.failed": "Échouées",
    "ops.notifications.failed_devices": "Appareils en erreur",
    "ops.notifications.queue_title": "Files de notifications",
    "ops.notifications.sent": "Envoyées",
    "ops.notifications.title": "Notifications",
    "ops.payments.batch": "Lot",
    "ops.payments.batch_description": "Résumé du lot courant",
    "ops.payments.batch_pending": "Lot en attente",
    "ops.payments.batch_started": "Lot démarré",
    "ops.payments.cta.refund": "Rembourser",
    "ops.payments.cta.retry": "Relancer",
    "ops.payments.cta.start": "Démarrer",
    "ops.payments.description": "Relance, remboursements et lots de versements.",
    "ops.payments.exceptions": "exceptions",
    "ops.payments.failed": "échecs",
    "ops.payments.failed_retry": "Réessayer l’échec",
    "ops.payments.manual_retry": "Relance manuelle",
    "ops.payments.payouts": "Paiements",
    "ops.payments.refunds": "Remboursements",
    "ops.payments.refunds_issued": "Remboursements émis",
    "ops.payments.retry_queued": "Relances en file",
    "ops.payments.title": "Paiements",
    "ops.payout.unavailable.back": "Retour aux paiements",
    "ops.payout.unavailable.body": "Les lots de versements ne peuvent pas être lancés depuis cette console pour le moment. Les montants, les destinataires et les reprises après échec doivent être vérifiés avant d’activer cette action.",
    "ops.payout_error.access_required": "Cette action demande l’accès finance.",
    "ops.payout_error.advance_not_found": "Demande d’avance introuvable.",
    "ops.payout_error.advance_not_open": "Cette demande d’avance n’est plus ouverte : elle a déjà été payée ou refusée.",
    "ops.payout_error.advance_payout_in_progress": "Un paiement de cette avance est en cours ou attend un superviseur : elle ne peut pas être refusée maintenant.",
    "ops.payout_error.amount_mismatch": "Le montant ne correspond pas au paiement attendu.",
    "ops.payout_error.destination_locked": "Un paiement vers son numéro actuel est encore en cours : réglez-le avant de changer de numéro.",
    "ops.payout_error.duplicate_transaction": "Ce numéro de transaction est déjà enregistré : un transfert ne s’enregistre qu’une fois.",
    "ops.payout_error.exceeds_due": "C’est plus que le montant dû : vérifiez ce que vous avez envoyé.",
    "ops.payout_error.idempotency_conflict": "Cet envoi a déjà été traité avec d’autres valeurs.",
    "ops.payout_error.in_flight": "Un paiement est déjà en cours pour ce mois.",
    "ops.payout_error.invalid_account_number": "Numéro invalide : 8 chiffres, avec ou sans +228.",
    "ops.payout_error.invalid_amount": "Montant invalide.",
    "ops.payout_error.invalid_idempotency_key": "Envoi non valide : rechargez la page, puis recommencez.",
    "ops.payout_error.invalid_month": "Mois invalide : utilisez le format AAAA-MM.",
    "ops.payout_error.invalid_provider": "Choisissez Mixx by Yas ou Flooz.",
    "ops.payout_error.invalid_request": "Demande incomplète ou invalide : vérifiez les champs.",
    "ops.payout_error.month_not_closed": "Le mois n’est pas terminé : payez plutôt une avance.",
    "ops.payout_error.no_destination": "Aucun numéro de paiement : elle l’ajoute dans l’application (Paiement).",
    "ops.payout_error.not_found": "Paiement introuvable.",
    "ops.payout_error.not_resolvable": "Ce paiement ne se règle pas ainsi : « payé » demande le numéro de transaction, et seul un résultat inconnu ou bloqué se règle ici.",
    "ops.payout_error.not_voidable": "Seul un paiement payé peut être annulé.",
    "ops.payout_error.outcome_unresolved": "Un paiement précédent a un résultat inconnu : réglez-le d’abord (Paie des laveuses).",
    "ops.payout_error.paid_in_future": "La date du transfert ne peut pas être dans le futur.",
    "ops.payout_error.preview_stale": "Le montant ou le numéro a changé depuis votre lecture : voici le nouveau montant.",
    "ops.payout_error.provider_unavailable": "Le service de paiement est indisponible : rien n’a été envoyé. Réessayez plus tard.",
    "ops.payout_error.reason_required": "Indiquez ce que montre le service de paiement (5 caractères au moins).",
    "ops.payout_error.supervisor_required": "Seul un superviseur peut régler ce paiement.",
    "ops.payout_error.transaction_required": "Le numéro de transaction est obligatoire.",
    "ops.payout_error.worker_not_found": "Laveuse introuvable.",
    "ops.planfit.classification.false_alarm": "Fausse alerte",
    "ops.planfit.classification.label": "Qualification",
    "ops.planfit.classification.other_policy_misuse": "Autre usage non conforme",
    "ops.planfit.confirm_resolve": "Confirmer",
    "ops.planfit.empty": "Aucune revue ouverte",
    "ops.planfit.kicker": "TRIAGE",
    "ops.planfit.link": "Revue d’adéquation",
    "ops.planfit.notes_label": "Notes",
    "ops.planfit.resolution.abuse_recorded": "Abus consigné",
    "ops.planfit.resolution.no_action": "Aucune action",
    "ops.planfit.resolution.plan_updated": "Forfait mis à jour",
    "ops.planfit.resolution.recommended_upgrade": "Recommander un forfait",
    "ops.planfit.resolve_cta": "Enregistrer",
    "ops.planfit.title": "Revue d’adéquation",
    "ops.planfit.trigger.commercial_use": "Usage commercial",
    "ops.planfit.trigger.exceptional_volume": "Volume exceptionnel",
    "ops.planfit.trigger.household_size_mismatch": "Taille du foyer",
    "ops.planfit.trigger.persistent_exceptional_volume": "Volume exceptionnel répété",
    "ops.planfit.trigger.third_party_laundry": "Linge de tiers",
    "ops.privacy.handled": "Traitée",
    "ops.profiles.active": "Actif",
    "ops.profiles.blocklist": "Liste noire",
    "ops.profiles.cs": "SAV",
    "ops.profiles.cta_block": "Ajouter restriction",
    "ops.profiles.cta_subscriber_privacy": "Traiter abonnement",
    "ops.profiles.cta_worker_privacy": "Traiter laveuse",
    "ops.profiles.description": "Gestion des profils",
    "ops.profiles.privacy_title": "Confidentialité",
    "ops.profiles.safety_flags": "Sécurité",
    "ops.profiles.subscriber_desc": "Profil abonné",
    "ops.profiles.subscriber_privacy": "Demande confidentialité",
    "ops.profiles.subscriber_title": "Abonné",
    "ops.profiles.title": "Profils",
    "ops.profiles.worker_desc": "Profil laveuse",
    "ops.profiles.worker_flags": "Alertes",
    "ops.readiness.ready": "Prêt",
    "ops.ready.manual": "Mode manuel",
    "ops.ready.mode": "Mode",
    "ops.referral.action.clear": "Valider",
    "ops.referral.action.reject": "Rejeter",
    "ops.referral.column.action": "Action",
    "ops.referral.column.reason": "Motif du signalement",
    "ops.referral.column.referee": "Filleule",
    "ops.referral.column.referrer": "Marraine",
    "ops.referral.column.status": "Statut",
    "ops.referral.empty": "Aucun parrainage à revoir.",
    "ops.referral.error.load": "Impossible de charger les parrainages.",
    "ops.referral.error.resolve": "Le serveur a refusé la décision.",
    "ops.referral.metrics.active_referrers": "Marraines actives",
    "ops.referral.metrics.active_referrers_hint": "Un plateau de croissance déclenche le passage au payant.",
    "ops.referral.metrics.empty": "Aucun parrainage pour le moment.",
    "ops.referral.metrics.error": "Impossible de charger les indicateurs.",
    "ops.referral.metrics.family_mix": "Part en offre famille",
    "ops.referral.metrics.family_mix_hint": "Atteindre le seuil déclenche le passage au payant.",
    "ops.referral.metrics.family_mix_trigger": "Seuil du déclencheur",
    "ops.referral.metrics.link": "Indicateurs de parrainage",
    "ops.referral.metrics.qualified_rate": "Taux de qualification",
    "ops.referral.metrics.referred_total": "Abonnées parrainées",
    "ops.referral.metrics.status_flagged": "Signalé",
    "ops.referral.metrics.status_pending": "En attente",
    "ops.referral.metrics.status_qualified": "Qualifié",
    "ops.referral.metrics.status_rejected": "Rejeté",
    "ops.referral.metrics.status_rewarded": "Récompensé",
    "ops.referral.metrics.subtitle": "Suivi du déclencheur de passage au mode payant.",
    "ops.referral.metrics.title": "Indicateurs de parrainage",
    "ops.referral.metrics.total": "Parrainages au total",
    "ops.referral.metrics.trigger_reached": "Seuil atteint",
    "ops.referral.metrics.trigger_watching": "En observation",
    "ops.referral.reason.unknown": "Motif non précisé.",
    "ops.referral.reason.velocity_cap": "Plafond d'invitations dépassé sur la période.",
    "ops.referral.resolve.cancel": "Annuler",
    "ops.referral.resolve.confirm": "Confirmer la décision",
    "ops.referral.resolve.confirm_clear": "Valider ce parrainage ?",
    "ops.referral.resolve.confirm_reject": "Rejeter ce parrainage ? Cette décision est définitive.",
    "ops.referral.resolve.notes_label": "Note de décision",
    "ops.referral.resolved.cleared": "Parrainage validé.",
    "ops.referral.resolved.rejected": "Parrainage rejeté.",
    "ops.referral.status.flagged": "À revoir",
    "ops.referral.title": "Parrainages signalés",
    "ops.repassage.action_cancel": "Annuler",
    "ops.repassage.action_decline": "Refuser",
    "ops.repassage.action_offer": "Proposer à un·e étudiant·e",
    "ops.repassage.action_payout": "Enregistrer le paiement",
    "ops.repassage.jobs_tab": "Demandes",
    "ops.repassage.payout_method_auto": "Paiement automatique",
    "ops.repassage.payout_method_manual": "Transfert manuel",
    "ops.repassage.payout_reference": "Référence du transfert",
    "ops.repassage.roster_add": "Ajouter un·e étudiant·e",
    "ops.repassage.roster_momo": "Opérateur Mobile Money",
    "ops.repassage.roster_name": "Nom complet",
    "ops.repassage.roster_neighborhood": "Quartier",
    "ops.repassage.roster_phone": "Téléphone",
    "ops.repassage.roster_status.active": "Actif·ve",
    "ops.repassage.roster_status.pending": "En attente",
    "ops.repassage.roster_status.suspended": "Suspendu·e",
    "ops.repassage.roster_status.trained": "Formé·e",
    "ops.repassage.roster_tab": "Étudiant·e·s",
    "ops.repassage.sms_failed": "SMS non envoyé — réessayer",
    "ops.repassage.title": "Repassage — missions étudiantes",
    "ops.reports.card.active_subscribers": "Abonnés actifs",
    "ops.reports.card.payout_readiness": "Prêt des versements",
    "ops.reports.card.recovery_sla": "Récupération SLA",
    "ops.reports.card.visit_completion": "Taux de réalisation",
    "ops.reports.cta_export": "Exporter",
    "ops.reports.description": "Lecture analytique et export opérationnel.",
    "ops.reports.export.title": "Export",
    "ops.reports.exported_desc": "Export effectué",
    "ops.reports.kpi": "KPI",
    "ops.reports.latest_export": "Dernier export",
    "ops.reports.not_exported": "Pas encore exporté",
    "ops.reports.read_from_data": "Données actualisées",
    "ops.reports.title": "Rapports",
    "ops.route.auth.o_00.kicker": "AUTHENTIFICATION · O-00",
    "ops.route.auth.o_00.title": "Splash",
    "ops.route.auth.o_01.kicker": "CONSOLE BUREAU",
    "ops.route.auth.o_01.title": "Connexion",
    "ops.route.auth.o_01_e1.kicker": "CONNEXION",
    "ops.route.auth.o_01_e1.title": "Trop de tentatives",
    "ops.route.auth.o_01_e2.kicker": "CONNEXION · 2FA",
    "ops.route.auth.o_01_e2.title": "Code incorrect",
    "ops.route.auth.o_01_e3.kicker": "CONNEXION",
    "ops.route.auth.o_01_e3.title": "Accès bloqué",
    "ops.route.auth.o_01_r.kicker": "RÉINITIALISATION",
    "ops.route.auth.o_01_r.title": "Réinitialiser l'accès",
    "ops.route.dashboard.o_02.kicker": "AUJOURD’HUI · O-02",
    "ops.route.dashboard.o_02.title": "Tableau de bord",
    "ops.route.dashboard.o_02_0.kicker": "AUJOURD’HUI · O-02.0",
    "ops.route.dashboard.o_02_0.title": "Tableau de bord · état nuit",
    "ops.route.dashboard.o_04.kicker": "NOTIFICATIONS · O-04",
    "ops.route.dashboard.o_04.title": "Boîte de notifications",
    "ops.route.dashboard.o_04_0.kicker": "AUJOURD’HUI · O-04.0",
    "ops.route.dashboard.o_04_0.title": "Notifications vide",
    "ops.route.dashboard.o_16.kicker": "AUJOURD’HUI · O-16",
    "ops.route.dashboard.o_16.title": "Journal d'audit",
    "ops.route.dashboard.o_16_d.kicker": "AUJOURD’HUI · O-16.D",
    "ops.route.dashboard.o_16_d.title": "Détail événement audit",
    "ops.route.finances.o_13.kicker": "FINANCES · O-13",
    "ops.route.finances.o_13.title": "Paiements",
    "ops.route.finances.o_13_0.kicker": "FINANCES · O-13.0",
    "ops.route.finances.o_13_0.title": "Paiements vide",
    "ops.route.finances.o_13_s.kicker": "FINANCES · O-13.S",
    "ops.route.finances.o_13_s.title": "Suspendre une laveuse",
    "ops.route.finances.o_13_s_c.kicker": "FINANCES · O-13.S.C",
    "ops.route.finances.o_13_s_c.title": "Suspension appliquée",
    "ops.route.finances.o_13_x.kicker": "FINANCES · O-13.X",
    "ops.route.finances.o_13_x.title": "Versements indisponibles",
    "ops.route.finances.o_13_x_c.kicker": "FINANCES · O-13.X.C",
    "ops.route.finances.o_13_x_c.title": "Versements indisponibles",
    "ops.route.finances.o_17.kicker": "FINANCES · O-17",
    "ops.route.finances.o_17.title": "Opérations groupées",
    "ops.route.finances.o_17_c.kicker": "FINANCES · O-17.C",
    "ops.route.finances.o_17_c.title": "Opération groupée appliquée",
    "ops.route.finances.o_18.kicker": "FINANCES · O-18",
    "ops.route.finances.o_18.title": "Exports & rapports",
    "ops.route.live.o_05.kicker": "LIVE OPS · O-05",
    "ops.route.live.o_05.title": "Live Ops",
    "ops.route.live.o_06.kicker": "LIVE OPS · O-06",
    "ops.route.live.o_06.title": "Tiroir visite live",
    "ops.route.live.o_21.kicker": "LIVE OPS · O-21",
    "ops.route.live.o_21.title": "SOS entrant",
    "ops.route.live.o_21_0.kicker": "LIVE OPS · O-21.0",
    "ops.route.live.o_21_0.title": "SOS · aucun incident actif",
    "ops.route.live.o_21_r.kicker": "LIVE OPS · O-21.R",
    "ops.route.live.o_21_r.title": "Rapport de résolution SOS",
    "ops.route.profiles.o_07.kicker": "PROFILS 360° · O-07",
    "ops.route.profiles.o_07.title": "Liste abonnés",
    "ops.route.profiles.o_08.kicker": "PROFILS 360° · O-08",
    "ops.route.profiles.o_08.title": "Profil 360° abonné",
    "ops.route.profiles.o_08_e.kicker": "PROFILS 360° · O-08.E",
    "ops.route.profiles.o_08_e.title": "Modifier abonné",
    "ops.route.profiles.o_08_p.kicker": "PROFILS 360° · O-08.P",
    "ops.route.profiles.o_08_p.title": "Changer de plan abonné",
    "ops.route.profiles.o_09.kicker": "PROFILS 360° · O-09",
    "ops.route.profiles.o_09.title": "Liste laveuses",
    "ops.route.profiles.o_10.kicker": "PROFILS 360° · O-10",
    "ops.route.profiles.o_10.title": "Profil 360° laveuse",
    "ops.route.profiles.o_10_e.kicker": "PROFILS 360° · O-10.E",
    "ops.route.profiles.o_10_e.title": "Modifier laveuse",
    "ops.route.profiles.o_22.kicker": "PROFILS 360° · O-22",
    "ops.route.profiles.o_22.title": "Onboarding laveuse",
    "ops.route.profiles.o_23.kicker": "PROFILS 360° · O-23",
    "ops.route.profiles.o_23.title": "Vérification abonnée",
    "ops.route.support.o_11.kicker": "SUPPORT · O-11",
    "ops.route.support.o_11.title": "Tickets",
    "ops.route.support.o_11_0.kicker": "SUPPORT · O-11.0",
    "ops.route.support.o_11_0.title": "Tickets vide",
    "ops.route.support.o_11_d.kicker": "SUPPORT · O-11.D",
    "ops.route.support.o_11_d.title": "Ticket détail",
    "ops.route.support.o_12_g.kicker": "SUPPORT · O-12.G",
    "ops.route.support.o_12_g.title": "Crédit goodwill",
    "ops.route.system.o_19.kicker": "SYSTÈME · O-19",
    "ops.route.system.o_19.title": "Réglages opérateur",
    "ops.route.system.o_19_2.kicker": "SYSTÈME · O-19.2",
    "ops.route.system.o_19_2.title": "Réinitialiser 2FA",
    "ops.route.system.o_19_d.kicker": "SYSTÈME · O-19.D",
    "ops.route.system.o_19_d.title": "Sessions actives",
    "ops.route.system.o_19_p.kicker": "SYSTÈME · O-19.P",
    "ops.route.system.o_19_p.title": "Modifier mot de passe",
    "ops.route.system_states.o_x_a.kicker": "ÉTAT SYSTÈME · O-X.A",
    "ops.route.system_states.o_x_a.title": "Compte archivé",
    "ops.route.system_states.o_x_c.kicker": "ÉTAT SYSTÈME · O-X.C",
    "ops.route.system_states.o_x_c.title": "Connexion perdue",
    "ops.route.system_states.o_x_m.kicker": "ÉTAT SYSTÈME · O-X.M",
    "ops.route.system_states.o_x_m.title": "Système en maintenance",
    "ops.route.system_states.o_x_rj.kicker": "ÉTAT SYSTÈME · O-X.RJ",
    "ops.route.system_states.o_x_rj.title": "Demande rejetée",
    "ops.route.system_states.o_x_s.kicker": "ÉTAT SYSTÈME · O-X.S",
    "ops.route.system_states.o_x_s.title": "Vous êtes déconnecté",
    "ops.route.system_states.o_x_w.kicker": "ÉTAT SYSTÈME · O-X.W",
    "ops.route.system_states.o_x_w.title": "En attente d'approbation",
    "ops.route.triage.o_03.kicker": "TRIAGE · O-03",
    "ops.route.triage.o_03.title": "Matching",
    "ops.route.triage.o_14.kicker": "TRIAGE · O-14",
    "ops.route.triage.o_14.title": "File d’assignations",
    "ops.route.triage.o_15.kicker": "TRIAGE · O-15",
    "ops.route.triage.o_15.title": "Gestion d’annulation",
    "ops.route.triage.o_20.kicker": "TRIAGE · O-20",
    "ops.route.triage.o_20.title": "Palette de commandes",
    "ops.route.triage.o_24.kicker": "TRIAGE",
    "ops.route.triage.o_24.title": "Lavages supplémentaires",
    "ops.route_planning.approved": "Validées",
    "ops.route_planning.cta_acknowledge": "Reconnaître",
    "ops.route_planning.cta_approve": "Approuver",
    "ops.route_planning.description": "Ajuster la planification quotidienne.",
    "ops.route_planning.title": "Planification",
    "ops.routes.total": "routes",
    "ops.section.dashboard.label": "Tableau de bord",
    "ops.section.finances.label": "Finances",
    "ops.section.live.label": "Direct",
    "ops.section.profiles.label": "Profils",
    "ops.section.support.label": "Assistance",
    "ops.section.system.label": "Système",
    "ops.section.triage.label": "Triage",
    "ops.settings.checks_label": "Checks",
    "ops.settings.cta_check": "Vérifier",
    "ops.settings.cta_toggle": "Basculer",
    "ops.settings.description": "Contrôle opérationnel du centre d’exploitation.",
    "ops.settings.failed_payouts": "Versements échoués",
    "ops.settings.features_desc": "Options disponibles",
    "ops.settings.features_label": "Fonctionnalités",
    "ops.settings.forced": "FORCED",
    "ops.settings.last_checked": "Dernière vérification",
    "ops.settings.normal": "PRÊT",
    "ops.settings.readiness_checks": "Vérifications readiness",
    "ops.settings.readiness_panel": "Centre readiness",
    "ops.settings.title": "Paramètres",
    "ops.sos.active.kicker": "SOS · INCIDENT ACTIF",
    "ops.sos.active.lede": "Action immédiate requise. Appelez d'abord la laveuse, puis la cliente si une visite est liée.",
    "ops.sos.active.title_many": "{count} alertes de sécurité ouvertes",
    "ops.sos.active.title_one": "1 alerte de sécurité ouverte",
    "ops.sos.call_subscriber": "Appeler la cliente",
    "ops.sos.call_worker": "Appeler la laveuse",
    "ops.sos.contact_subscriber_unavailable": "Numéro de la cliente indisponible",
    "ops.sos.contact_worker_unavailable": "Numéro de la laveuse indisponible",
    "ops.sos.empty.back": "Retour au live ops →",
    "ops.sos.empty.body": "Aucun SOS actif. Le bureau peut se concentrer sur les visites en cours.",
    "ops.sos.gps": "GPS {lat}, {lng} · précision ±{accuracy} m",
    "ops.sos.gps_unknown": "Position inconnue — appelez la laveuse pour savoir où elle est.",
    "ops.sos.load_error": "Impossible de charger les alertes SOS. Réessayez immédiatement.",
    "ops.sos.loading": "Chargement des alertes SOS…",
    "ops.sos.opened": "Déclenché {time}",
    "ops.sos.reason.client_issue": "Incident avec la cliente",
    "ops.sos.reason.danger": "Danger ou menace immédiate",
    "ops.sos.reason.medical": "Urgence médicale",
    "ops.sos.resolution.category": "Résultat de l'intervention",
    "ops.sos.resolution.error": "La résolution n'a pas été enregistrée. Vérifiez l'incident et réessayez.",
    "ops.sos.resolution.incident": "Incident SOS {id}",
    "ops.sos.resolution.notes": "Rapport factuel pour l'audit",
    "ops.sos.resolution.notes_placeholder": "Décrivez les appels, les actions prises et la situation finale.",
    "ops.sos.resolution.option.emergency_services_contacted": "Services d'urgence contactés",
    "ops.sos.resolution.option.false_alarm": "Fausse alerte confirmée",
    "ops.sos.resolution.option.follow_up_required": "Suivi du bureau requis",
    "ops.sos.resolution.option.worker_safe": "Laveuse jointe et en sécurité",
    "ops.sos.resolution.submit": "Enregistrer et clore l'incident",
    "ops.sos.resolution.submitting": "Enregistrement…",
    "ops.sos.resolve": "Envoyer des secours ou résoudre",
    "ops.sos.subscription": "Abonnement {id}",
    "ops.sos.view_gps": "Voir la position GPS",
    "ops.sponsor_pay.maintenance.body": "Expire les liens sponsor arrivés à terme et les périodes de grâce dont le délai est dépassé.",
    "ops.sponsor_pay.maintenance.cta": "Lancer la maintenance",
    "ops.sponsor_pay.maintenance.error": "Échec — le serveur a refusé la maintenance Sponsor Pay.",
    "ops.sponsor_pay.maintenance.result": "{inviteCount} lien(s) expiré(s), {graceCount} période(s) de grâce clôturée(s).",
    "ops.sponsor_pay.maintenance.running": "Maintenance en cours…",
    "ops.sponsor_pay.maintenance.title": "Sponsor Pay — maintenance",
    "ops.status.confirmed": "Confirmé",
    "ops.status.proposal_sent": "Proposition envoyée",
    "ops.status.unassigned": "Non attribué",
    "ops.suspension.confirmation.body": "Le compte de la laveuse est bloqué et la suspension est inscrite au journal d’audit.",
    "ops.suspension.confirmation.cta": "Retour aux paiements",
    "ops.suspension.confirmation.title": "Compte bloqué",
    "ops.suspension.cta": "Suspendre",
    "ops.suspension.duration_label": "Durée (jours)",
    "ops.suspension.error": "Échec — la suspension n’a pas été appliquée.",
    "ops.suspension.reason_label": "Raison",
    "ops.suspension.title": "Détails de la suspension",
    "ops.suspension.warning": "Action punitive — le compte sera bloqué et l’audit est immuable.",
    "ops.suspension.worker_id_label": "Identifiant de la laveuse",
    "ops.table.neighborhood": "Quartier",
    "ops.table.open": "Action",
    "ops.table.sla": "SLA",
    "ops.table.state": "État",
    "ops.table.subscriber": "Abonné",
    "ops.table.time": "Horaire",
    "ops.table.worker": "Laveuse",
    "ops.tickets.action.goodwill": "Crédit goodwill ({amount} XOF)",
    "ops.tickets.empty": "Aucun ticket ouvert.",
    "ops.tickets.policy.label": "Politique",
    "ops.tickets.priority.high": "HAUTE",
    "ops.tickets.priority.normal": "NORMALE",
    "ops.tickets.title": "Tickets",
    "ops.unassigned.label": "Non affecté",
    "ops.worker_directory.absence_filter": "Absence enregistrée aujourd’hui",
    "ops.worker_directory.absence_not_recorded": "Aucune absence enregistrée",
    "ops.worker_directory.absence_recorded": "Absence enregistrée",
    "ops.worker_directory.all_statuses": "Tous les statuts",
    "ops.worker_directory.any": "Tous",
    "ops.worker_directory.apply": "Rechercher",
    "ops.worker_directory.at_capacity": "Capacité atteinte",
    "ops.worker_directory.availability_note": "Aucune absence enregistrée ne confirme pas la disponibilité pour une mission. Vérifiez le planning avant toute attribution.",
    "ops.worker_directory.below_capacity": "Sous la capacité",
    "ops.worker_directory.capacity_filter": "Capacité d’abonnements",
    "ops.worker_directory.clear": "Effacer",
    "ops.worker_directory.empty": "Aucune laveuse ne correspond à ces filtres.",
    "ops.worker_directory.issue_filter": "Signalements ouverts",
    "ops.worker_directory.load_error": "Impossible de charger les laveuses.",
    "ops.worker_directory.loading": "Chargement des laveuses…",
    "ops.worker_directory.more_filters": "Plus de filtres",
    "ops.worker_directory.neighborhood": "Quartier desservi",
    "ops.worker_directory.next": "Suivant",
    "ops.worker_directory.no_neighborhood": "Quartiers non renseignés",
    "ops.worker_directory.open_issues": "Signalements ouverts : {count}",
    "ops.worker_directory.page": "Page {count}",
    "ops.worker_directory.pages": "Pages des laveuses",
    "ops.worker_directory.previous": "Précédent",
    "ops.worker_directory.retry": "Réessayer",
    "ops.worker_directory.search": "Nom ou identifiant",
    "ops.worker_directory.status": "Statut",
    "ops.worker_directory.status.active": "Active",
    "ops.worker_directory.status.applicant": "Candidate",
    "ops.worker_directory.status.inactive": "Inactive",
    "ops.worker_directory.status.onboarding": "En intégration",
    "ops.worker_directory.status.suspended": "Suspendue",
    "ops.worker_directory.with_open_issue": "Avec signalement",
    "ops.worker_directory.without_open_issue": "Sans signalement",
    "ops.worker_directory.workload": "Foyers actifs",
    "ops.worker_edit.display_name": "Nom affiché",
    "ops.worker_edit.form_title": "Corriger le nom affiché",
    "ops.worker_edit.load_error": "Impossible de charger ce profil. Réessayez.",
    "ops.worker_edit.loading": "Chargement du profil…",
    "ops.worker_edit.save": "Enregistrer",
    "ops.worker_edit.save_error": "La correction n’a pas été enregistrée. Réessayez.",
    "ops.worker_edit.scope_note": "Cette correction ne change ni le statut, ni la capacité, ni les quartiers desservis.",
    "ops.worker_overview.activity": "Activité récente",
    "ops.worker_overview.activity_empty": "Aucune activité récente enregistrée.",
    "ops.worker_overview.activity_error": "Impossible de charger l’activité récente.",
    "ops.worker_overview.activity_loading": "Chargement de l’activité…",
    "ops.worker_overview.back": "← Liste des laveuses",
    "ops.worker_overview.correct_name": "Corriger le nom",
    "ops.worker_overview.eligibility_note": "Cette vue ne détermine pas l’éligibilité à une affectation. Aucune absence enregistrée ne prouve la disponibilité ; les signalements ne sont pas des dossiers Case.",
    "ops.worker_overview.expiry_unrecorded": "Aucune date de fin enregistrée.",
    "ops.worker_overview.invalid_link": "Ce lien de laveuse est invalide. Ouvrez le profil depuis la liste.",
    "ops.worker_overview.load_error": "Impossible de charger cette laveuse.",
    "ops.worker_overview.loading": "Chargement de la laveuse…",
    "ops.worker_overview.market": "Marché · Togo",
    "ops.worker_overview.no_worker": "Ouvrez une laveuse depuis la liste.",
    "ops.worker_overview.not_found": "Cette laveuse est introuvable sur ce marché.",
    "ops.worker_overview.open_reports": "Signalements de laveuse non résolus",
    "ops.worker_overview.recorded_absence": "Absence du {date}",
    "ops.worker_overview.suspended": "Statut : suspendue",
    "ops.worker_overview.suspension_until": "Fin enregistrée : {date}",
    "ops.worker_overview.workload": "Abonnements actifs / capacité",
    "ops.worker_overview.zones": "Quartiers desservis",
    "partner.ACTIVE": "Actif",
    "partner.ATTRIBUTED": "Inscription enregistrée",
    "partner.CANCELLED": "Commission annulée",
    "partner.HELD": "En vérification",
    "partner.HELD_FIRST_SERVICE_ISSUE": "Lavage à résoudre",
    "partner.INVITED": "Invité",
    "partner.PAID": "Commission versée",
    "partner.PAYABLE": "Commission acquise",
    "partner.PENDING_RETENTION": "Renouvellement attendu",
    "partner.QUALIFIED_PENDING_REVIEW": "Vérification en cours",
    "partner.REJECTED": "Non éligible",
    "partner.REWARDED": "Premier lavage validé",
    "partner.SUSPENDED": "Suspendu",
    "partner.accept": "Accepter les conditions et activer mon code",
    "partner.active": "Abonnements actifs",
    "partner.activeHelp": "Le foyer dispose actuellement d’un abonnement actif.",
    "partner.activityIntro": "Des références anonymes pour suivre chaque recommandation. Les coordonnées des foyers restent privées.",
    "partner.allActivity": "Voir tous les parrainages",
    "partner.allTime": "Depuis votre arrivée",
    "partner.ambassador": "Ambassadrice",
    "partner.amount": "Commission",
    "partner.amountXof": "Montant versé (XOF)",
    "partner.apply": "Appliquer",
    "partner.attributed": "Foyers recommandés",
    "partner.attributedHelp": "Un code enregistré sur un nouveau foyer avant son premier paiement.",
    "partner.back": "Retour aux partenaires",
    "partner.balanceNote": "Soldes sur toute la durée du programme. Les montants en attente ne sont pas encore acquis.",
    "partner.boundaryFailed": "Cette page n’a pas pu s’afficher.",
    "partner.boundaryKeep": "Rechargez pour continuer ; vous restez connecté.",
    "partner.boundaryUpdated": "L’espace créateur a été mis à jour pendant que cet onglet était ouvert.",
    "partner.budget": "Budget du programme",
    "partner.budgetIntro": "Signal indicatif uniquement : aucun arrêt automatique des approbations ou des commissions acquises.",
    "partner.changeEmail": "Utiliser une autre adresse",
    "partner.chartTable": "Voir les chiffres par jour",
    "partner.code": "Votre code personnel",
    "partner.codeChangeEndNow": "Arrêter l’ancien code tout de suite (code abusif ou trompeur)",
    "partner.codeChangeIntro": "À la demande du créateur, ou si son code induit en erreur. Les foyers déjà enregistrés gardent leur créateur. Sauf arrêt immédiat, l’ancien code fonctionne encore 90 jours.",
    "partner.codeChangeNew": "Nouveau code, sans INF-",
    "partner.codeChangeSubmit": "Changer le code",
    "partner.codeChangeTitle": "Changer le code du créateur",
    "partner.codeIntro": "Si cette adresse est invitée, un code à 6 chiffres vient d’y être envoyé. Il expire dans 10 minutes.",
    "partner.codeInvalid": "Ce code ne fonctionne pas. Vérifiez-le ou demandez un nouveau code.",
    "partner.codeLabel": "Code à 6 chiffres",
    "partner.codeTitle": "Saisissez votre code",
    "partner.cohort": "Parcours des foyers",
    "partner.confirm": "Ouvrir mon espace",
    "partner.contactPending": "Conservez ce code. Le lien WhatsApp sera disponible dès que le bureau aura confirmé son numéro de contact.",
    "partner.conversion": "Du premier contact au renouvellement",
    "partner.conversionFootnote": "Chaque premier abonnement intégralement payé et vérifié donne droit à une commission. Les lavages et renouvellements sont suivis à titre informatif.",
    "partner.conversionNote": "Foyers attribués pendant la période sélectionnée, selon leur situation actuelle.",
    "partner.conversionRate": "ont payé un premier cycle",
    "partner.copied": "Copié",
    "partner.copy": "Copier le lien",
    "partner.copyCode": "Copier le code",
    "partner.cost": "Primes, crédits et réductions du programme",
    "partner.creator": "Créateur",
    "partner.creatorAccessOnly": "Cet espace est réservé aux créateurs et influenceurs. Pour votre code ami de client, contactez le bureau WASHED.",
    "partner.custom": "Dates personnalisées",
    "partner.customAMBIGUOUS_CHARACTERS": "Les chiffres 0 et 1 ne sont pas acceptés : on les confond avec O et I.",
    "partner.customAvailable": "Disponible",
    "partner.customCURRENT": "C’est déjà votre code.",
    "partner.customChecking": "Vérification…",
    "partner.customDone": "Votre nouveau code est actif. Partagez désormais ce code et ce lien.",
    "partner.customHint": "3 à 12 lettres ou chiffres, en commençant par une lettre. Les chiffres 0 et 1 ne sont pas acceptés : on les confond avec O et I. Un seul changement tous les 30 jours.",
    "partner.customINVALID_CHARACTERS": "Lettres A à Z et chiffres 2 à 9 uniquement, sans espace ni symbole.",
    "partner.customIntro": "Choisissez un code facile à dire et à écrire, comme INF-AMA ou INF-KOFI228. Les foyers déjà enregistrés restent à vous. Votre code actuel continue de fonctionner 90 jours après le changement, puis il n’est plus accepté mais n’est jamais donné à quelqu’un d’autre.",
    "partner.customLabel": "Votre nouveau code",
    "partner.customMUST_START_WITH_LETTER": "Le code doit commencer par une lettre.",
    "partner.customPreview": "Votre code sera",
    "partner.customPrevious": "Ancien code",
    "partner.customPreviousUntil": "fonctionne encore jusqu’au",
    "partner.customRESERVED": "Ce code n’est pas autorisé. Choisissez-en un autre.",
    "partner.customSubmit": "Utiliser ce code",
    "partner.customTAKEN": "Ce code est déjà pris. Essayez une variante, par exemple avec des chiffres.",
    "partner.customTOO_LONG": "12 caractères au maximum après INF-.",
    "partner.customTOO_SHORT": "Au moins 3 caractères après INF-.",
    "partner.customTitle": "Personnaliser mon code",
    "partner.customTooSoon": "Prochain changement possible le",
    "partner.customUnavailable": "Ce code ne peut pas être personnalisé. Contactez le bureau WASHED.",
    "partner.dashboardIntro": "Vos parrainages, vos commissions et vos paiements, au même endroit.",
    "partner.date": "Date d’attribution",
    "partner.demo": "Aperçu · données fictives",
    "partner.demoEmpty": "Vide",
    "partner.demoNormal": "Exemple",
    "partner.demoWorst": "Cas limites",
    "partner.destination": "Destination du paiement",
    "partner.earned": "Commissions acquises",
    "partner.earnedInPeriod": "Acquis pendant la période",
    "partner.earnings": "Revenus",
    "partner.earningsHistory": "L’évolution de vos commissions",
    "partner.earningsIntro": "Suivez vos commissions acquises et vos versements.",
    "partner.email": "Adresse e-mail",
    "partner.emailChangeIntro": "Pour un partenaire qui n’a plus accès à son adresse. Son code, ses parrainages et ses commissions ne changent pas. Ses sessions ouvertes se ferment, l’ancienne adresse est prévenue et la nouvelle reçoit l’e-mail d’invitation.",
    "partner.emailChangeSubmit": "Changer l’adresse",
    "partner.emailChangeTitle": "Changer l’adresse de connexion",
    "partner.emailChangedSilent": "Adresse changée, mais aucun e-mail n’a pu être envoyé. Prévenez le partenaire vous-même.",
    "partner.emailInUse": "Un autre partenaire se connecte déjà avec cette adresse.",
    "partner.emailUnchanged": "Le partenaire se connecte déjà avec cette adresse.",
    "partner.error": "Nous n’avons pas pu terminer cette action. Réessayez.",
    "partner.evidence": "Justificatif du paiement",
    "partner.fee": "Frais réels (XOF)",
    "partner.from": "Du",
    "partner.held": "En cours de vérification",
    "partner.hello": "Bonjour",
    "partner.householdId": "Identifiant du foyer (ambassadrice)",
    "partner.inspect": "Consulter",
    "partner.intro": "Suivez les foyers que vous avez orientés vers WASHED, leur parcours et vos commissions.",
    "partner.invite": "Approuver et inviter",
    "partner.join": "Commencer sur WhatsApp",
    "partner.kind": "Type de partenaire",
    "partner.landing": "Votre code de parrainage WASHED",
    "partner.landingBody": "Conservez ce code et transmettez-le à WASHED avant votre premier paiement pour enregistrer votre parrainage.",
    "partner.last30": "30 derniers jours",
    "partner.last90": "90 derniers jours",
    "partner.loading": "Chargement de votre espace…",
    "partner.loginIntro": "Saisissez l’adresse e-mail invitée par WASHED. Nous vous enverrons un code à 6 chiffres, valable 10 minutes.",
    "partner.loginTitle": "Votre espace créateur",
    "partner.logout": "Se déconnecter",
    "partner.name": "Nom affiché",
    "partner.newEmail": "Nouvelle adresse e-mail",
    "partner.next": "Suivant",
    "partner.noActivity": "L’activité apparaîtra après vos premiers parrainages.",
    "partner.noPayouts": "Aucun paiement enregistré pour le moment.",
    "partner.noReferrals": "Pas encore de parrainage",
    "partner.noReferralsBody": "Partagez votre lien. Un foyer apparaîtra ici une fois votre code enregistré pendant son inscription.",
    "partner.ofReferred": "des foyers recommandés",
    "partner.operatorPerformance": "La performance de vos partenaires",
    "partner.opsEmpty": "Aucun partenaire invité.",
    "partner.opsIntro": "Invitez les créateurs, vérifiez les parrainages et enregistrez les paiements mobile money.",
    "partner.opsTitle": "Partenaires et commissions",
    "partner.overview": "Résumé",
    "partner.page": "Page",
    "partner.paid": "Premier cycle payé",
    "partner.paidHelp": "Au moins un abonnement intégralement payé, avec paiement vérifié.",
    "partner.paidOn": "Date du paiement",
    "partner.paidOut": "Déjà versés",
    "partner.partnerStatus": "Statut du partenaire",
    "partner.partnersActive": "Partenaires actifs",
    "partner.partnersCount": "Partenaires inscrits",
    "partner.passkeyAddFailed": "L’activation n’a pas abouti. Réessayez plus tard.",
    "partner.passkeyEnable": "Activer l’empreinte ou Face ID",
    "partner.passkeyEnabled": "Connexion par empreinte ou Face ID activée",
    "partner.passkeyFailed": "La connexion par empreinte ou Face ID n’a pas abouti. Utilisez votre adresse e-mail.",
    "partner.passkeyLater": "Plus tard",
    "partner.passkeyOfferBody": "La prochaine fois, connectez-vous avec l’empreinte ou Face ID de ce téléphone, sans code par e-mail.",
    "partner.passkeyOfferTitle": "Connexion plus rapide",
    "partner.passkeyRemove": "Désactiver",
    "partner.passkeySignIn": "Se connecter avec l’empreinte ou Face ID",
    "partner.payable": "À vous verser",
    "partner.paymentsInPeriod": "Versés pendant la période",
    "partner.payout": "Enregistrer un paiement effectué",
    "partner.payoutNote": "Les paiements sont enregistrés par le bureau après leur envoi par mobile money.",
    "partner.payouts": "Historique des paiements",
    "partner.pending": "En attente de renouvellement",
    "partner.performance": "L’activité de vos parrainages",
    "partner.performanceNote": "Attributions et étapes de paiement enregistrées pendant la période sélectionnée.",
    "partner.performanceUnavailable": "Aucune activité pour cette période.",
    "partner.period": "Période",
    "partner.policy": "Version des conditions",
    "partner.portal": "Espace créateur",
    "partner.previous": "Précédent",
    "partner.programPayable": "Commissions à verser",
    "partner.provider": "Service",
    "partner.qualified": "Premier lavage validé",
    "partner.qualifiedHelp": "Un premier lavage terminé, sans problème matériel ouvert, après 48 heures.",
    "partner.rateLimited": "Trop de tentatives. Patientez 15 minutes avant de réessayer.",
    "partner.ratio": "Part des revenus",
    "partner.readyToShare": "Partagez votre code",
    "partner.reason": "Motif de la décision",
    "partner.recent": "Le parcours de vos parrainages",
    "partner.reference": "Référence",
    "partner.referrals": "Parrainages",
    "partner.refresh": "Actualiser",
    "partner.reload": "Recharger",
    "partner.resend": "Recevoir un nouveau code",
    "partner.resent": "Si cette adresse est invitée, un nouveau code vient d’y être envoyé.",
    "partner.retained": "Deuxième cycle payé",
    "partner.retainedHelp": "Au moins deux cycles distincts activés avec paiement vérifié.",
    "partner.retentionRate": "ont payé un deuxième cycle",
    "partner.retry": "Réessayer",
    "partner.revenue": "Revenus des cycles vérifiés",
    "partner.reviewsNeeded": "Vérifications à effectuer",
    "partner.savePayout": "Confirmer le paiement effectué",
    "partner.sendCode": "Recevoir mon code",
    "partner.sendInvite": "Envoyer l’e-mail d’invitation",
    "partner.share": "Mon lien",
    "partner.shareHint": "Chaque foyer qui donne ce code avant son premier paiement vous est rattaché.",
    "partner.shareIntro": "Votre lien accompagne votre code jusqu’à l’inscription. Une visite du lien seule ne compte pas comme un parrainage.",
    "partner.shareTitle": "Partagez votre lien",
    "partner.status": "Étape",
    "partner.success": "Action enregistrée.",
    "partner.suspend": "Suspendre les nouveaux parrainages",
    "partner.terms": "Vos conditions",
    "partner.termsBody": "Vous recevez 1 000 F une seule fois par foyer recommandé, après son premier lavage validé et l’activation de son deuxième cycle payé. Le foyer reçoit 500 F de crédit promotionnel après validation du premier lavage. Les paiements sont effectués manuellement par mobile money.",
    "partner.termsCreatorBody": "Vous recevez 2 000 F une seule fois par foyer recommandé (1 500 F si son premier mois est un Solo 1× ou un Duo 1×), dès que le paiement intégral de son premier abonnement est vérifié. Aucun premier lavage ni deuxième paiement n’est requis pour acquérir cette commission. Le foyer recommandé paie moins cher son premier mois : 500 F de moins en Solo 2×, 1 000 F en Duo 2× et 1 500 F en Foyer 2× ; les formules 1× sont au prix normal. Il ne reçoit pas de crédit de parrainage. Les versements sont effectués manuellement par mobile money et sont suivis séparément des commissions acquises.",
    "partner.termsCreatorLegacyBody": "Vous recevez 2 000 F une seule fois par foyer recommandé, dès que le paiement intégral de son premier abonnement est vérifié. Aucun premier lavage ni deuxième paiement n’est requis pour acquérir cette commission. Le foyer recommandé paie moins cher son premier mois : 500 F de moins en Solo 1×, 1 000 F en Duo 1×, 1 500 F en Solo 2× et en Foyer 1×, 2 000 F en Duo 2×, 3 000 F en Foyer 2×. Il ne reçoit pas de crédit de parrainage. Les versements sont effectués manuellement par mobile money et sont suivis séparément des commissions acquises.",
    "partner.termsTitle": "Bienvenue parmi les partenaires WASHED",
    "partner.to": "Au",
    "partner.updated": "Actualisé à",
    "partner.volumeReview": "Plus de 10 commissions ce mois-ci : vérification du volume à effectuer. Ce signal ne plafonne pas les revenus.",
    "partner.welcome": "Chaque recommandation compte.",
    "partner.yourEarnings": "Vos commissions",
    "pricing.tiers.d1": "Duo 1×",
    "pricing.tiers.d2": "Duo 2×",
    "pricing.tiers.f1": "Foyer 1×",
    "pricing.tiers.f2": "Foyer 2×",
    "pricing.tiers.fc": "Foyer 2×",
    "pricing.tiers.fe": "Foyer 1×",
    "pricing.tiers.s1": "Solo 1×",
    "pricing.tiers.s2": "Solo 2×",
    "pricing.tiers.t1": "Solo 1×",
    "pricing.tiers.t2": "Solo 2×",
    "push.ops.sla_breach": "SLA dépassé · {client} {time} non assignée.",
    "push.ops.sos": "🆘 SOS — {worker} chez {client}, {neighborhood}",
    "push.sub.visit_done": "Visite terminée. Voilà ce que ça donne.",
    "push.sub.visit_started": "{name} a commencé la visite.",
    "push.sub.visit_today": "{name} arrive aujourd'hui à {time}.",
    "push.sub.visit_tomorrow": "{name} arrive demain à {time}.",
    "push.sub.worker_enroute": "{name} est en route.",
    "push.work.assignment": "Nouvelle visite proposée : {time} chez {name} ({neighborhood}).",
    "push.work.assignment.expires": "Acceptez avant {time} sinon réassignée.",
    "push.work.payout_received": "+ {amount} XOF reçus sur {provider}.",
    "series.lacour.akouvi_door": "Le seau est prêt ?",
    "series.lacour.assistant_paid": "Votre paiement de {amount} est bien enregistré : c’est confirmé pour {day} {window}. Merci !",
    "series.lacour.dots": "…",
    "series.lacour.fil_rewind": "On rembobine.",
    "series.lacour.fil_stop": "On s’arrête une seconde.",
    "series.lacour.gardienne_line": "Je veille.",
    "series.lacour.group": "La Cour",
    "series.lacour.komla_line": "De mon temps, on lavait soi-même.",
    "series.lacour.komla_line_cut": "De mon temps…",
    "series.lacour.label": "La Cour · S{season}·E{episode}",
    "series.lacour.name.akossiwa": "Maman Akossiwa",
    "series.lacour.name.akouvi": "Akouvi",
    "series.lacour.name.amivi": "Amivi",
    "series.lacour.name.edem": "Edem",
    "series.lacour.name.komla": "Tonton Komla",
    "series.lacour.name.kossi": "Kossi",
    "series.lacour.name.sena": "Sena",
    "series.lacour.panier_line": "Eau, savon, seau !",
    "series.lacour.price_from": "Dès {price} / mois",
    "series.lacour.price_month": "{price} / mois",
    "series.lacour.typing": "{name} est en train d’écrire…",
    "series.s0e1.akossiwa_ask": "Demande à Akouvi.",
    "series.s0e1.caption_arrived": "Tonton Komla est arrivé il y a trois semaines.",
    "series.s0e1.caption_basins": "Et personne n’a touché une bassine.",
    "series.s0e1.caption_cour": "Une cour à Lomé. Une semaine.",
    "series.s0e1.caption_line": "Le fil n’a jamais été vide.",
    "series.s0e1.caption_questions": "Il pose beaucoup de questions.",
    "series.s0e1.end_line": "Une laveuse vérifiée, chez vous.",
    "series.s0e1.fil_hold": "Je tiens le linge de toute la cour.",
    "series.s0e1.fil_intro": "Moi, c’est le fil.",
    "series.s0e1.komla_akouvi": "C’est qui, Akouvi ?",
    "series.s0e1.komla_who": "Toute la semaine, le fil était plein. Qui a lavé ?",
    "series.s0e1.not_me": "Pas moi.",
    "series.s0e1.not_us": "Pas nous.",
    "series.s0e1.teaser": "Qui est Akouvi ? Partie 2 demain.",
    "series.s0e2.amivi_akouvi": "Akouvi est venue.",
    "series.s0e2.amivi_baptism": "Baptême. J’y suis passée cinq minutes.",
    "series.s0e2.amivi_not_me": "Je n’ai pas lavé, Tonton.",
    "series.s0e2.caption_part": "Partie 2 · Porte 1",
    "series.s0e2.caption_sundays": "Le mois dernier. Ses dimanches étaient déjà pleins.",
    "series.s0e2.caption_three_hours": "(Trois heures.)",
    "series.s0e2.caption_tuesday": "Mardi matin, chez elle. Avec son eau et son savon.",
    "series.s0e2.caption_whatsapp": "Une visite par mois. Le jour qu’elle a choisi.",
    "series.s0e2.end_line": "Solo : une personne, une laveuse.",
    "series.s0e2.komla_by_itself": "Le linge s’est lavé tout seul ?",
    "series.s0e2.komla_sunday": "Et dimanche, tu faisais quoi ?",
    "series.s0e2.komla_tuesday": "Mardi, ton linge était sur le fil. Tu as lavé quand ?",
    "series.s0e2.msg_choice": "Un passage, le mardi matin.",
    "series.s0e2.msg_hello": "Bonjour, je vis seule et mes dimanches sont pleins.",
    "series.s0e2.msg_paid": "C’est réglé, par Mixx by Yas.",
    "series.s0e2.teaser": "Partie 3 demain.",
    "series.s0e3.akouvi": "C’est Akouvi.",
    "series.s0e3.caption_duo": "Ils ont pris Duo. Et ils partagent.",
    "series.s0e3.caption_hers": "Le travail est le sien.",
    "series.s0e3.caption_part": "Partie 3 · Porte 3",
    "series.s0e3.caption_rewind": "Il y a deux mois, Porte 3.",
    "series.s0e3.caption_saturday": "Samedi, 7 h 50.",
    "series.s0e3.caption_yours": "L’eau et le savon sont les vôtres.",
    "series.s0e3.edem_going": "J’y vais.",
    "series.s0e3.edem_no": "Surtout pas.",
    "series.s0e3.edem_peace": "Et on ne se dispute plus.",
    "series.s0e3.end_line": "Duo : le linge à deux.",
    "series.s0e3.fight_counts": "Ça compte.",
    "series.s0e3.fight_dishes": "J’ai fait la vaisselle.",
    "series.s0e3.fight_name": "Edem.",
    "series.s0e3.fight_turn": "C’est ton tour.",
    "series.s0e3.fight_when": "Mardi dernier.",
    "series.s0e3.komla_pay": "Vous payez une femme pour laver ?",
    "series.s0e3.komla_who": "C’est Sena qui lave chez vous ?",
    "series.s0e3.sena_almost": "Presque plus.",
    "series.s0e3.sena_no": "Ni lui.",
    "series.s0e3.sena_soap": "Edem. Le savon.",
    "series.s0e3.sena_sub": "On paie l’abonnement. Avant la visite.",
    "series.s0e3.tag_bucket": "Seau",
    "series.s0e3.tag_duo": "Duo · 2 personnes",
    "series.s0e3.tag_shop": "Boutique",
    "series.s0e3.tag_soap": "Savon",
    "series.s0e3.tag_water": "Eau",
    "series.s0e3.teaser": "Partie 4 demain.",
    "series.s0e4.akossiwa_akouvi": "Akouvi. Deux jeudis par mois.",
    "series.s0e4.akossiwa_nap": "Tu fais la sieste à 9 h, Tonton.",
    "series.s0e4.akossiwa_not_stranger": "Ce n’est pas une inconnue. C’est Akouvi.",
    "series.s0e4.akossiwa_yes": "Oui, Tonton.",
    "series.s0e4.caption_family": "Une famille de cinq. Un seul samedi.",
    "series.s0e4.caption_foyer": "Alors : Foyer, deux visites par mois.",
    "series.s0e4.caption_next_room": "Depuis la pièce d’à côté.",
    "series.s0e4.caption_returns": "Et c’est elle qui revient.",
    "series.s0e4.caption_vetted": "Chaque laveuse est vérifiée avant sa première visite.",
    "series.s0e4.end_line": "Foyer : toute la famille, une laveuse.",
    "series.s0e4.komla_never": "Je ne l’ai jamais vue.",
    "series.s0e4.komla_stranger": "Une inconnue dans la maison ?",
    "series.s0e4.komla_who": "Akossiwa. Qui lave le linge de cette maison ?",
    "series.s0e4.tag_identity": "Identité",
    "series.s0e4.tag_interview": "Entretien",
    "series.s0e4.tag_references": "Références",
    "series.s0e4.tag_visit": "Jeudi · Akouvi",
    "series.s0e4.teaser": "Demain : la fin.",
    "series.s0e5.akossiwa_add": "Le tonton de mon mari vient vivre chez nous. Ajoutez-le au Foyer.",
    "series.s0e5.akossiwa_ok": "D’accord.",
    "series.s0e5.akossiwa_shirt": "Tonton. Ta chemise.",
    "series.s0e5.akossiwa_thursday": "Jeudi.",
    "series.s0e5.amivi_alone": "Tonton lave tout seul, oui.",
    "series.s0e5.caption_added": "Le jour de son arrivée, elle l’a ajouté au Foyer.",
    "series.s0e5.caption_opened": "Jeudi, c’est Tonton Komla qui a ouvert.",
    "series.s0e5.caption_part": "Partie 5 · La fin",
    "series.s0e5.end_line": "Solo, Duo ou Foyer. Une laveuse vérifiée, chez vous.",
    "series.s0e5.komla_good": "Elle lave bien, cette Akouvi.",
    "series.s0e5.komla_myself": "Moi, au moins, je lave mon linge moi-même.",
    "series.s0e5.komla_no_nap": "Je ne ferai pas la sieste.",
    "series.s0e5.komla_when": "Elle revient quand ?",
    "series.s0e5.kossi_count": "Chemises propres : Tonton, 1.",
    "series.s0e5.tag_arrival": "Le jour où Tonton est arrivé",
    "series.s0e5.tag_shirt": "Chemise de Tonton Komla",
    "series.s0e5.washed_noted": "C’est noté. Komla devient la 6e personne du Foyer : {price} de plus par mois.",
    "sms.sub.payment_failed": "Washed : prélèvement de {amount} XOF refusé. Solde Mobile Money insuffisant. Nouvelle tentative demain.",
    "sms.work.cancel_tomorrow": "Washed : la visite chez {name} demain {time} est annulée. Votre forfait journalier est maintenu. Bureau {phone}.",
    "student.repassage.accept_cta": "J'accepte cette mission",
    "student.repassage.accepted_note": "Mission acceptée. L'adresse complète et le contact du client sont ci-dessous.",
    "student.repassage.completed_note": "Merci ! Votre paiement Mobile Money est en cours.",
    "student.repassage.expired_note": "Cette mission n'est plus disponible.",
    "student.repassage.fee_line": "{fee} XOF pour vous — 100 %",
    "student.repassage.page_title": "Mission repassage Washed",
    "student.repassage.photo_cta": "Envoyer la photo du linge repassé",
    "student.repassage.sms.offer": "Washed : mission repassage le {date} ({window}) à {neighborhood}. {fee} XOF pour vous (100 %). Acceptez ici : {link}",
    "student.repassage.sms.paid": "Washed : merci ! {fee} XOF arrivent sur votre Mobile Money. À bientôt !",
    "subscriber.account.deletion.deleted.receipts_kept": "Reçus (conservés selon nos obligations comptables)",
    "subscriber.address_edit.a11y.already_pending_announcement": "Demande de modification d'adresse déjà en cours. Le bureau examine votre demande précédente.",
    "subscriber.address_edit.a11y.cta_disabled_hint": "Renseignez votre quartier pour activer.",
    "subscriber.address_edit.a11y.error_announcement": "Échec de l'envoi. Réessayez.",
    "subscriber.address_edit.a11y.landmark_label": "Repère, facultatif",
    "subscriber.address_edit.a11y.neighborhood_label": "Quartier, obligatoire",
    "subscriber.address_edit.a11y.street_label": "Rue ou détail, facultatif",
    "subscriber.address_edit.a11y.submitting": "Envoi de la demande de modification d'adresse",
    "subscriber.address_edit.a11y.success_announcement": "Demande envoyée. Le bureau examine votre nouvelle adresse.",
    "subscriber.address_edit.already_pending.body": "Le bureau examine votre demande précédente. Vous pourrez modifier à nouveau dès qu'elle est résolue.",
    "subscriber.address_edit.already_pending.title": "Demande déjà en cours",
    "subscriber.address_edit.body": "Le bureau valide la nouvelle adresse avant de modifier vos prochaines visites.",
    "subscriber.address_edit.cancel.cta": "Garder mon adresse",
    "subscriber.address_edit.current_label": "Adresse actuelle",
    "subscriber.address_edit.error.already_pending": "Une demande de modification d'adresse est déjà en cours. Veuillez attendre la validation du bureau.",
    "subscriber.address_edit.error.network": "Échec de l'envoi. Réessayez.",
    "subscriber.address_edit.field.landmark": "Repère (facultatif)",
    "subscriber.address_edit.field.landmark.placeholder": "en face de la pharmacie",
    "subscriber.address_edit.field.neighborhood": "Quartier",
    "subscriber.address_edit.field.neighborhood.placeholder": "Quartier (ex. Bè)",
    "subscriber.address_edit.field.street": "Rue / détail (facultatif)",
    "subscriber.address_edit.field.street.placeholder": "rue 18, immeuble jaune",
    "subscriber.address_edit.header": "Modifier l'adresse",
    "subscriber.address_edit.keyboard.done": "OK",
    "subscriber.address_edit.kicker": "Modifier l'adresse",
    "subscriber.address_edit.submit.cta": "Envoyer pour validation",
    "subscriber.address_edit.submit.pill": "Envoyer",
    "subscriber.address_edit.submitted.body": "Le bureau valide votre nouvelle adresse avant de modifier vos prochaines visites.",
    "subscriber.address_edit.submitted.cta": "Retour au profil",
    "subscriber.address_edit.submitted.title": "Demande envoyée",
    "subscriber.address_edit.title": "Nouvelle adresse",
    "subscriber.address_edit.warn_body": "Vos visites gardent l'adresse actuelle jusqu'à la validation. Délai habituel : 24-48 h.",
    "subscriber.address_edit.warn_eyebrow": "À noter",
    "subscriber.appearance.body": "Choisissez un affichage clair, sombre ou aligné sur votre téléphone.",
    "subscriber.appearance.header": "Apparence",
    "subscriber.appearance.launch.cta": "Continuer",
    "subscriber.appearance.launch.header": "Avant de commencer",
    "subscriber.appearance.option.dark": "Sombre",
    "subscriber.appearance.option.dark.body": "Garde les écrans en fond sombre.",
    "subscriber.appearance.option.light": "Clair",
    "subscriber.appearance.option.light.body": "Garde les écrans en fond clair.",
    "subscriber.appearance.option.system": "Système",
    "subscriber.appearance.option.system.body": "Suit le réglage de votre téléphone.",
    "subscriber.appearance.title": "Choisir l'apparence",
    "subscriber.auth.otp.title": "Le code reçu par SMS",
    "subscriber.auth.phone.title": "Votre numéro de téléphone",
    "subscriber.booking.confirmed.title": "Demande envoyée",
    "subscriber.booking.day.body": "Choisissez une journée en semaine ou le week-end.",
    "subscriber.booking.day.friday": "Vendredi",
    "subscriber.booking.day.monday": "Lundi",
    "subscriber.booking.day.saturday": "Samedi",
    "subscriber.booking.day.sunday": "Dimanche",
    "subscriber.booking.day.thursday": "Jeudi",
    "subscriber.booking.day.title": "Quel jour vous convient ?",
    "subscriber.booking.day.tuesday": "Mardi",
    "subscriber.booking.day.wednesday": "Mercredi",
    "subscriber.booking.day_group.label": "Jour souhaité",
    "subscriber.booking.header": "Réserver",
    "subscriber.booking.home.body": "Indiquez votre préférence en semaine ou le week-end. Le bureau confirme avec votre laveuse.",
    "subscriber.booking.home.cta": "Réserver une visite",
    "subscriber.booking.home.eyebrow": "Besoin d'un lavage ?",
    "subscriber.booking.home.title": "Réservez une visite",
    "subscriber.booking.notice": "Ce choix est une préférence, pas encore une confirmation. On vous appelle si la laveuse n'est pas disponible.",
    "subscriber.booking.request.cancel": "Annuler",
    "subscriber.booking.request.slot.afternoon_full": "Après-midi · 13 h–17 h",
    "subscriber.booking.request.slot.afternoon_hours": "13 h–17 h",
    "subscriber.booking.request.slot.morning_full": "Matin · 8 h–12 h",
    "subscriber.booking.request.slot.morning_hours": "8 h–12 h",
    "subscriber.booking.request.subtitle": "Vos visites reviendront ensuite ce même jour de la semaine, et vous pourrez en déplacer une jusqu’à 18 h la veille. Nous confirmons la date dès qu'une laveuse a accepté.",
    "subscriber.booking.request.title": "Quel jour pour votre première visite ?",
    "subscriber.booking.selected_day.label": "Jour choisi",
    "subscriber.booking.submit.cta": "Envoyer la demande",
    "subscriber.booking.submitted.body": "Le bureau confirme votre créneau par appel ou WhatsApp avant la visite.",
    "subscriber.booking.submitted.header": "Réservation",
    "subscriber.booking.submitted.home_cta": "Retour à l'accueil",
    "subscriber.booking.submitted.title": "Demande envoyée.",
    "subscriber.booking.sunday_closed": "Nous passons du lundi au samedi. Choisissez un autre jour.",
    "subscriber.booking.time.afternoon.detail": "13 h–17 h",
    "subscriber.booking.time.afternoon.label": "Après-midi",
    "subscriber.booking.time.body": "{day} est noté. Choisissez le moment qui vous arrange.",
    "subscriber.booking.time.morning.detail": "8 h–12 h",
    "subscriber.booking.time.morning.label": "Matin",
    "subscriber.booking.time.title": "Quel moment ce {day} ?",
    "subscriber.booking.time_group.label": "Moment souhaité",
    "subscriber.change_number.code_body_template": "Code envoyé au {number}.",
    "subscriber.change_number.code_title": "Entrez le code",
    "subscriber.change_number.confirm_cta": "Confirmer le changement",
    "subscriber.change_number.eyebrow": "Numéro de téléphone",
    "subscriber.change_number.number_body": "Nous enverrons un code par SMS à ce numéro pour confirmer qu'il est bien le vôtre.",
    "subscriber.change_number.number_label": "Nouveau numéro",
    "subscriber.change_number.number_title": "Nouveau numéro",
    "subscriber.change_number.send_cta": "Recevoir le code",
    "subscriber.change_number.success_body": "Vous vous connecterez désormais avec ce numéro.",
    "subscriber.change_number.success_cta": "Terminé",
    "subscriber.change_number.success_title": "Numéro mis à jour",
    "subscriber.client_insights.body": "Ces réponses sont facultatives. Elles nous aident à comprendre qui utilise le service et à améliorer les formules.",
    "subscriber.client_insights.field.age_band": "Tranche d'âge",
    "subscriber.client_insights.field.current_laundry_solution": "Solution actuelle pour le linge",
    "subscriber.client_insights.field.gender": "Genre",
    "subscriber.client_insights.field.household_role": "Rôle dans le foyer",
    "subscriber.client_insights.field.household_size": "Nombre de personnes au foyer",
    "subscriber.client_insights.field.join_reason": "Pourquoi rejoindre Washed ?",
    "subscriber.client_insights.field.referral_source": "Comment avez-vous connu Washed ?",
    "subscriber.client_insights.header": "Profil",
    "subscriber.client_insights.household_size.placeholder": "Ex. 4",
    "subscriber.client_insights.option.age.18_24": "18-24 ans",
    "subscriber.client_insights.option.age.25_34": "25-34 ans",
    "subscriber.client_insights.option.age.35_44": "35-44 ans",
    "subscriber.client_insights.option.age.45_54": "45-54 ans",
    "subscriber.client_insights.option.age.55_plus": "55 ans et plus",
    "subscriber.client_insights.option.gender.female": "Femme",
    "subscriber.client_insights.option.gender.male": "Homme",
    "subscriber.client_insights.option.gender.non_binary": "Non binaire",
    "subscriber.client_insights.option.laundry.family_help": "Famille / aide à la maison",
    "subscriber.client_insights.option.laundry.laundromat": "Pressing / laverie",
    "subscriber.client_insights.option.laundry.laveuse": "Laveuse indépendante",
    "subscriber.client_insights.option.laundry.self_wash": "Je lave moi-même",
    "subscriber.client_insights.option.other": "Autre",
    "subscriber.client_insights.option.prefer_not_to_say": "Préfère ne pas répondre",
    "subscriber.client_insights.option.reason.price": "Prix clair",
    "subscriber.client_insights.option.reason.quality": "Qualité du linge",
    "subscriber.client_insights.option.reason.reliability": "Service régulier",
    "subscriber.client_insights.option.reason.save_time": "Gagner du temps",
    "subscriber.client_insights.option.reason.trusted_worker": "Travailleuse fiable",
    "subscriber.client_insights.option.referral.field_team": "Équipe terrain",
    "subscriber.client_insights.option.referral.friend_family": "Ami ou famille",
    "subscriber.client_insights.option.referral.neighborhood": "Quartier",
    "subscriber.client_insights.option.referral.social_media": "Réseaux sociaux",
    "subscriber.client_insights.option.referral.worker": "Laveuse",
    "subscriber.client_insights.option.role.household_manager": "Responsable du foyer",
    "subscriber.client_insights.option.role.parent": "Parent",
    "subscriber.client_insights.option.role.professional": "Professionnelle / professionnel",
    "subscriber.client_insights.option.role.student": "Étudiante / étudiant",
    "subscriber.client_insights.placeholder": "Choisir une réponse",
    "subscriber.client_insights.privacy_note": "Pas de date de naissance complète. Vous pouvez ignorer chaque question.",
    "subscriber.client_insights.save_cta": "Enregistrer",
    "subscriber.client_insights.title": "Mieux adapter Washed",
    "subscriber.dashboard.cta_detail": "Détails",
    "subscriber.dashboard.cta_report": "Reporter",
    "subscriber.dashboard.cta_visits": "Voir les visites",
    "subscriber.dashboard.empty_visit.body": "Choisissez le jour et le moment souhaités. Le bureau confirme avant d'assigner votre laveuse.",
    "subscriber.dashboard.empty_visit.cta": "Planifier ma première visite",
    "subscriber.dashboard.empty_visit.eyebrow": "Première visite",
    "subscriber.dashboard.empty_visit.title": "Planifiez votre première visite",
    "subscriber.dashboard.greeting.afternoon": "Bon après-midi {name}.",
    "subscriber.dashboard.greeting.evening": "Bonsoir {name}.",
    "subscriber.dashboard.greeting.generic": "Bonjour",
    "subscriber.dashboard.greeting.morning": "bonjour {name}",
    "subscriber.dashboard.last_visit.label": "Dernière visite · {date}",
    "subscriber.dashboard.next_visit.countdown": "Dans {days} jours · {hours} h",
    "subscriber.dashboard.next_visit.day": "{weekday}",
    "subscriber.dashboard.next_visit.label": "Prochaine visite",
    "subscriber.dashboard.next_visit.status.in_progress": "en cours",
    "subscriber.dashboard.next_visit.status.scheduled": "prévue",
    "subscriber.dashboard.next_visit.time": "{hour} h {min}",
    "subscriber.dashboard.pending_visit.body": "Le bureau confirme votre créneau par appel ou WhatsApp avant d'assigner votre laveuse.",
    "subscriber.dashboard.pending_visit.cta": "Modifier ma demande",
    "subscriber.dashboard.pending_visit.eyebrow": "Demande envoyée",
    "subscriber.dashboard.pending_visit.title": "Première visite en confirmation",
    "subscriber.dashboard.plan.current_status": "À jour",
    "subscriber.dashboard.plan.first_visit_pending_status": "Demande en confirmation",
    "subscriber.dashboard.plan.first_visit_status": "Visite à planifier",
    "subscriber.dashboard.plan.ready_label": "Forfait",
    "subscriber.dashboard.profile_shortcut.label": "Ouvrir le profil",
    "subscriber.dashboard.service.arrival": "Arrivée prévue le {date} · {time}",
    "subscriber.dashboard.service.body": "Washed garde le suivi du service même si l'assignation change.",
    "subscriber.dashboard.service.eyebrow": "Zone de visite",
    "subscriber.dashboard.service.test_map": "Aperçu de la carte de la visite",
    "subscriber.dashboard.service.title": "{neighborhood}",
    "subscriber.dashboard.streak.label": "{count} visites avec {name}",
    "subscriber.dashboard.tab.history": "Historique",
    "subscriber.dashboard.tab.home": "Accueil",
    "subscriber.dashboard.tab.plan": "Forfait",
    "subscriber.dashboard.tab.profile": "Profil",
    "subscriber.dashboard.tab.visits": "Visites",
    "subscriber.dashboard.worker.assignment_pending.body": "Le bureau confirme la personne avant la visite.",
    "subscriber.dashboard.worker.assignment_pending.title": "Assignation en cours",
    "subscriber.dashboard.worker.ready_chip": "prête",
    "subscriber.dashboard.worker.tenure": "{neighborhood} · service suivi",
    "subscriber.dashboard.worker.tenure_first": "Première visite confirmée",
    "subscriber.delete.body": "Votre demande sera revue avant suppression. L'historique de {count} visites sera préparé selon les règles légales.",
    "subscriber.delete.body_pending": "Votre demande sera revue avant suppression. Votre historique sera préparé selon les règles légales.",
    "subscriber.delete.cancel.cta": "Annuler",
    "subscriber.delete.confirm.cta": "Supprimer définitivement",
    "subscriber.delete.confirm.label": "Tapez « SUPPRIMER » pour confirmer",
    "subscriber.delete.confirm.token": "SUPPRIMER",
    "subscriber.delete.header": "Supprimer le compte",
    "subscriber.delete.reason": "Demande de suppression depuis l'application abonnée.",
    "subscriber.delete.submitted.body": "Le bureau vérifie votre demande avant suppression. Référence {requestId}.",
    "subscriber.delete.submitted.cta": "Retour au profil",
    "subscriber.delete.submitted.title": "Demande envoyée.",
    "subscriber.delete.title": "C'est définitif.",
    "subscriber.delete.warn.cancel_visit": "Visite de {weekday} {date} annulée · pas de remboursement",
    "subscriber.delete.warn.cancel_visit_pending": "Aucune visite confirmée à annuler pour le moment",
    "subscriber.delete.warn.legal": "Délai légal de conservation : 30 jours côté bureau (factures)",
    "subscriber.delete.warn.photos": "Toutes vos photos supprimées définitivement",
    "subscriber.delete.warn.reassign": "Le bureau clôt l'assignation active après validation",
    "subscriber.delete.warn_eyebrow": "Ce qui arrivera",
    "subscriber.error.otp.already_used": "Ce code a déjà été utilisé. Demandez un nouveau code.",
    "subscriber.error.otp.expired": "Le code a expiré. Demandez un nouveau code.",
    "subscriber.error.otp.invalid_code": "Code incorrect. Vérifiez et réessayez.",
    "subscriber.error.otp.not_found": "Lien expiré. Recommencez avec votre numéro.",
    "subscriber.error.otp.too_many_attempts": "Trop de tentatives. Recommencez avec votre numéro.",
    "subscriber.family.cap_label": "Maximum 7 personnes — au-delà, contactez le bureau.",
    "subscriber.family.grace.age_bucket.adulte": "adulte",
    "subscriber.family.grace.age_bucket.enfant": "enfant",
    "subscriber.family.grace.age_bucket.mixte": "mélangé",
    "subscriber.family.grace.refused.body": "{count} vêtement(s) ({ageBucket}) ont été mis de côté. Ajoutez le membre manquant pour reprendre le service complet.",
    "subscriber.family.grace.refused.cta": "Mettre mon foyer à jour",
    "subscriber.family.grace.refused.title": "Vêtements non lavés selon le contrat",
    "subscriber.family.grace.strike_1.body": "Nous avons lavé {count} vêtement(s) supplémentaire(s) ({ageBucket}). Si quelqu'un manque dans votre famille, ajoutez-le pour les prochaines visites.",
    "subscriber.family.grace.strike_1.cta": "Ajouter un membre",
    "subscriber.family.grace.strike_1.title": "Vêtements supplémentaires lavés aujourd'hui",
    "subscriber.family.grace.strike_2.body": "Nous avons encore lavé {count} vêtement(s) supplémentaire(s) ({ageBucket}). À la prochaine visite, ils ne seront plus lavés.",
    "subscriber.family.grace.strike_2.cta": "Ajouter un membre maintenant",
    "subscriber.family.grace.strike_2.title": "Vêtements hors contrat — dernière visite avant refus",
    "subscriber.family.included_members_label": "5 personnes incluses, vous compris",
    "subscriber.family.roster.add_cta": "Ajouter un membre",
    "subscriber.family.roster.age_years": "{age} ans",
    "subscriber.family.roster.cap_reached": "Maximum atteint : 7 personnes, vous compris. Pour un foyer plus grand, contactez le bureau.",
    "subscriber.family.roster.edit.cancel_cta": "Annuler",
    "subscriber.family.roster.edit.relationship_locked": "Pour changer la relation, retirez ce membre et ajoutez-en un nouveau.",
    "subscriber.family.roster.edit.save_cta": "Enregistrer",
    "subscriber.family.roster.edit.title": "Modifier ce membre",
    "subscriber.family.roster.edit_cta": "Modifier",
    "subscriber.family.roster.empty": "Aucun membre enregistré.",
    "subscriber.family.roster.error": "Impossible de mettre à jour votre foyer pour le moment. Réessayez.",
    "subscriber.family.roster.member_count": "{active} / 6 membres en plus de vous",
    "subscriber.family.roster.paid_extra_badge": "Membre payant",
    "subscriber.family.roster.readd_cta": "Re-ajouter",
    "subscriber.family.roster.remove.cancel_cta": "Annuler",
    "subscriber.family.roster.remove.confirm_body": "Cette action remet à zéro le compteur de tolérance pour la prochaine visite. Le membre apparaîtra comme retiré dans votre historique.",
    "subscriber.family.roster.remove.confirm_cta": "Retirer",
    "subscriber.family.roster.remove.confirm_title": "Retirer ce membre ?",
    "subscriber.family.roster.remove_cta": "Retirer",
    "subscriber.family.roster.removed_at": "Retiré le {date}",
    "subscriber.family.roster.removed_section": "Membres retirés",
    "subscriber.family.roster.show_removed": "Voir les membres retirés",
    "subscriber.family.roster.title": "Mon foyer",
    "subscriber.family.seat_upsell.a11y.cta_hint": "Ouvre le formulaire d'ajout de membre ci-dessous.",
    "subscriber.family.seat_upsell.body": "+{price} XOF par mois — tout le foyer couvert à chaque passage.",
    "subscriber.family.seat_upsell.cta": "Ajouter une personne",
    "subscriber.family.seat_upsell.title": "Une {seat}ᵉ personne ?",
    "subscriber.family.section.headline": "Une laveuse, tout le linge de la maison, en un seul passage.",
    "subscriber.family.signup.commercial_accord.block": "Pour 8 personnes ou plus, le bureau vous propose un prix adapté à votre foyer : {phone}.",
    "subscriber.family.signup.member.add.body": "Inscrivez chaque personne dont le linge sera lavé. Les vêtements de toute personne non enregistrée sont refusés.",
    "subscriber.family.signup.member.add.title": "Ajoutez un membre",
    "subscriber.family.signup.member.add_cta": "Ajouter ce membre",
    "subscriber.family.signup.member.birth_year": "Année de naissance",
    "subscriber.family.signup.member.cap_reached": "Maximum atteint : 7 personnes, vous compris.",
    "subscriber.family.signup.member.count": "{count} / 6 membres en plus de vous",
    "subscriber.family.signup.member.edit_cta": "Modifier",
    "subscriber.family.signup.member.gender": "Genre",
    "subscriber.family.signup.member.gender_f": "Femme",
    "subscriber.family.signup.member.gender_m": "Homme",
    "subscriber.family.signup.member.given_name": "Prénom",
    "subscriber.family.signup.member.housemaid_notice": "Le personnel domestique compte comme membre payant et ses vêtements seront refusés s'il n'est pas enregistré.",
    "subscriber.family.signup.member.list.title": "Membres déjà inscrits",
    "subscriber.family.signup.member.paid_extra_warning": "Ce membre coûte {price} XOF/mois supplémentaires au-delà des 5 inclus.",
    "subscriber.family.signup.member.rel.ami": "Ami ou amie",
    "subscriber.family.signup.member.rel.autre": "Autre",
    "subscriber.family.signup.member.rel.epouse": "Épouse",
    "subscriber.family.signup.member.rel.epoux": "Époux",
    "subscriber.family.signup.member.rel.fille": "Fille",
    "subscriber.family.signup.member.rel.fils": "Fils",
    "subscriber.family.signup.member.rel.parent": "Parent",
    "subscriber.family.signup.member.rel.personnel_domestique": "Personnel domestique",
    "subscriber.family.signup.member.relationship": "Relation",
    "subscriber.family.signup.member.remove_cta": "Retirer",
    "subscriber.family.signup.payment.body": "Votre premier prélèvement Mobile Money sera de {amount}, avant votre premier passage. Les mois suivants sont prélevés avant leur premier passage.",
    "subscriber.family.signup.payment.cta": "Confirmer · {amount}",
    "subscriber.family.signup.payment.error": "Le paiement n'a pas pu être confirmé. Vérifiez votre solde Mobile Money et réessayez.",
    "subscriber.family.signup.payment.retry_cta": "Réessayer",
    "subscriber.family.signup.payment.title": "Confirmer le paiement",
    "subscriber.family.signup.review.base": "Plan de base",
    "subscriber.family.signup.review.body": "Vérifiez chaque membre. Vous pourrez les modifier après votre inscription depuis votre forfait.",
    "subscriber.family.signup.review.continue_cta": "Confirmer et payer",
    "subscriber.family.signup.review.cta": "Réviser ma famille",
    "subscriber.family.signup.review.empty": "Ajoutez au moins un membre.",
    "subscriber.family.signup.review.extras": "Sièges supplémentaires ({count})",
    "subscriber.family.signup.review.title": "Révisez votre famille",
    "subscriber.family.signup.review.total": "Total mensuel",
    "subscriber.family.visit.grace_banner.cta": "Mettre à jour mon foyer",
    "subscriber.family.visit.grace_banner.strike_ge3": "Du linge a été refusé selon le contrat — {count} vêtement(s) ({ageBucket}).",
    "subscriber.family.visit.grace_banner.strike_lt3": "Cette visite a inclus du linge supplémentaire — {count} vêtement(s) ({ageBucket}).",
    "subscriber.freshness.stale": "Pas à jour · dernière mise à jour à {time}",
    "subscriber.history.detail.after": "Après",
    "subscriber.history.detail.after_photo": "Photo après",
    "subscriber.history.detail.arrival": "Arrivée",
    "subscriber.history.detail.before": "Avant",
    "subscriber.history.detail.before_photo": "Photo avant",
    "subscriber.history.detail.completed": "Fin",
    "subscriber.history.detail.duration_with_worker": "{duration} de service.",
    "subscriber.history.detail.good_title": "Bonne visite.",
    "subscriber.history.detail.header": "Visite · {date}",
    "subscriber.history.detail.included": "Visite incluse au forfait",
    "subscriber.history.detail.payment": "Paiement",
    "subscriber.history.detail.report.cta": "Signaler a posteriori",
    "subscriber.history.detail.timeline": "Déroulé",
    "subscriber.history.empty.body": "Votre première visite apparaîtra ici dès qu'elle est terminée.",
    "subscriber.history.empty.title": "Pas encore de visite.",
    "subscriber.history.entry.duration": "{duration}",
    "subscriber.history.entry.duration_clean": "{duration} · pas de souci",
    "subscriber.history.entry.status_clean": "Visite réussie",
    "subscriber.history.entry.status_issue": "Souci signalé",
    "subscriber.history.eyebrow": "Vos visites",
    "subscriber.history.heading": "Vos visites.",
    "subscriber.history.recent": "Récentes",
    "subscriber.history.stats.counter": "Compteur",
    "subscriber.history.stats.coverage": "Mois couverts",
    "subscriber.history.stats.months": "mois",
    "subscriber.history.title": "Votre suivi Washed depuis {months} mois.",
    "subscriber.history.title_first": "Première visite Washed.",
    "subscriber.home.cancelled.body": "Aucune visite ni aucun paiement à venir. Vous pouvez reprendre un forfait quand vous voulez.",
    "subscriber.home.cancelled.title": "Forfait arrêté",
    "subscriber.home.contact_office": "Joindre le bureau",
    "subscriber.home.greeting": "Bonjour, {name}",
    "subscriber.home.household_incomplete.cta": "Ajouter les personnes",
    "subscriber.home.household_incomplete.title": "Ajoutez les personnes de votre forfait",
    "subscriber.home.household_unknown.title": "Nous n’avons pas pu vérifier les personnes de votre forfait.",
    "subscriber.home.no_payment_until_confirmed": "Aucun paiement tant que votre laveuse n’est pas confirmée.",
    "subscriber.home.paused.body": "Aucun paiement pendant la pause. Vous pouvez reprendre quand vous voulez.",
    "subscriber.home.paused.title": "Forfait en pause",
    "subscriber.home.pending.body": "Nous vous prévenons dès que la laveuse et la date sont confirmées.",
    "subscriber.home.pending.preference": "Votre préférence : {day}, {window}. Nous vous prévenons dès que la laveuse et la date sont confirmées.",
    "subscriber.home.pending.title": "Le bureau choisit votre laveuse",
    "subscriber.home.rate_ask.a11y": "Noter la visite du {date}",
    "subscriber.home.rate_ask.title": "Comment s’est passée la visite ?",
    "subscriber.home.ready.body": "Indiquez le jour et le moment qui vous conviennent. Le bureau choisit ensuite une laveuse de votre quartier.",
    "subscriber.home.ready.cta": "Choisir le jour",
    "subscriber.home.ready.title": "Choisissez votre premier passage",
    "subscriber.home.steps.choose_day": "Choix du jour et du moment",
    "subscriber.home.steps.confirmed": "Premier passage confirmé",
    "subscriber.home.steps.confirmed_detail": "Date, heure et laveuse",
    "subscriber.home.steps.plan_created": "Abonnement créé",
    "subscriber.home.steps.request_sent": "Demande envoyée",
    "subscriber.home.steps.state_done": "fait",
    "subscriber.home.steps.state_now": "en cours",
    "subscriber.home.steps.state_todo": "à venir",
    "subscriber.home.steps.washer": "Choix de votre laveuse",
    "subscriber.home.steps.washer_detail": "Par le bureau, selon votre quartier",
    "subscriber.home.upcoming_visit.between_body": "Votre prochaine visite apparaîtra ici dès que le bureau l'aura planifiée.",
    "subscriber.home.visit_day.eta": "Arrive dans {minutes} min",
    "subscriber.home.visit_day.open_cta": "Voir la visite",
    "subscriber.home.visit_day.since": "depuis {minutes} min",
    "subscriber.hub.change_until": "Possible jusqu'au {date}, 18 h.",
    "subscriber.language.body": "Choisissez la langue de l'application. Vous pourrez la changer dans Profil.",
    "subscriber.language.header": "Langue",
    "subscriber.language.launch.cta": "Continuer",
    "subscriber.language.launch.header": "Avant de commencer",
    "subscriber.language.option.en": "English",
    "subscriber.language.option.en.body": "Interface et messages en anglais.",
    "subscriber.language.option.fr": "Français",
    "subscriber.language.option.fr.body": "Interface et messages en français.",
    "subscriber.language.title": "Choisir la langue",
    "subscriber.launch.restore.status": "Restauration de votre session…",
    "subscriber.load_failed.home": "Impossible d’afficher votre accueil",
    "subscriber.load_failed.plan": "Impossible d’afficher votre forfait",
    "subscriber.load_failed.prices": "Impossible d’afficher les prix",
    "subscriber.load_failed.retry": "Réessayer",
    "subscriber.load_failed.tickets": "Impossible d’afficher vos demandes",
    "subscriber.load_failed.visit": "Impossible d’afficher cette visite",
    "subscriber.load_failed.visits": "Impossible d’afficher vos visites",
    "subscriber.loading.a11y": "Chargement",
    "subscriber.loading.slow": "Plus long que d’habitude…",
    "subscriber.neighborhood_route.eyebrow": "Carte de quartier",
    "subscriber.neighborhood_route.map_title": "Tournée du quartier",
    "subscriber.neighborhood_route.metric_eta": "Repère",
    "subscriber.neighborhood_route.metric_eta_fallback": "Avant visite",
    "subscriber.neighborhood_route.metric_progress": "Trajet",
    "subscriber.neighborhood_route.metric_stops": "Étapes",
    "subscriber.neighborhood_route.offer_activate": "Activer l'avantage",
    "subscriber.neighborhood_route.offer_activated": "Avantage activé",
    "subscriber.neighborhood_route.offer_activating": "Activation...",
    "subscriber.neighborhood_route.offer_eyebrow": "Avantage partenaire",
    "subscriber.neighborhood_route.offer_failed": "Activation impossible pour le moment.",
    "subscriber.neighborhood_route.offer_valid_until": "Valable jusqu'au {date}",
    "subscriber.neighborhood_route.open": "Voir le trajet de quartier",
    "subscriber.neighborhood_route.partner_frozen_badge": "Gelé",
    "subscriber.neighborhood_route.progress": "Progression du trajet",
    "subscriber.neighborhood_route.progress_value": "{count} %",
    "subscriber.neighborhood_route.signal_lost": "Signal perdu · dernière position connue",
    "subscriber.neighborhood_route.sponsor_hidden": "Programme partenaires masqué",
    "subscriber.neighborhood_route.sponsors_frozen": "Les offres partenaires sont prêtes côté produit, mais restent invisibles tant que le lancement commercial est gelé.",
    "subscriber.neighborhood_route.stops_value": "{count} étapes",
    "subscriber.neighborhood_route.story_title": "Repères du trajet",
    "subscriber.neighborhood_route.subtitle": "Votre visite, replacée dans les repères utiles du quartier.",
    "subscriber.neighborhood_route.title_fallback": "Découvrir le quartier",
    "subscriber.neighborhood_route.unavailable": "La carte de quartier n’est pas disponible pour cette visite.",
    "subscriber.notifications.body": "Vous pouvez tout désactiver. Le bureau vous appellera s'il y a urgence.",
    "subscriber.notifications.email_recap.sub": "Reçu et statistiques du mois",
    "subscriber.notifications.email_recap.title": "Email mensuel · récap",
    "subscriber.notifications.header": "Notifications",
    "subscriber.notifications.no_marketing": "Aucune notification marketing — promis.",
    "subscriber.notifications.no_visit": "Aucune visite confirmée",
    "subscriber.notifications.push_reveal.sub": "« Voilà ce que ça donne » · 1×",
    "subscriber.notifications.push_reveal.title": "Push · reveal photos",
    "subscriber.notifications.push_route.sub": "« La visite est en route » · « La laveuse est arrivée »",
    "subscriber.notifications.push_route.title": "Push · en route",
    "subscriber.notifications.sms_reminder.sub": "{weekday} {time}, {weekday} {time} dans {hours} h",
    "subscriber.notifications.sms_reminder.sub_pending": "Rappel WhatsApp dès qu'une visite est confirmée.",
    "subscriber.notifications.sms_reminder.title": "WhatsApp · rappel J-1 et J",
    "subscriber.notifications.title": "Que voulez-vous recevoir ?",
    "subscriber.offline.since": "Hors connexion depuis {time}",
    "subscriber.payment.action.edit_method": "Modifier le moyen",
    "subscriber.payment.action.view_history": "Voir les paiements",
    "subscriber.payment.cancel.title": "Vous êtes sûr ?",
    "subscriber.payment.failed.banner.cta": "Régulariser",
    "subscriber.payment.failed.banner.message": "Régularisez votre paiement pour conserver vos visites.",
    "subscriber.payment.failed.banner.title": "Paiement échoué",
    "subscriber.payment.failed.body": "Solde Mobile Money insuffisant. Rechargez puis nous réessayons demain.",
    "subscriber.payment.failed.change_label": "Modifier mon moyen de paiement",
    "subscriber.payment.failed.cta": "Réessayer maintenant",
    "subscriber.payment.failed.hero_title": "Le prélèvement a échoué",
    "subscriber.payment.failed.next_step": "Rechargez votre compte ou changez de moyen de paiement, puis prévenez le bureau : il relance le prélèvement.",
    "subscriber.payment.failed.title": "Le paiement n'a pas abouti.",
    "subscriber.payment.failed.whatsapp_cta": "Prévenir le bureau sur WhatsApp",
    "subscriber.payment.failed.whatsapp_message": "Bonjour, mon paiement Washed a échoué. Mon compte est prêt : vous pouvez relancer le prélèvement.",
    "subscriber.payment.history.amount_review": "Montant à vérifier",
    "subscriber.payment.history.count_label": "{count} prélèvements",
    "subscriber.payment.history.covered_label": "Mois couverts",
    "subscriber.payment.history.current_status": "À jour",
    "subscriber.payment.history.detail_eyebrow": "Détail",
    "subscriber.payment.history.download_cta": "Télécharger les reçus",
    "subscriber.payment.history.download_error": "Téléchargement impossible. Réessayez.",
    "subscriber.payment.history.download_selected_cta": "Télécharger {count} reçu(s)",
    "subscriber.payment.history.empty": "Aucun paiement encore.",
    "subscriber.payment.history.header": "Historique paiements",
    "subscriber.payment.history.months_value": "{months} mois",
    "subscriber.payment.history.receipt_tools_label": "Choix des reçus",
    "subscriber.payment.history.review_status": "À vérifier",
    "subscriber.payment.history.select_receipt": "Inclure le reçu du {date}",
    "subscriber.payment.history.selection_all": "Tout sélectionner",
    "subscriber.payment.history.selection_clear": "Tout retirer",
    "subscriber.payment.history.selection_count": "{count} reçu(s) sélectionné(s)",
    "subscriber.payment.history.status_label": "Statut",
    "subscriber.payment.history.summary_label": "Résumé paiements",
    "subscriber.payment.history.title": "{months} mois couverts.",
    "subscriber.payment.method.active_badge": "Actif",
    "subscriber.payment.method.add.body": "Choisissez Mixx by Yas ou Flooz, puis entrez le numéro lié à ce compte Mobile Money.",
    "subscriber.payment.method.add.cta": "Enregistrer",
    "subscriber.payment.method.add.error.invalid_number": "Numéro invalide. Vérifiez le format.",
    "subscriber.payment.method.add.error.network": "Enregistrement impossible. Réessayez.",
    "subscriber.payment.method.add.header": "Ajouter un moyen de paiement",
    "subscriber.payment.method.add.success.body": "Le prochain prélèvement sera effectué sur ce compte.",
    "subscriber.payment.method.add.success.title": "Moyen de paiement ajouté.",
    "subscriber.payment.method.add.title": "Choisissez votre fournisseur.",
    "subscriber.payment.method.add_flooz": "+ Ajouter un Flooz",
    "subscriber.payment.method.add_mixx": "+ Ajouter un Mixx by Yas",
    "subscriber.payment.method.available_badge": "Dispo",
    "subscriber.payment.method.body": "Choisissez le fournisseur et le numéro Mobile Money à débiter chaque mois.",
    "subscriber.payment.method.current_suffix": "actuel",
    "subscriber.payment.method.field.number": "Numéro Mobile Money",
    "subscriber.payment.method.field.number.placeholder": "07 00 00 00 00",
    "subscriber.payment.method.header": "Moyen de paiement",
    "subscriber.payment.method.save_cta": "Enregistrer",
    "subscriber.payment.method.sponsor_fallback.a11y.submitting": "Enregistrement du Mobile Money de secours",
    "subscriber.payment.method.sponsor_fallback.a11y.success_announcement": "Mobile Money de secours ajouté.",
    "subscriber.payment.method.sponsor_fallback.body": "Ce moyen sert uniquement si le paiement du sponsor échoue ou s'arrête.",
    "subscriber.payment.method.sponsor_fallback.cta": "Enregistrer le secours",
    "subscriber.payment.method.sponsor_fallback.notice": "Le sponsor continue de payer tant que sa carte fonctionne. Votre Mobile Money protège le service pendant le délai de grâce.",
    "subscriber.payment.method.sponsor_fallback.success.body": "Votre forfait reste protégé si le sponsor doit corriger sa carte.",
    "subscriber.payment.method.sponsor_fallback.success.title": "Mobile Money de secours ajouté",
    "subscriber.payment.method.sponsor_fallback.title": "Ajouter un Mobile Money local",
    "subscriber.payment.method.swap.notice": "Ce numéro sera utilisé pour le prochain prélèvement, y compris celui que le bureau relance après un échec.",
    "subscriber.payment.method.swap.success.title": "Moyen de paiement mis à jour",
    "subscriber.payment.method.title": "Mobile Money",
    "subscriber.payment.overdue.banner": "3 tentatives échouées. Visite en pause jusqu'au paiement.",
    "subscriber.payment.overdue.header": "Paiement non abouti",
    "subscriber.payment.overdue.next_visit_eyebrow": "Prochaine visite",
    "subscriber.payment.overdue.waiting": "en attente de paiement",
    "subscriber.payment.receipt.amount_label": "Montant",
    "subscriber.payment.receipt.bundle_title": "Reçus Washed · {count} paiements",
    "subscriber.payment.receipt.client_label": "Client",
    "subscriber.payment.receipt.footer": "Document généré depuis l'application Washed. Chaque reçu correspond à un prélèvement ou remboursement individuel.",
    "subscriber.payment.receipt.issued_at": "Émis le {date}",
    "subscriber.payment.receipt.reference_label": "Référence",
    "subscriber.payment.receipt.single_title": "Reçu Washed · {date}",
    "subscriber.payment.receipt.status.review": "À vérifier",
    "subscriber.payment.receipt.status.succeeded": "Payé",
    "subscriber.payment.receipt.title": "Reçu",
    "subscriber.payment.receipt.type_charge": "Prélèvement",
    "subscriber.payment.receipt.type_label": "Type",
    "subscriber.payment.receipt.type_refund": "Remboursement",
    "subscriber.payment.success.toast": "{amount} XOF prélevés. Référence {ref}.",
    "subscriber.plan.active_card.eyebrow": "Forfait actif",
    "subscriber.plan.active_card.next_charge_label": "Prochain prélèvement",
    "subscriber.plan.active_card.next_charge_value": "{date} · auto",
    "subscriber.plan.active_card.payment_setup_pending": "Paiement à finaliser",
    "subscriber.plan.active_card.tier": "{label} · {amount} / mois",
    "subscriber.plan.change.available_badge": "Disponible",
    "subscriber.plan.change.body": "Toutes les formules disponibles sont ici. Le changement prend effet au prochain cycle · {date}.",
    "subscriber.plan.change.current_badge": "Actuel",
    "subscriber.plan.change.header": "Modifier le forfait",
    "subscriber.plan.change.increase_label": "Hausse / mois",
    "subscriber.plan.change.options_label": "Forfaits disponibles",
    "subscriber.plan.change.reduction_label": "Baisse / mois",
    "subscriber.plan.change.select_cta": "Choisir un forfait",
    "subscriber.plan.change.selected_badge": "Choisi",
    "subscriber.plan.change.title": "Choisissez votre nouveau forfait.",
    "subscriber.plan.cta_manage_family": "Gérer mon foyer",
    "subscriber.plan.cta_modify": "Modifier le forfait",
    "subscriber.plan.cta_pause": "Mettre en pause",
    "subscriber.plan.cta_repassage": "Faire repasser mon linge",
    "subscriber.plan.detail.choose_slot": "Choisissez le jour et le moment souhaités. Le bureau confirme avant d'assigner votre laveuse.",
    "subscriber.plan.extra_wash.lead": "Un lavage complet en plus de votre forfait, un par cycle. Nous confirmons un créneau avec une laveuse disponible.",
    "subscriber.plan.extra_wash.price": "{price} F CFA, pour votre forfait {plan} actuel",
    "subscriber.plan.extra_wash.success.plan_unchanged": "Votre forfait n’a pas encore changé.",
    "subscriber.plan.extra_wash.until": "Choisissez une date jusqu’au {date}.",
    "subscriber.plan.eyebrow": "Votre forfait",
    "subscriber.plan.forfait.addons_title": "Services en plus",
    "subscriber.plan.forfait.due_cancelled": "Abonnement résilié",
    "subscriber.plan.forfait.due_eyebrow": "Prochain paiement",
    "subscriber.plan.forfait.method_label": "Paiement",
    "subscriber.plan.next_visit.assignment_pending": "Assignation confirmée avant la visite",
    "subscriber.plan.next_visit.empty": "Aucune visite confirmée",
    "subscriber.plan.next_visit.eyebrow": "Prochaine visite",
    "subscriber.plan.next_visit.summary": "{weekday} {date} · {time}",
    "subscriber.plan.next_visit.with_worker": "avec {name}",
    "subscriber.plan.pause.body": "Pas de visites ni de prélèvement de {amount} pendant la pause. Vous reprenez quand vous voulez depuis l'onglet Forfait.",
    "subscriber.plan.pause.body_no_amount": "Pas de visites ni de prélèvements pendant la pause. Vous reprenez quand vous voulez depuis l'onglet Forfait.",
    "subscriber.plan.pause.confirm.cta": "Mettre en pause",
    "subscriber.plan.pause.header": "Mettre en pause",
    "subscriber.plan.pause.success.body": "Aucune visite ni aucun prélèvement pendant la pause. Reprenez quand vous voulez depuis l'onglet Forfait.",
    "subscriber.plan.pause.success.changes.data": "Vos données et historique conservés",
    "subscriber.plan.pause.success.changes.no_charge": "Pas de prélèvement le {date}",
    "subscriber.plan.pause.success.changes.no_charge_pending": "Aucun prélèvement tant que le paiement n'est pas prêt.",
    "subscriber.plan.pause.success.changes.no_visit": "Aucune visite confirmée à annuler pour le moment.",
    "subscriber.plan.pause.success.changes.resume": "Vous pouvez reprendre à tout moment depuis Forfait",
    "subscriber.plan.pause.success.changes.visit": "Visite de {weekday} {date} : annulée · sans frais",
    "subscriber.plan.pause.success.changes_eyebrow": "Ce qui change maintenant",
    "subscriber.plan.pause.success.cta": "Compris",
    "subscriber.plan.pause.success.deadline_body": "Sans reprise avant le {date}, votre compte sera clôturé automatiquement.",
    "subscriber.plan.pause.success.deadline_body_pending": "Le bureau confirme votre date limite de reprise dans votre dossier.",
    "subscriber.plan.pause.success.deadline_eyebrow": "Rappel · délai max",
    "subscriber.plan.pause.success.title": "Pause activée",
    "subscriber.plan.pause.title": "Mettre votre forfait en pause ?",
    "subscriber.plan.pause.warn.cancel_visit": "Visite de {weekday} {date} annulée · vous gardez le crédit",
    "subscriber.plan.pause.warn.no_charge": "Pas de prélèvement le {date}",
    "subscriber.plan.pause.warn.no_charge_pending": "Aucun prélèvement tant que le paiement n'est pas prêt.",
    "subscriber.plan.pause.warn.no_visit_cancel": "Votre historique et vos préférences sont gardés. Votre créneau habituel, lui, n'est pas garanti à la reprise.",
    "subscriber.plan.pause.warn.resume": "Vous pouvez reprendre à tout moment",
    "subscriber.plan.pause.warn_eyebrow": "Ce qui va arriver",
    "subscriber.plan.paused.deadline_body": "La pause prend fin automatiquement au bout de 3 mois (le {date}). Au-delà, votre compte est clôturé et le créneau peut être donné à un autre foyer.",
    "subscriber.plan.paused.deadline_body_pending": "Votre pause reste temporaire. Le bureau vous confirme la date limite de reprise dans votre dossier.",
    "subscriber.plan.paused.deadline_eyebrow": "Attention · délai max",
    "subscriber.plan.paused.extend_cta": "Prolonger la pause · contact bureau",
    "subscriber.plan.paused.eyebrow": "Forfait en pause",
    "subscriber.plan.paused.headline": "Aucune visite jusqu'à reprise.",
    "subscriber.plan.paused.hold_notice": "Votre historique et vos préférences sont gardés. Votre créneau habituel, lui, n'est pas garanti à la reprise.",
    "subscriber.plan.paused.resume_confirm_action": "Reprendre",
    "subscriber.plan.paused.resume_confirm_change_payment": "Changer de moyen de paiement d'abord",
    "subscriber.plan.paused.resume_confirm_message": "Vos visites et vos paiements reprennent avec le moyen de paiement enregistré.",
    "subscriber.plan.paused.resume_confirm_title": "Reprendre votre forfait ?",
    "subscriber.plan.paused.resume_cta": "Reprendre maintenant",
    "subscriber.plan.paused.since": "Pause active depuis le {date} · jour {day} sur 90 max.",
    "subscriber.plan.paused.since_pending": "Pause active. La date exacte est confirmée dans votre dossier.",
    "subscriber.plan.paused.title": "Votre compte est en pause",
    "subscriber.plan.paused.worker_eyebrow": "Votre service",
    "subscriber.plan.paused.worker_line": "Le bureau garde votre dossier prêt.",
    "subscriber.plan.paused.worker_sub": "Historique conservé · {months} mois de suivi",
    "subscriber.plan.paused.worker_sub_ready": "Historique conservé · reprise possible dès que vous le souhaitez",
    "subscriber.plan.pending.card_eyebrow": "Forfait prêt",
    "subscriber.plan.pending.request_body": "Le bureau confirme votre créneau par appel ou WhatsApp avant d'assigner votre laveuse.",
    "subscriber.plan.pending.request_title": "Votre première visite est en confirmation.",
    "subscriber.plan.pending.title": "Votre forfait est prêt.",
    "subscriber.plan.per_person.label": "Par personne",
    "subscriber.plan.per_person.people": "{count} personnes",
    "subscriber.plan.sheet.and": "et",
    "subscriber.plan.sheet.close": "Fermer",
    "subscriber.plan.sheet.cta": "Passer à {plan}",
    "subscriber.plan.sheet.cta_idle": "Choisissez un autre forfait",
    "subscriber.plan.sheet.current": "Votre forfait actuel",
    "subscriber.plan.sheet.extra_wash_link": "Ajouter un lavage {plan}",
    "subscriber.plan.sheet.extra_wash_question": "Un lavage de plus ce mois-ci ?",
    "subscriber.plan.sheet.household_question": "Combien êtes-vous ?",
    "subscriber.plan.sheet.keep": "Annuler ce changement",
    "subscriber.plan.sheet.kept": "Vous gardez {plan}.",
    "subscriber.plan.sheet.leaves_many": "{names} ne seront alors plus sur votre forfait.",
    "subscriber.plan.sheet.leaves_one": "{names} ne sera alors plus sur votre forfait.",
    "subscriber.plan.sheet.prices_loading": "Chargement des prix",
    "subscriber.plan.sheet.scheduled": "Changement prévu : {plan} à partir du {date}. Jusque-là, vous restez en {current}.",
    "subscriber.plan.sheet.scheduled_note": "Changement prévu",
    "subscriber.plan.sheet.scheduled_undated": "Changement prévu : {plan} avec votre prochain paiement. Jusque-là, vous restez en {current}.",
    "subscriber.plan.sheet.sending": "Envoi en cours",
    "subscriber.plan.sheet.solo_leaves": "Solo ne couvre que vous.",
    "subscriber.plan.sheet.timing_immediate": "{plan} s’applique tout de suite. Votre premier paiement sera de {price} F CFA.",
    "subscriber.plan.sheet.timing_next": "Ce mois-ci reste en {current}. À partir du {date} : {plan}, {price} F CFA par mois.",
    "subscriber.plan.sheet.timing_next_undated": "Ce mois-ci reste en {current}. Avec votre prochain paiement : {plan}, {price} F CFA par mois.",
    "subscriber.plan.sheet.title": "Changer de forfait",
    "subscriber.plan.sheet.today": "Aujourd’hui : {plan}, {price} F CFA par mois.",
    "subscriber.plan.sheet.who_stays_body": "Duo couvre deux personnes : vous et une autre. Choisissez qui reste.",
    "subscriber.plan.sheet.who_stays_title": "Qui reste sur votre forfait ?",
    "subscriber.plan.sponsor.billing_note": "Facturé chaque mois. Annulation possible à tout moment.",
    "subscriber.plan.sponsor.creating": "Création du lien Sponsor Pay",
    "subscriber.plan.sponsor.eyebrow": "Sponsor Pay",
    "subscriber.plan.sponsor.fallback.cta": "Ajouter un Mobile Money local",
    "subscriber.plan.sponsor.fallback.notice": "Ajoutez un Mobile Money local avant la fin du délai pour éviter l'arrêt du service.",
    "subscriber.plan.sponsor.grace_ends_label": "Délai de grâce",
    "subscriber.plan.sponsor.invite.body": "Envoyez un lien privé. Le sponsor voit seulement le forfait, les montants, l'état du paiement et votre prénom.",
    "subscriber.plan.sponsor.invite.cta": "Créer le lien Sponsor Pay",
    "subscriber.plan.sponsor.invite.title": "Faire payer ce forfait par un proche",
    "subscriber.plan.sponsor.link.body": "Partagez ce lien avec la personne qui paiera le forfait.",
    "subscriber.plan.sponsor.link.title": "Lien prêt",
    "subscriber.plan.sponsor.next_renewal_label": "Prochain renouvellement",
    "subscriber.plan.sponsor.plan_label": "Forfait",
    "subscriber.plan.sponsor.privacy_note": "Le sponsor ne voit ni laveuse, ni adresse, ni photos, ni litiges, sauf partage explicite de votre part.",
    "subscriber.plan.sponsor.revoke.cta": "Arrêter Sponsor Pay",
    "subscriber.plan.sponsor.revoked.body": "Ajoutez un Mobile Money local pour garder le forfait actif.",
    "subscriber.plan.sponsor.revoked.title": "Sponsor Pay arrêté",
    "subscriber.plan.sponsor.revoking": "Arrêt de Sponsor Pay",
    "subscriber.plan.sponsor.share.cta": "Partager",
    "subscriber.plan.sponsor.status.active": "Sponsor actif",
    "subscriber.plan.sponsor.status.payment_failed": "Paiement sponsor échoué",
    "subscriber.plan.sponsor.status.pending": "En attente du sponsor",
    "subscriber.plan.sponsor.status.revoked": "Sponsor Pay arrêté",
    "subscriber.plan.sponsor.total_label": "Total sponsor",
    "subscriber.plan.tab.status_cancelled": "Résilié",
    "subscriber.plan.tab.status_paused": "En pause",
    "subscriber.plan.tab.status_payment_overdue": "Paiement en retard",
    "subscriber.plan.title.active": "Compte bon jusqu'au {date}.",
    "subscriber.plan.title.active_payment_setup": "Forfait prêt, paiement à finaliser.",
    "subscriber.plan.upgrade.cancel.cta": "Garder mon forfait",
    "subscriber.plan.upgrade.changes_eyebrow": "Ce qui change",
    "subscriber.plan.upgrade.confirm.cta": "Confirmer · {amount} / mois",
    "subscriber.plan.upgrade.current_label": "Forfait actuel",
    "subscriber.plan.upgrade.current_template": "Actuellement : {plan}",
    "subscriber.plan.upgrade.effect.charge": "{date} · prélèvement de {amount}",
    "subscriber.plan.upgrade.effect.charge_pending": "Prochain cycle confirmé avant le prélèvement de {amount}",
    "subscriber.plan.upgrade.effect.same_worker": "Le bureau garde la continuité du service",
    "subscriber.plan.upgrade.effect_eyebrow": "Effet",
    "subscriber.plan.upgrade.error.network": "Modification impossible. Réessayez.",
    "subscriber.plan.upgrade.new_label": "Nouveau forfait",
    "subscriber.plan.upgrade.notice.cycle_effect": "Le nouveau prix s'applique dès le prochain prélèvement.",
    "subscriber.plan.upgrade.reactivate.success_title": "Abonnement réactivé",
    "subscriber.plan.upgrade.savings_label": "Économie / mois",
    "subscriber.plan.upgrade.success.body": "Le changement prend effet au prochain cycle. Le bureau vous contacte si un ajustement est nécessaire.",
    "subscriber.plan.upgrade.success.cta": "Compris",
    "subscriber.plan.upgrade.success.title": "Forfait mis à jour",
    "subscriber.privacy.account.body": "Nom · numéro · adresse · numéro Mobile Money · réponses facultatives de profil. Conservés tant que votre compte est actif.",
    "subscriber.privacy.account.title": "Données de compte",
    "subscriber.privacy.delete.cta": "Supprimer mon compte",
    "subscriber.privacy.export.cta": "Télécharger mes données",
    "subscriber.privacy.export.reason": "Demande d'export depuis l'application abonnée.",
    "subscriber.privacy.export.submitted": "Demande reçue. Référence {requestId}.",
    "subscriber.privacy.header": "Vie privée & données",
    "subscriber.privacy.intro": "Voici les données que nous collectons et pourquoi nous les utilisons. Les durées de conservation figurent dans la politique de confidentialité.",
    "subscriber.privacy.location.body": "Utilisée uniquement pour le suivi en route (X-12). Échantillons chiffrés, supprimés après 30 min.",
    "subscriber.privacy.location.title": "Localisation",
    "subscriber.privacy.photos.body": "Avant / après — chiffrées, accessibles à vous et au bureau. Supprimées au bout de 12 mois.",
    "subscriber.privacy.photos.title": "Photos de visite",
    "subscriber.privacy.rights.body": "Demander l'export, la rectification ou la suppression de vos données à tout moment.",
    "subscriber.privacy.rights.title": "Vos droits",
    "subscriber.privacy.subtitle": "Ce que Washed sait sur vous, et pourquoi.",
    "subscriber.privacy.title": "Ce qu'on garde sur vous.",
    "subscriber.profile.account_ready": "Compte actif",
    "subscriber.profile.cta_signout": "Se déconnecter",
    "subscriber.profile.cta_support": "Aide & support",
    "subscriber.profile.detail.address": "Adresse",
    "subscriber.profile.detail.address_missing": "Adresse à compléter",
    "subscriber.profile.detail.adult": "Âge",
    "subscriber.profile.detail.adult_confirmed": "18 ans ou plus confirmé",
    "subscriber.profile.detail.email": "Email",
    "subscriber.profile.detail.email_missing": "Non renseigné",
    "subscriber.profile.detail.first_name": "Prénom",
    "subscriber.profile.detail.last_name": "Nom",
    "subscriber.profile.detail.missing": "À compléter",
    "subscriber.profile.detail.phone": "Téléphone",
    "subscriber.profile.details.title": "Informations du compte",
    "subscriber.profile.edit.body": "Mettez à jour le nom affiché et l'email de votre compte.",
    "subscriber.profile.edit.change_number_cta": "Changer de numéro",
    "subscriber.profile.edit.cta": "Modifier le profil",
    "subscriber.profile.edit.header": "Profil",
    "subscriber.profile.edit.phone_note": "Votre numéro change après vérification par SMS.",
    "subscriber.profile.edit.save_cta": "Enregistrer",
    "subscriber.profile.edit.success.title": "Profil enregistré",
    "subscriber.profile.edit.title": "Modifier vos informations",
    "subscriber.profile.eyebrow": "Profil",
    "subscriber.profile.identity.pending_name": "Compte Washed",
    "subscriber.profile.member_since": "Abonnée depuis {date}",
    "subscriber.profile.menu.address": "Adresse",
    "subscriber.profile.menu.appearance": "Apparence",
    "subscriber.profile.menu.client_insights": "Mieux vous connaître",
    "subscriber.profile.menu.client_insights_sub": "Âge, foyer, habitudes",
    "subscriber.profile.menu.label": "Paramètres",
    "subscriber.profile.menu.language": "Langue",
    "subscriber.profile.menu.notifications": "Notifications",
    "subscriber.profile.menu.personal_info": "Informations personnelles",
    "subscriber.profile.menu.personal_info_sub": "Nom, email, photo",
    "subscriber.profile.menu.privacy": "Vie privée & données",
    "subscriber.profile.photo.change": "Modifier la photo",
    "subscriber.profile.photo.input_label": "Photo de profil",
    "subscriber.rating.none": "Aucune note",
    "subscriber.rating.value": "{count} étoiles sur 5",
    "subscriber.rating.value_one": "1 étoile sur 5",
    "subscriber.referral.code_label": "Votre code",
    "subscriber.referral.cta_share": "Partager mon code",
    "subscriber.referral.post_visit_reveal_body": "Faites découvrir Washed à une amie et accompagnez-la pour son premier lavage.",
    "subscriber.referral.post_visit_reveal_title": "Faites découvrir Washed à un proche.",
    "subscriber.referral.share_message": "J'utilise Washed pour faire laver mon linge à domicile à Lomé. Installez l'app et saisissez mon code {code} : {link}",
    "subscriber.referral.signup_field_hint": "Vous avez été invitée ? Saisissez le code reçu de votre amie.",
    "subscriber.referral.signup_field_label": "Code de parrainage",
    "subscriber.referral.stats_pending": "En attente",
    "subscriber.referral.stats_qualified": "Confirmées",
    "subscriber.referral.status_merci": "Merci ! Votre amie a fait son premier lavage grâce à vous.",
    "subscriber.referral.subtitle": "Offrez Washed à une amie : partagez votre code et accompagnez-la dès son premier lavage.",
    "subscriber.referral.title": "Parrainer une amie",
    "subscriber.repassage.a11y.success_announcement": "Demande de repassage envoyée.",
    "subscriber.repassage.basket_hint": "1 panier ≈ 20 vêtements (hauts, pantalons, robes, boubous)",
    "subscriber.repassage.basket_label": "Paniers de linge",
    "subscriber.repassage.charge_timing_note": "Vous ne serez débité·e que lorsqu'un·e étudiant·e accepte la mission.",
    "subscriber.repassage.cta_submit": "Demander le repassage",
    "subscriber.repassage.date_label": "Date du passage",
    "subscriber.repassage.fee_service_label": "Frais Mixx/Flooz + SMS",
    "subscriber.repassage.fee_service_note": "Washed ne garde rien",
    "subscriber.repassage.fee_student_label": "Rémunération de l'étudiant·e",
    "subscriber.repassage.fee_student_note": "100 % reversé à votre étudiant·e",
    "subscriber.repassage.fee_total_label": "Total",
    "subscriber.repassage.history_badge": "Repassage",
    "subscriber.repassage.impact_note": "Chaque repassage soutient un·e étudiant·e de Lomé. Washed ne prend aucune marge.",
    "subscriber.repassage.quote_error": "Impossible d'afficher le prix pour le moment. Vérifiez votre connexion et réessayez.",
    "subscriber.repassage.status.accepted": "Accepté — passage prévu",
    "subscriber.repassage.status.cancelled": "Annulé",
    "subscriber.repassage.status.completed": "Repassé et plié",
    "subscriber.repassage.status.declined": "Refusé",
    "subscriber.repassage.status.expired": "Expiré",
    "subscriber.repassage.status.no_show": "Passage manqué",
    "subscriber.repassage.status.offered": "Proposé à un·e étudiant·e",
    "subscriber.repassage.status.paid": "Étudiant·e payé·e",
    "subscriber.repassage.status.requested": "Demandé",
    "subscriber.repassage.subtitle": "Un·e étudiant·e de Lomé vient demain repasser et plier votre linge propre.",
    "subscriber.repassage.success_body": "Nous contactons un·e étudiant·e. Vous serez notifié·e dès que votre repassage est accepté.",
    "subscriber.repassage.success_title": "Demande envoyée",
    "subscriber.repassage.title": "Repassage à domicile",
    "subscriber.repassage.window_afternoon": "Après-midi",
    "subscriber.repassage.window_label": "Créneau",
    "subscriber.repassage.window_morning": "Matin",
    "subscriber.signup.address.body": "Quartier puis détail (rue, repère).",
    "subscriber.signup.address.field.neighborhood": "Quartier",
    "subscriber.signup.address.field.street": "Rue / détail",
    "subscriber.signup.address.location.captured": "Position enregistrée ✓",
    "subscriber.signup.address.location.cta": "Utiliser ma position",
    "subscriber.signup.address.location.denied": "Utiliser ma position",
    "subscriber.signup.address.location.note": "Aide votre laveuse à vous trouver plus vite.",
    "subscriber.signup.address.location.requesting": "Localisation…",
    "subscriber.signup.address.neighborhood.placeholder": "Choisissez un quartier",
    "subscriber.signup.address.street.placeholder": "rue 254, maison bleue",
    "subscriber.signup.address.title": "Où passe la laveuse ?",
    "subscriber.signup.auth.error_generic": "Action impossible. Réessayez.",
    "subscriber.signup.auth.error_network": "Pas de connexion. Vérifiez le réseau puis réessayez.",
    "subscriber.signup.auth.error_not_subscriber": "Ce numéro n’est pas relié à un compte abonné.",
    "subscriber.signup.confirm.check_cta": "Vérifier",
    "subscriber.signup.confirm.checking_price": "Vérification du prix…",
    "subscriber.signup.confirm.extra_helper": "Personnel domestique ({count})",
    "subscriber.signup.confirm.extra_people": "Personnes en plus ({count})",
    "subscriber.signup.confirm.failed": "L’abonnement n’a pas été créé. Rien n’a été prélevé. Réessayez.",
    "subscriber.signup.confirm.first_charge": "Premier prélèvement quand le bureau confirme votre laveuse, avant votre premier passage. Les mois suivants sont prélevés avant leur premier passage.",
    "subscriber.signup.confirm.members_incomplete": "Votre abonnement est créé. Certaines personnes de votre foyer ne sont pas encore enregistrées.",
    "subscriber.signup.confirm.people": "Personnes",
    "subscriber.signup.confirm.people_solo": "Vous",
    "subscriber.signup.confirm.people_with": "Vous, {names}",
    "subscriber.signup.confirm.per_person": "Par personne",
    "subscriber.signup.confirm.plan_price": "Prix du forfait",
    "subscriber.signup.confirm.price_unavailable": "Le prix n’a pas pu être confirmé. Réessayez avant de vous abonner.",
    "subscriber.signup.confirm.restricted": "Votre compte ne peut pas prendre d’abonnement pour le moment. Contactez le bureau au {phone}.",
    "subscriber.signup.confirm.saving_members": "Enregistrement des personnes de votre foyer…",
    "subscriber.signup.confirm.title": "Vérifiez votre abonnement",
    "subscriber.signup.confirm.today": "À l’inscription",
    "subscriber.signup.confirm.today_amount": "0 F CFA",
    "subscriber.signup.confirm.unknown_body": "La connexion a été coupée pendant l’envoi. Rien n’a été prélevé. Vérifiez avant de renvoyer, pour ne rien créer en double.",
    "subscriber.signup.confirm.unknown_title": "Nous vérifions votre abonnement",
    "subscriber.signup.continue.cta": "Continuer",
    "subscriber.signup.identity.adult": "Je confirme avoir 18 ans ou plus.",
    "subscriber.signup.identity.body": "Le bureau utilise ces informations pour votre compte et vos reçus.",
    "subscriber.signup.identity.email.placeholder": "afi@email.com",
    "subscriber.signup.identity.field.email": "Email (facultatif)",
    "subscriber.signup.identity.field.first_name": "Prénom",
    "subscriber.signup.identity.field.last_name": "Nom",
    "subscriber.signup.identity.first_name.placeholder": "Afi",
    "subscriber.signup.identity.last_name.placeholder": "Mensah",
    "subscriber.signup.identity.title": "Vos informations",
    "subscriber.signup.members.add_cta": "Ajouter une personne",
    "subscriber.signup.members.birth_year_error": "Indiquez une année entre 1900 et {year}.",
    "subscriber.signup.members.person": "Personne {number}",
    "subscriber.signup.members.range": "Ajoutez de {min} à {max} personnes, en plus de vous.",
    "subscriber.signup.members.range_duo": "Ajoutez l’autre personne de votre forfait Duo.",
    "subscriber.signup.members.title": "Qui vit avec vous ?",
    "subscriber.signup.otp.body": "Six chiffres envoyés au {phone}.",
    "subscriber.signup.otp.call_office.cta": "Appeler le bureau",
    "subscriber.signup.otp.digit_label": "Chiffre {index}",
    "subscriber.signup.otp.edit_phone.cta": "Modifier",
    "subscriber.signup.otp.help_prefix": "Pas reçu après 30 s ?",
    "subscriber.signup.otp.resend": "Renvoyer dans {timer}",
    "subscriber.signup.otp.resend_now.cta": "Renvoyer le code",
    "subscriber.signup.otp.title": "Le code reçu par SMS",
    "subscriber.signup.payment.body": "Choisissez Mixx by Yas ou Flooz, puis entrez le numéro lié à ce fournisseur.",
    "subscriber.signup.payment.note": "Premier prélèvement avant votre première visite.",
    "subscriber.signup.payment.phone_error": "Vérifiez votre numéro {provider}.",
    "subscriber.signup.payment.phone_help": "Numéro {provider} à 8 chiffres.",
    "subscriber.signup.payment.phone_label": "Numéro Mobile Money",
    "subscriber.signup.payment.provider_label": "Fournisseur",
    "subscriber.signup.payment.title": "Ajoutez votre moyen de paiement",
    "subscriber.signup.phone.body": "On vous envoie un code à 6 chiffres pour confirmer.",
    "subscriber.signup.phone.cta": "Recevoir le code",
    "subscriber.signup.phone.input_label": "Numéro",
    "subscriber.signup.phone.placeholder": "90 12 34 56",
    "subscriber.signup.phone.privacy_note": "Confidentiel — non transmis à la laveuse.",
    "subscriber.signup.phone.title": "Votre numéro de téléphone",
    "subscriber.signup.plan.a_month": "par mois",
    "subscriber.signup.plan.continue_with": "Continuer avec {plan}",
    "subscriber.signup.plan.covers.foyer_extra": "5 personnes incluses, puis {price} F CFA par mois pour chaque personne en plus, jusqu’à {max} personnes.",
    "subscriber.signup.plan.currency_spoken": "francs CFA",
    "subscriber.signup.plan.eight_or_more": "8 personnes ou plus ?",
    "subscriber.signup.plan.frequency_question": "Combien de passages par mois ?",
    "subscriber.signup.plan.household_help": "Toutes les personnes dont le linge est lavé, vous compris.",
    "subscriber.signup.plan.household_question": "Combien êtes-vous à la maison ?",
    "subscriber.signup.plan.no_payment_today": "Rien à payer à l’inscription. Prélèvement à la confirmation de votre laveuse, avant la première visite.",
    "subscriber.signup.plan.per_month": "F CFA par mois",
    "subscriber.signup.plan.prices_unavailable": "Les prix n’ont pas pu être chargés. Vérifiez votre connexion et réessayez.",
    "subscriber.signup.plan.selected": "Votre forfait · {plan}",
    "subscriber.signup.plan.title": "Votre forfait",
    "subscriber.signup.plan.unit_many": "personnes",
    "subscriber.signup.plan.unit_one": "personne",
    "subscriber.signup.plan.value.per_person": "{price} F CFA par personne",
    "subscriber.signup.plan.value.per_visit": "{price} F CFA par passage",
    "subscriber.signup.plan.visits_row_one": "1 passage",
    "subscriber.signup.plan.visits_row_two": "2 passages",
    "subscriber.signup.retry_cta": "Réessayer",
    "subscriber.signup.review.consent.connector": "et la",
    "subscriber.signup.review.consent.prefix": "J'accepte les",
    "subscriber.signup.review.consent.privacy": "politique de confidentialité",
    "subscriber.signup.review.consent.terms": "conditions",
    "subscriber.signup.review.cta": "Confirmer l'abonnement",
    "subscriber.signup.review.eyebrow": "Récap",
    "subscriber.signup.review.field.address": "Adresse",
    "subscriber.signup.review.field.identity": "Compte",
    "subscriber.signup.review.field.payment": "Paiement",
    "subscriber.signup.review.field.tier": "Forfait",
    "subscriber.signup.review.field.total": "Total mensuel",
    "subscriber.signup.review.next_step.body": "Votre laveuse vous appellera pour caler la première visite.",
    "subscriber.signup.review.title": "Tout est bon ?",
    "subscriber.signup.step_indicator": "Étape {current} / {total}",
    "subscriber.signup.tier.available_badge": "disponible",
    "subscriber.signup.tier.body": "Un forfait simple, sans surprise. Vous pouvez changer plus tard.",
    "subscriber.signup.tier.cta_continue_amount": "Continuer · {amount}",
    "subscriber.signup.tier.d1.label": "1 visite / mois · 2 personnes",
    "subscriber.signup.tier.d1.price": "6 000 XOF",
    "subscriber.signup.tier.d2.label": "2 visites / mois · 2 personnes",
    "subscriber.signup.tier.d2.price": "11 500 XOF",
    "subscriber.signup.tier.f1.label": "1 visite / mois · 3 à 5 personnes",
    "subscriber.signup.tier.f1.price": "9 500 XOF",
    "subscriber.signup.tier.f2.label": "2 visites / mois · 3 à 5 personnes",
    "subscriber.signup.tier.f2.price": "18 000 XOF",
    "subscriber.signup.tier.pricing_note": "Prix validé avant chaque prélèvement Mobile Money.",
    "subscriber.signup.tier.selected_badge": "sélectionné",
    "subscriber.signup.tier.t1.label": "1 visite / mois · 1 personne",
    "subscriber.signup.tier.t1.price": "4 500 XOF",
    "subscriber.signup.tier.t2.label": "2 visites / mois · 1 personne",
    "subscriber.signup.tier.t2.price": "8 500 XOF",
    "subscriber.signup.tier.title": "Choisissez votre rythme",
    "subscriber.signup.wallet.title": "Votre Mobile Money",
    "subscriber.signup.welcome.body": "Votre abonnement est prêt. Choisissez maintenant le jour et le moment de votre première visite.",
    "subscriber.signup.welcome.cta": "Planifier ma première visite",
    "subscriber.signup.welcome.skip_cta": "Passer pour le moment",
    "subscriber.signup.welcome.title": "Bienvenue chez Washed.",
    "subscriber.splash.cta_continue": "Continuer",
    "subscriber.splash.cta_existing": "J'ai déjà un compte",
    "subscriber.splash.tagline": "L'app abonné · Lomé",
    "subscriber.status.cancelled": "Visite du {date} annulée.",
    "subscriber.status.moved": "Déplacée, au lieu du {date}",
    "subscriber.status.moved_spoken": "Visite déplacée. Elle était prévue le {date}.",
    "subscriber.status.rated": "Merci, votre note est envoyée.",
    "subscriber.status.rated_low": "Note envoyée. Un souci pendant cette visite ?",
    "subscriber.status.reported": "Problème signalé · le bureau l’examine",
    "subscriber.status.reported_spoken": "Problème signalé. Le bureau l’examine. Sa réponse s’affichera ici.",
    "subscriber.support.contact.category.other": "Autre",
    "subscriber.support.contact.category.payment": "Paiement Mobile Money",
    "subscriber.support.contact.category.plan": "Mon abonnement · pause, changement, fin",
    "subscriber.support.contact.category.visit": "Une visite · annulation, report, problème",
    "subscriber.support.contact.category.worker": "Ma laveuse · changement, retour, autre",
    "subscriber.support.contact.header": "Contacter le bureau",
    "subscriber.support.contact.message.label": "Votre message",
    "subscriber.support.contact.message.placeholder": "Décrivez en quelques mots…",
    "subscriber.support.contact.subject.label": "Sujet",
    "subscriber.support.contact.subject.placeholder": "Résumez votre demande",
    "subscriber.support.contact.submit.cta": "Envoyer au bureau",
    "subscriber.support.contact.submit.error": "Impossible d'envoyer. Vérifiez votre connexion et réessayez.",
    "subscriber.support.contact.submitted.body": "Ticket #{ticketId} créé. La réponse arrivera dans Vos demandes.",
    "subscriber.support.contact.submitted.body_pending": "Votre demande a été reçue. La réponse arrivera dans Vos demandes.",
    "subscriber.support.contact.submitted.card_eyebrow": "Votre demande · #{ticketId}",
    "subscriber.support.contact.submitted.card_eyebrow_pending": "Votre demande",
    "subscriber.support.contact.submitted.card_status": "Ouvert · en attente du bureau",
    "subscriber.support.contact.submitted.created_label": "Ticket créé",
    "subscriber.support.contact.submitted.home_cta": "Retour à l'accueil",
    "subscriber.support.contact.submitted.tickets_cta": "Voir mes tickets",
    "subscriber.support.contact.submitted.title": "Message envoyé",
    "subscriber.support.contact.title": "De quoi voulez-vous parler ?",
    "subscriber.support.help.call.detail": "{phone} · lun-sam 7 h-19 h",
    "subscriber.support.help.call.title": "Appeler le bureau",
    "subscriber.support.help.contact.eyebrow": "Joindre le bureau",
    "subscriber.support.help.eyebrow": "Aide",
    "subscriber.support.help.faq.cancel.answer": "Depuis le détail de visite, choisissez Reporter. Le bureau confirme le nouveau créneau.",
    "subscriber.support.help.faq.cancel.question": "Comment annuler une visite ?",
    "subscriber.support.help.faq.damage.answer": "Signalez un souci depuis la visite. Ajoutez des photos si possible.",
    "subscriber.support.help.faq.damage.question": "Le linge a été abîmé. Que faire ?",
    "subscriber.support.help.faq.eyebrow": "Questions fréquentes",
    "subscriber.support.help.faq.missed.answer": "Appelez le bureau. On vérifie la tournée et on vous rappelle.",
    "subscriber.support.help.faq.missed.question": "Que faire si la laveuse ne vient pas ?",
    "subscriber.support.help.faq.payment.answer": "Dans Forfait, ouvrez Moyen de paiement puis enregistrez le nouveau numéro.",
    "subscriber.support.help.faq.payment.question": "Comment changer de Mobile Money ?",
    "subscriber.support.help.faq.worker.answer": "Oui, le bureau examine la demande sans annuler votre prochaine visite.",
    "subscriber.support.help.faq.worker.question": "Puis-je changer de laveuse ?",
    "subscriber.support.help.tickets.cta": "Mes tickets · {openCount} ouvert",
    "subscriber.support.help.title": "On vous écoute",
    "subscriber.support.help.whatsapp.detail": "{phone}",
    "subscriber.support.help.whatsapp.title": "Écrire sur WhatsApp",
    "subscriber.support.help.write.cta": "Écrire au bureau",
    "subscriber.support.retry.cta": "Réessayer",
    "subscriber.support.ticket.detail.header": "Ticket #{ticketId}",
    "subscriber.support.ticket.detail.load.error": "Impossible de charger ce ticket. Réessayez.",
    "subscriber.support.ticket.detail.load_failed.title": "Impossible d'afficher la demande",
    "subscriber.support.ticket.detail.message_office_label": "Message bureau",
    "subscriber.support.ticket.detail.message_subscriber_label": "Message abonné",
    "subscriber.support.ticket.detail.not_found.body": "Cette demande n'est pas liée à votre compte.",
    "subscriber.support.ticket.detail.not_found.cta": "Voir mes tickets",
    "subscriber.support.ticket.detail.not_found.title": "Demande introuvable",
    "subscriber.support.ticket.detail.office_label": "Bureau · {timeAgo}",
    "subscriber.support.ticket.detail.photo.pull": "Pull · 1",
    "subscriber.support.ticket.detail.photo.shirts": "Chemises · 2",
    "subscriber.support.ticket.detail.reply.cta": "Envoyer",
    "subscriber.support.ticket.detail.reply.error": "Impossible d'envoyer votre réponse. Réessayez.",
    "subscriber.support.ticket.detail.reply.just_now": "à l'instant",
    "subscriber.support.ticket.detail.reply.label": "Répondre",
    "subscriber.support.ticket.detail.reply.placeholder": "Répondre…",
    "subscriber.support.ticket.detail.retry": "Réessayer",
    "subscriber.support.ticket.detail.status.open": "En cours",
    "subscriber.support.ticket.detail.status.resolved": "Résolu",
    "subscriber.support.ticket.detail.user_label": "Vous · {timeAgo}",
    "subscriber.support.tickets.empty.body": "Vos messages au bureau apparaîtront ici.",
    "subscriber.support.tickets.empty.title": "Aucune demande",
    "subscriber.support.tickets.header": "Mes tickets",
    "subscriber.support.tickets.load.error": "Impossible de charger vos tickets. Réessayez.",
    "subscriber.support.tickets.open.progress": "{agentName} enquête",
    "subscriber.support.tickets.open_request.cta": "Ouvrir une demande",
    "subscriber.support.tickets.status.open": "#{ticketId} · Ouvert",
    "subscriber.support.tickets.status.resolved": "#{ticketId} · Résolu",
    "subscriber.support.tickets.title": "Vos demandes",
    "subscriber.system.maintenance.body": "On améliore quelque chose pour vous. L'app revient dans {minutes} minutes environ.",
    "subscriber.system.maintenance.emergency": "En cas d'urgence, appelez le bureau au {phone}.",
    "subscriber.system.maintenance.next_visit": "Votre prochaine visite",
    "subscriber.system.maintenance.next_visit_line": "{date} · {time} · {name}",
    "subscriber.system.maintenance.next_visit_line_assignment": "{date} · {time} · assignation en cours",
    "subscriber.system.maintenance.no_impact": "Maintenue · pas d'impact.",
    "subscriber.system.maintenance.title": "Maintenance en cours.",
    "subscriber.system.offline.greeting": "Bonjour {name}",
    "subscriber.system.offline.next_visit": "Prochaine visite",
    "subscriber.system.offline.retry_cta": "Réessayer",
    "subscriber.system.offline.retry_hint": "On vérifie le réseau toutes les 30 secondes.",
    "subscriber.system.offline.status": "Hors ligne · dernière MAJ {time}",
    "subscriber.system.offline.worker_cache_label": "Laveuse en cache",
    "subscriber.system.offline.worker_hidden": "infos cachées localement",
    "subscriber.system.update.body": "Mises à jour de sécurité importantes. La version actuelle ne fonctionne plus à partir d'aujourd'hui.",
    "subscriber.system.update.cta": "Mettre à jour",
    "subscriber.system.update.item.reveal": "Reveal photos plus rapide",
    "subscriber.system.update.item.security": "Correctifs de sécurité",
    "subscriber.system.update.item.tracking": "Meilleur suivi en route",
    "subscriber.system.update.title_prefix": "Une nouvelle version",
    "subscriber.system.update.title_suffix": "est disponible.",
    "subscriber.system.update.whats_new": "Quoi de neuf",
    "subscriber.toast.booking.success": "Demande envoyée",
    "subscriber.toast.notification.disabled": "Notification désactivée",
    "subscriber.toast.notification.enabled": "Notification activée",
    "subscriber.toast.notification.error": "Échec de la mise à jour",
    "subscriber.toast.pause.error": "Échec de la mise en pause",
    "subscriber.toast.pause.success": "Abonnement mis en pause",
    "subscriber.toast.payment_method.success": "Méthode de paiement mise à jour",
    "subscriber.toast.repassage.error": "Impossible d'envoyer la demande de repassage.",
    "subscriber.toast.resume.error": "Échec de la reprise",
    "subscriber.toast.resume.success": "Abonnement repris",
    "subscriber.toast.tier_change.error": "Échec du changement de forfait",
    "subscriber.toast.tier_change.success": "Forfait mis à jour",
    "subscriber.tour.a11y_dismiss": "Fermer le guide de démarrage",
    "subscriber.tour.cta_done": "Commencer",
    "subscriber.tour.cta_next": "Suivant",
    "subscriber.tour.eyebrow": "Première session",
    "subscriber.tour.new_chip": "nouveau",
    "subscriber.tour.step1.body": "Planification, forfait et aide sont toujours à portée avant la première visite.",
    "subscriber.tour.step1.card_body": "Touchez Planifier pour choisir votre premier créneau.",
    "subscriber.tour.step1.title": "Votre accueil commence ici",
    "subscriber.tour.step2.body": "Le bureau sélectionne une prestataire de votre quartier. Vous la voyez ici avant chaque passage.",
    "subscriber.tour.step2.card_body": "Touchez Prestataire pour voir son profil.",
    "subscriber.tour.step2.title": "Votre laveuse, choisie pour vous",
    "subscriber.tour.step3.body": "Modifiez le forfait, mettez en pause ou suivez vos paiements depuis l'onglet Forfait.",
    "subscriber.tour.step3.card_body": "Touchez Forfait pour explorer vos options.",
    "subscriber.tour.step3.title": "Votre forfait, toujours sous contrôle",
    "subscriber.tour.step_indicator": "{current} / {total}",
    "subscriber.upgrade.price_per_month": "{price} / mois",
    "subscriber.visit.action_menu.a11y_actions_button_hint": "Ouvre les actions disponibles pour cette visite.",
    "subscriber.visit.action_menu.action_cancel": "Annuler la visite",
    "subscriber.visit.action_menu.action_rate": "Évaluer la laveuse",
    "subscriber.visit.action_menu.action_report_issue": "Signaler un problème",
    "subscriber.visit.action_menu.action_reschedule": "Reprogrammer la visite",
    "subscriber.visit.action_menu.dismiss": "Fermer",
    "subscriber.visit.action_menu.open_menu": "Actions",
    "subscriber.visit.action_menu.sheet_title": "Actions",
    "subscriber.visit.arrived.toast": "{name} est devant chez vous.",
    "subscriber.visit.cancel.a11y.submitting": "Annulation en cours",
    "subscriber.visit.cancel.body": "Nous prévenons votre laveuse. Cette visite ne sera ni remplacée ni remboursée.",
    "subscriber.visit.cancel.confirm.cta": "Confirmer l'annulation",
    "subscriber.visit.cancel.error.network": "Erreur réseau. Réessayez.",
    "subscriber.visit.cancel.keep.cta": "Garder la visite",
    "subscriber.visit.cancel.kicker": "Annuler",
    "subscriber.visit.cancel.success.body": "La laveuse a été prévenue. Votre prochaine visite confirmée apparaîtra dans l'accueil.",
    "subscriber.visit.cancel.success.cta": "Retour à l'accueil",
    "subscriber.visit.cancel.success.kicker": "Confirmé",
    "subscriber.visit.cancel.success.title": "Visite annulée.",
    "subscriber.visit.cancel.title": "Annuler cette visite ?",
    "subscriber.visit.complete.toast": "Visite terminée. {name} est partie.",
    "subscriber.visit.detail.address.label": "Adresse",
    "subscriber.visit.detail.body": "Le bureau suit cette visite jusqu'au passage.",
    "subscriber.visit.detail.body_with_worker": "{name} est prévue pour cette visite. Washed garde le suivi.",
    "subscriber.visit.detail.duration.label": "Durée prévue",
    "subscriber.visit.detail.kicker": "Prochaine visite",
    "subscriber.visit.detail.report.cta": "Reporter la visite",
    "subscriber.visit.detail.report_note": "Vous pouvez reporter jusqu'à 18 h la veille.",
    "subscriber.visit.detail.tier.label": "Forfait",
    "subscriber.visit.detail.title": "Mardi 7 mai · 9:00",
    "subscriber.visit.enroute.distance_label": "Distance",
    "subscriber.visit.enroute.distance_live": "Suivi actif",
    "subscriber.visit.enroute.eta_label": "Arrive dans",
    "subscriber.visit.enroute.eta_live": "En route",
    "subscriber.visit.enroute.eyebrow": "En route · {time}",
    "subscriber.visit.enroute.home_label": "Votre foyer",
    "subscriber.visit.enroute.map_label": "Carte de suivi",
    "subscriber.visit.enroute.metrics_label": "Statut du trajet",
    "subscriber.visit.enroute.signal_lost": "Signal perdu · dernière position connue",
    "subscriber.visit.enroute.status_label": "Statut",
    "subscriber.visit.enroute.title": "{name} est en route.",
    "subscriber.visit.enroute.title_template": "{name} est en route",
    "subscriber.visit.enroute.update_note": "Mise à jour toutes les {cadence}",
    "subscriber.visit.feedback.good": "Tout va bien",
    "subscriber.visit.feedback.issue": "Signaler un souci",
    "subscriber.visit.feedback.prompt": "Tout s'est bien passé ?",
    "subscriber.visit.in_progress.body": "Vous pouvez fermer l'app. On vous prévient quand c'est fini.",
    "subscriber.visit.in_progress.close_cta": "Fermer l'app sereinement",
    "subscriber.visit.in_progress.since_template": "depuis {minutes} min",
    "subscriber.visit.in_progress.started_body": "{name} a démarré la visite à {time}.",
    "subscriber.visit.in_progress.started_body_pending": "Le bureau suit le démarrage de la visite.",
    "subscriber.visit.in_progress.started_title": "Démarrage",
    "subscriber.visit.in_progress.status": "Visite en cours",
    "subscriber.visit.in_progress.timeline.arrival": "Arrivée",
    "subscriber.visit.in_progress.title": "Votre linge est pris en charge",
    "subscriber.visit.issue.header": "Signaler un souci",
    "subscriber.visit.issue.option.behavior": "Comportement inapproprié",
    "subscriber.visit.issue.option.damaged": "Linge endommagé",
    "subscriber.visit.issue.option.missing": "Linge manquant",
    "subscriber.visit.issue.option.no_show": "La laveuse n'est pas venue",
    "subscriber.visit.issue.option.other": "Autre · décrire",
    "subscriber.visit.issue.option.poor_wash": "Linge mal lavé",
    "subscriber.visit.issue.photo.add.cta": "Ajouter des photos",
    "subscriber.visit.issue.photo.body": "Montrez le linge ou le détail concerné. Le bureau les vérifie avant de vous rappeler.",
    "subscriber.visit.issue.photo.count_many": "{count} photos ajoutées",
    "subscriber.visit.issue.photo.count_one": "1 photo ajoutée",
    "subscriber.visit.issue.photo.empty": "Aucune photo ajoutée",
    "subscriber.visit.issue.photo.required": "Ajoutez au moins une photo pour envoyer le signalement.",
    "subscriber.visit.issue.photo.submit.cta": "Envoyer le signalement",
    "subscriber.visit.issue.photo.title": "Ajoutez des photos du souci.",
    "subscriber.visit.issue.title": "Dites-nous ce qui ne va pas",
    "subscriber.visit.morning.banner": "{name} arrive aujourd'hui à {time}.",
    "subscriber.visit.reschedule.a11y.submitting": "Enregistrement de la nouvelle date",
    "subscriber.visit.reschedule.body": "Le bureau confirme le report et ajuste l'assignation si le créneau change.",
    "subscriber.visit.reschedule.confirm.cta": "Confirmer le report",
    "subscriber.visit.reschedule.error.change_closed": "Cette visite ne peut plus être déplacée dans l'application : les changements ferment à 18 h la veille. Appelez le bureau.",
    "subscriber.visit.reschedule.error.date_closed": "Ce jour n'est plus possible : les changements ferment à 18 h la veille. Choisissez un autre jour.",
    "subscriber.visit.reschedule.error.network": "Erreur réseau. Réessayez.",
    "subscriber.visit.reschedule.error.past_date": "Choisissez une date future.",
    "subscriber.visit.reschedule.field.date": "Date",
    "subscriber.visit.reschedule.field.window": "Créneau",
    "subscriber.visit.reschedule.field.window.afternoon": "Après-midi (13 h–17 h)",
    "subscriber.visit.reschedule.field.window.morning": "Matin (8 h–12 h)",
    "subscriber.visit.reschedule.header": "Reporter une visite",
    "subscriber.visit.reschedule.kicker": "REPROGRAMMER",
    "subscriber.visit.reschedule.note": "Aucun de ces créneaux ? Le bureau vous rappelle.",
    "subscriber.visit.reschedule.option.same_zone": "{time} · même créneau de zone",
    "subscriber.visit.reschedule.option.usual": "{time} · horaire habituel",
    "subscriber.visit.reschedule.option.worker_available": "{time} · créneau proposé",
    "subscriber.visit.reschedule.options_label": "Créneaux proposés",
    "subscriber.visit.reschedule.title": "Choisissez un nouveau créneau",
    "subscriber.visit.reschedule.window.afternoon": "Après-midi (13 h–17 h)",
    "subscriber.visit.reschedule.window.morning": "Matin (8 h–12 h)",
    "subscriber.visit.return_home.cta": "Retour à l'accueil",
    "subscriber.visit.reveal.after": "Après — {hour} h {min}",
    "subscriber.visit.reveal.before": "Avant — {hour} h {min}",
    "subscriber.visit.reveal.completed_note": "{name} est partie à {time}. Durée {duration}.",
    "subscriber.visit.reveal.completed_note_generic": "Visite terminée à {time}. Durée {duration}.",
    "subscriber.visit.reveal.completed_title": "Visite terminée.",
    "subscriber.visit.reveal.dispute.status.open": "en cours d'examen",
    "subscriber.visit.reveal.dispute.status.resolved_subscriber": "résolu en votre faveur",
    "subscriber.visit.reveal.dispute.status.resolved_worker": "clos après examen",
    "subscriber.visit.reveal.dispute_template": "Problème signalé · {status}",
    "subscriber.visit.reveal.duration.hours_minutes_template": "{hours} h {minutes}",
    "subscriber.visit.reveal.duration.hours_template": "{hours} h",
    "subscriber.visit.reveal.duration.minutes_template": "{minutes} min",
    "subscriber.visit.reveal.photo_unavailable": "Photo non disponible",
    "subscriber.visit.reveal.photos_label": "Photos avant et après",
    "subscriber.visit.reveal.rate_cta": "Noter la visite",
    "subscriber.visit.reveal.recap_title": "Récap",
    "subscriber.visit.reveal.timeline.end": "Fin",
    "subscriber.visit.reveal.timeline.start": "Démarrage",
    "subscriber.visit.reveal.timeline.wash": "Lavage",
    "subscriber.visit.reveal.timeline_unavailable": "Non disponible",
    "subscriber.visit.reveal.title": "Voilà ce que ça donne.",
    "subscriber.visit.reveal.your_rating": "Votre note",
    "subscriber.visit.status.cancelled": "Annulée",
    "subscriber.visit.status.completed": "Terminée",
    "subscriber.visit.status.en_route": "En route",
    "subscriber.visit.status.in_progress": "En cours",
    "subscriber.visit.status.no_show": "Passage manqué",
    "subscriber.visit.status.pending_review": "À vérifier",
    "subscriber.visit.status.scheduled": "Planifiée",
    "subscriber.visit.status.unknown": "Statut inconnu",
    "subscriber.visit.support.body": "Le bureau vous rappelle dans la journée. La laveuse ne voit pas ce signalement.",
    "subscriber.visit.support.submit.cta": "Suivant · ajouter photos",
    "subscriber.visit.support.submitted.body": "Signalement #0421 créé. La réponse s’affichera sur la page de la visite.",
    "subscriber.visit.support.submitted.body_live": "Signalement #{id} créé. La réponse s’affichera sur la page de la visite.",
    "subscriber.visit.support.submitted.ticket_cta": "Voir mon ticket",
    "subscriber.visit.support.submitted.title": "Signalement reçu.",
    "subscriber.visit.thanks.body": "Merci. Le bureau garde votre retour avec l'historique de service.",
    "subscriber.visit.thanks.counter_line": "Suivi Washed depuis {since}",
    "subscriber.visit.thanks.counter_title": "Votre compteur",
    "subscriber.visit.thanks.title": "Merci.",
    "subscriber.visit.window.afternoon": "Après-midi",
    "subscriber.visit.window.morning": "Matin",
    "subscriber.worker.change.a11y.description_label": "Détails de la demande, facultatif",
    "subscriber.worker.change.a11y.reason_required": "Choisissez un motif pour envoyer la demande",
    "subscriber.worker.change.a11y.submitting": "Envoi de la demande de changement",
    "subscriber.worker.change.a11y.success_announcement": "Demande de changement envoyée",
    "subscriber.worker.change.body": "Le bureau vous appelle dans la journée pour comprendre. {name} ne voit pas cette demande.",
    "subscriber.worker.change.description.label": "Détail utile au bureau (facultatif)",
    "subscriber.worker.change.description.not_sent_notice": "Pour cette première version, seul le motif sélectionné est transmis. Le détail ci-dessous nous aidera à améliorer la prochaine version.",
    "subscriber.worker.change.description.placeholder": "Ajoutez un détail utile au bureau.",
    "subscriber.worker.change.error.network": "Envoi impossible. Réessayez.",
    "subscriber.worker.change.keyboard.done": "Terminé",
    "subscriber.worker.change.note.body": "Délai habituel pour changement : 1 à 2 semaines. La prochaine visite est maintenue avec {name}.",
    "subscriber.worker.change.note.title": "À noter",
    "subscriber.worker.change.reason.availability": "Disponibilité",
    "subscriber.worker.change.reason.availability.sub": "mes horaires ont changé",
    "subscriber.worker.change.reason.behavior": "Souci de comportement",
    "subscriber.worker.change.reason.incident": "Incident",
    "subscriber.worker.change.reason.incident.sub": "problème non résolu",
    "subscriber.worker.change.reason.other": "Autre",
    "subscriber.worker.change.reason.personal": "Préférence personnelle",
    "subscriber.worker.change.reason.preference": "Préférence",
    "subscriber.worker.change.reason.preference.sub": "je préfère essayer une autre personne",
    "subscriber.worker.change.reason.quality": "Souci de qualité du travail",
    "subscriber.worker.change.reason.schedule": "{name} a déménagé / changé d'horaire",
    "subscriber.worker.change.submit.cta": "Envoyer la demande",
    "subscriber.worker.change.submitted.body": "Le bureau vous appelle dans la journée. La prochaine visite reste maintenue avec {name}.",
    "subscriber.worker.change.submitted.cta": "Compris",
    "subscriber.worker.change.submitted.title": "Demande envoyée",
    "subscriber.worker.change.title": "Pourquoi voulez-vous changer ?",
    "subscriber.worker.profile.change.cta": "Demander un changement",
    "subscriber.worker.profile.header": "Profil de la laveuse",
    "subscriber.worker.profile.location": "{neighborhood} · vit avec sa famille à {distance} de chez vous",
    "subscriber.worker.profile.location_live": "{neighborhood} · assignation active",
    "subscriber.worker.profile.location_live_generic": "Assignation suivie par Washed",
    "subscriber.worker.profile.path.body": "Laveuse depuis {since}. {households} foyers réguliers à Lomé. Parle {languages}.",
    "subscriber.worker.profile.path.body_live": "{name} intervient actuellement sur vos prochaines visites.",
    "subscriber.worker.profile.path.title": "Son parcours",
    "subscriber.worker.profile.relation.active": "assignation active",
    "subscriber.worker.profile.relation.months": "{months} mois",
    "subscriber.worker.profile.relation.title": "Votre relation",
    "subscriber.worker.profile.relation.together": "ensemble",
    "subscriber.worker.profile.relation.visits": "visites",
    "subscriber.worker.profile.reliability.body": "{visits} visites · {cancellations} annulation de son fait · {onTimeRate}% à l'heure ce mois-ci.",
    "subscriber.worker.profile.reliability.body_live": "{visits} visites terminées sur votre forfait.",
    "subscriber.worker.profile.reliability.rating_pending": "Note disponible après plus de visites",
    "subscriber.worker.profile.reliability.title": "Fiabilité",
    "survey.confirm": "Confirmer →",
    "survey.error.consent": "Veuillez accepter d'être recontacté·e pour laisser vos coordonnées (ou passez cette étape).",
    "survey.error.email": "Vérifiez l’email et réessayez.",
    "survey.error.phone": "Vérifiez le numéro et réessayez.",
    "survey.error.submit": "L’envoi n’a pas abouti. Réessayez.",
    "survey.eyebrow": "Question {current} / {total}",
    "survey.nav.back": "← Retour",
    "survey.nav.back.aria": "Question précédente",
    "survey.page.meta": "Aidez Washed à mieux comprendre les habitudes de linge à Lomé. 2 minutes, 10 questions.",
    "survey.page.title": "Washed · Sondage · 2 minutes pour Lomé",
    "survey.progress.aria": "Progression du sondage",
    "survey.q1.option.none": "Non, je lave moi-même",
    "survey.q1.option.regular": "Oui, régulièrement",
    "survey.q1.option.sometimes": "Oui, parfois",
    "survey.q1.text": "Avez-vous actuellement une laveuse qui passe chez vous ?",
    "survey.q10.aria.consent": "Consentement",
    "survey.q10.aria.email": "Votre adresse email",
    "survey.q10.aria.phone": "Votre numéro de téléphone",
    "survey.q10.consent_label": "Si vous laissez vos coordonnées, j'accepte que Washed les conserve pour me contacter quand le service est disponible chez moi.",
    "survey.q10.optional_hint": "Téléphone ou email. Les deux sont optionnels. Nous vous écrirons uniquement quand Washed sera disponible chez vous.",
    "survey.q10.placeholder.email": "votre@email.com",
    "survey.q10.placeholder.phone": "+228 90 12 34 56",
    "survey.q10.submit.no_contact": "Envoyer mes réponses →",
    "survey.q10.submit.with_contact": "Terminer →",
    "survey.q10.text": "Votre numéro pour que Washed vous recontacte ?",
    "survey.q2.option.biweekly": "Toutes les deux semaines",
    "survey.q2.option.monthly": "Une fois par mois",
    "survey.q2.option.on_demand": "Quand j'en ai besoin / cela varie",
    "survey.q2.option.weekly": "Toutes les semaines",
    "survey.q2.text": "À quelle fréquence vient-elle ?",
    "survey.q3.option.2_3k": "2 000 – 3 000 XOF",
    "survey.q3.option.3_5k": "3 000 – 5 000 XOF",
    "survey.q3.option.5_10k": "5 000 – 10 000 XOF",
    "survey.q3.option.over_10k": "Plus de 10 000 XOF",
    "survey.q3.option.under_2k": "Moins de 2 000 XOF",
    "survey.q3.option.varies": "Cela varie",
    "survey.q3.text": "Combien la payez-vous par mois ?",
    "survey.q4.option.alone": "Seulement pour moi",
    "survey.q4.option.partial": "Pour plusieurs personnes (mais pas tout le foyer)",
    "survey.q4.option.whole_household": "Pour tout le foyer ensemble",
    "survey.q4.text": "Lave-t-elle pour vous seul·e, ou pour tout le foyer ?",
    "survey.q5.multi_hint": "Sélectionnez tout ce qui s'applique, puis confirmez.",
    "survey.q5.option.disappears": "Elle disparaît parfois sans prévenir",
    "survey.q5.option.lost_damaged": "Linge perdu ou abîmé",
    "survey.q5.option.none": "Aucune frustration",
    "survey.q5.option.price_changes": "Le prix change",
    "survey.q5.option.quality": "La qualité varie",
    "survey.q5.option.unreliable": "Elle n'est pas fiable (vient quand elle veut)",
    "survey.q5.text": "Quelle est votre plus grande frustration avec votre laveuse actuelle ?",
    "survey.q6.option.1": "1 personne",
    "survey.q6.option.2_3": "2 ou 3 personnes",
    "survey.q6.option.4_5": "4 ou 5 personnes",
    "survey.q6.option.6_plus": "6 personnes ou plus",
    "survey.q6.text": "Combien de personnes vivent dans votre foyer ?",
    "survey.q7.text": "Seriez-vous prêt·e à payer 2 500 XOF/mois pour une visite par mois d'une laveuse formée et vérifiée ?",
    "survey.q7q8.option.no": "Non",
    "survey.q7q8.option.unsure": "Je ne sais pas",
    "survey.q7q8.option.yes_definitely": "Oui, sans hésiter",
    "survey.q7q8.option.yes_maybe": "Oui, peut-être",
    "survey.q8.text": "Et 4 500 XOF/mois pour deux visites par mois ?",
    "survey.q9.aria": "Votre quartier",
    "survey.q9.optional_hint": "Optionnel. Nous aide à organiser les visites par quartier.",
    "survey.q9.placeholder": "Ex. Tokoin-Hôpital, Bè-Kpota…",
    "survey.q9.text": "Votre quartier à Lomé ?",
    "survey.skip": "Passer",
    "survey.submitting": "Envoi…",
    "survey.thanks.body": "Vos réponses aident Washed à construire le service que votre foyer mérite.",
    "survey.thanks.home_link": "Voir le site Washed",
    "survey.thanks.share_button": "Partager le sondage",
    "survey.thanks.share_message": "Bonjour 👋 Aidez Washed à mieux comprendre le linge à Lomé, 2 minutes seulement : https://washedafrica.com/sondage",
    "survey.thanks.title": "Merci 🙏",
    "survey.turnstile.error": "Veuillez compléter la vérification anti-robot avant d'envoyer.",
    "whatsapp.washer.payout_destination_set": "WASHED : votre paie sera désormais envoyée sur {wallet}. Si vous ne l’avez pas demandé, répondez FRAUDE à ce message et le bureau vous contactera.",
    "worker.app.offline_banner.failed": "{count} action(s) en échec. L'équipe vous contactera.",
    "worker.app.offline_banner.offline": "Hors ligne — vos actions sont enregistrées.",
    "worker.app.offline_banner.queued": "{count} action(s) en attente de synchronisation.",
    "worker.app.offline_banner.syncing": "Synchronisation en cours…",
    "worker.auth.w_01.cta_primary": "Continuer",
    "worker.auth.w_01.cta_secondary": "J'ai déjà un compte",
    "worker.auth.w_01.kicker": "CHARGEMENT",
    "worker.auth.w_01.note": "Marque + tag · 2 boutons. Sync silencieuse en arrière-plan.",
    "worker.auth.w_01.tag": "l'app laveuse · lomé",
    "worker.auth.w_01.title": "Washed",
    "worker.auth.w_02.copy": "Tapez votre code à 4 chiffres pour démarrer la journée.",
    "worker.auth.w_02.cta": "Démarrer la journée",
    "worker.auth.w_02.demo_copy": "Tapez sur un compte démo (PIN 1234) pour vous connecter.",
    "worker.auth.w_02.demo_title": "Choisissez un compte",
    "worker.auth.w_02.forgot_link": "Mot de passe oublié ?",
    "worker.auth.w_02.kicker": "CONNEXION",
    "worker.auth.w_02.note": "PIN local jamais transmis. Vérifié contre hash.",
    "worker.auth.w_02.phone_copy": "Entrez votre numéro pour vous connecter.",
    "worker.auth.w_02.phone_cta": "Continuer",
    "worker.auth.w_02.phone_field_label": "Numéro de téléphone",
    "worker.auth.w_02.phone_placeholder": "90 12 34 56",
    "worker.auth.w_02.phone_title": "Votre numéro",
    "worker.auth.w_02.title": "Bonjour.",
    "worker.auth.w_02_e1.copy": "Vérifiez les chiffres et réessayez. Il vous reste {count} essais avant verrouillage.",
    "worker.auth.w_02_e1.copy_one": "Vérifiez les chiffres et réessayez. Il vous reste 1 essai avant verrouillage.",
    "worker.auth.w_02_e1.cta": "Réessayer",
    "worker.auth.w_02_e1.forgot_link": "Mot de passe oublié ?",
    "worker.auth.w_02_e1.kicker": "↩ CONNEXION",
    "worker.auth.w_02_e1.note": "Erreur saisie · tentatives restantes affichées.",
    "worker.auth.w_02_e1.notice": "Au 5e essai raté, votre compte sera verrouillé jusqu'à appel au bureau.",
    "worker.auth.w_02_e1.title": "Code incorrect",
    "worker.auth.w_02_e2.copy": "Trop d'essais incorrects. Pour des raisons de sécurité, seul le bureau peut débloquer votre compte.",
    "worker.auth.w_02_e2.countdown": "Déverrouillage automatique dans {time}.",
    "worker.auth.w_02_e2.cta_back": "Retour",
    "worker.auth.w_02_e2.cta_call": "Appeler le bureau",
    "worker.auth.w_02_e2.kicker": "↩ CONNEXION",
    "worker.auth.w_02_e2.note": "5 essais ratés · seul le bureau peut débloquer.",
    "worker.auth.w_02_e2.title": "Compte verrouillé",
    "worker.auth.w_02_e3.copy": "Pas de connexion réseau. Vérifiez votre signal puis réessayez.",
    "worker.auth.w_02_e3.cta": "Réessayer",
    "worker.auth.w_02_e3.kicker": "CONNEXION",
    "worker.auth.w_02_e3.note": "Pas de réseau au démarrage · mode dégradé.",
    "worker.auth.w_02_e3.title": "Pas de réseau",
    "worker.auth.w_02_r.copy": "Appelez le bureau au {phone}. L'opérateur vérifie votre identité, puis déclenche la réinitialisation. Vous recevrez ensuite un message WhatsApp pour configurer un nouveau code.",
    "worker.auth.w_02_r.cta_back": "Retour",
    "worker.auth.w_02_r.cta_call": "Appeler le bureau",
    "worker.auth.w_02_r.kicker": "RÉINITIALISATION",
    "worker.auth.w_02_r.note": "Sous-modal de W-02. Bureau a confirmé l'identité.",
    "worker.auth.w_02_r.title": "Nouveau code",
    "worker.cancellation.w_18.compensation_label": "Compensation",
    "worker.cancellation.w_18.eligible_no": "Non éligible",
    "worker.cancellation.w_18.eligible_yes": "Éligible",
    "worker.cancellation.w_18.replacement_notice": "Le bureau remplace ce créneau si possible avant midi.",
    "worker.cancellation.w_18.subscriber_line": "{name} a annulé la visite de {time}.",
    "worker.cancellation.w_18.title": "Visite annulée",
    "worker.earn.balance.label": "Solde disponible",
    "worker.earn.bonus.regularity": "Bonus régularité · + {amount} XOF",
    "worker.earn.empty": "Pas encore de gains cette semaine.",
    "worker.earn.this_week": "Cette semaine",
    "worker.earn.title": "Vos gains",
    "worker.earn.withdraw.confirmed": "{amount} XOF envoyés sur {provider}",
    "worker.earn.withdraw.cta": "Retirer",
    "worker.earnings.visits_count": "{count} visite",
    "worker.earnings.w_13.advance_cta": "Demander une avance",
    "worker.earnings.w_13.advance_cta_aria": "Demander une avance sur vos gains",
    "worker.earnings.w_13.advance_status.approved": "Approuvée",
    "worker.earnings.w_13.advance_status.paid": "Payée",
    "worker.earnings.w_13.advance_status.pending": "Demandée",
    "worker.earnings.w_13.advance_status.rejected": "Refusée",
    "worker.earnings.w_13.body": "Suivez le net à percevoir, les visites terminées et les versements déjà envoyés.",
    "worker.earnings.w_13.breakdown.completed_visits": "Visites terminées",
    "worker.earnings.w_13.breakdown.floor": "Plancher garanti",
    "worker.earnings.w_13.breakdown.month": "Mois",
    "worker.earnings.w_13.breakdown.net_due": "Net à percevoir",
    "worker.earnings.w_13.breakdown.paid_out": "Déjà versé",
    "worker.earnings.w_13.breakdown.visit_bonus": "Bonus visites",
    "worker.earnings.w_13.empty_body": "Réessayez quand le réseau est stable.",
    "worker.earnings.w_13.empty_title": "Gains indisponibles",
    "worker.earnings.w_13.error_message": "Impossible de charger vos gains. Vérifiez votre connexion.",
    "worker.earnings.w_13.kicker": "CETTE SEMAINE",
    "worker.earnings.w_13.note": "Total + breakdown + statut payout.",
    "worker.earnings.w_13.retry": "Réessayer",
    "worker.earnings.w_13.retry_aria": "Réessayer de charger les gains",
    "worker.earnings.w_13.section.breakdown": "Ventilation",
    "worker.earnings.w_13.section.payout_history": "Historique des versements",
    "worker.earnings.w_13.title": "Vos gains",
    "worker.earnings.w_13_0.kicker": "CETTE SEMAINE",
    "worker.earnings.w_13_0.note": "Nouvelle laveuse · semaine 1 sans visite.",
    "worker.earnings.w_13_0.title": "Vos gains",
    "worker.earnings.w_13_m.amount_label": "Montant (XOF)",
    "worker.earnings.w_13_m.available_hint": "Disponible : {amount}",
    "worker.earnings.w_13_m.cancel": "Annuler",
    "worker.earnings.w_13_m.confirm": "Confirmer",
    "worker.earnings.w_13_m.error_unknown": "Erreur inconnue",
    "worker.earnings.w_13_m.kicker": "↩ GAINS",
    "worker.earnings.w_13_m.min_amount_error": "Minimum 1 000 XOF",
    "worker.earnings.w_13_m.note": "Sous-modal de W-13. Confirmation montant + numéro.",
    "worker.earnings.w_13_m.payout_to": "Vers",
    "worker.earnings.w_13_m.payout_unset": "À configurer dans le profil",
    "worker.earnings.w_13_m.queued_toast": "Envoi différé",
    "worker.earnings.w_13_m.title": "Demander un retrait",
    "worker.earnings.w_13_v.kicker": "↩ GAINS",
    "worker.earnings.w_13_v.note": "Sous-modal de W-13 · ventilation par visite.",
    "worker.earnings.w_13_v.title": "Mardi 5 mai",
    "worker.end-of-day.w_21.kicker": "MARDI 5 MAI",
    "worker.end-of-day.w_21.note": "Bilan. Total visites + total gains + visites manquées.",
    "worker.end-of-day.w_21.title": "Belle journée.",
    "worker.end-of-day.w_21_m.kicker": "MAI 2026",
    "worker.end-of-day.w_21_m.note": "Bilan mois · agrégats hebdomadaires.",
    "worker.end-of-day.w_21_m.title": "Votre mois",
    "worker.end-of-day.w_21_w.kicker": "SEMAINE 19 · 5–11 MAI",
    "worker.end-of-day.w_21_w.note": "Bilan semaine · gains, visites, note moyenne.",
    "worker.end-of-day.w_21_w.title": "Belle semaine.",
    "worker.family.grace.cta": "Vêtements supplémentaires",
    "worker.family.grace.error": "Impossible de signaler pour le moment. Réessayez.",
    "worker.family.grace.modal.back": "Précédent",
    "worker.family.grace.modal.cancel": "Annuler",
    "worker.family.grace.modal.close": "Fermer",
    "worker.family.grace.modal.next": "Suivant",
    "worker.family.grace.modal.step.age.adulte": "Adulte",
    "worker.family.grace.modal.step.age.enfant": "Enfant",
    "worker.family.grace.modal.step.age.mixte": "Mélangé",
    "worker.family.grace.modal.step.age.title": "Pour qui semblent-ils ?",
    "worker.family.grace.modal.step.count.help": "Nombre approximatif d'articles hors contrat trouvés.",
    "worker.family.grace.modal.step.count.title": "Combien de vêtements ?",
    "worker.family.grace.modal.step.photo.cta": "Prendre une photo",
    "worker.family.grace.modal.step.photo.retake": "Reprendre la photo",
    "worker.family.grace.modal.step.photo.skip": "Continuer sans photo",
    "worker.family.grace.modal.step.photo.title": "Photo des vêtements",
    "worker.family.grace.modal.submit": "Signaler",
    "worker.family.grace.modal.submitting": "Envoi…",
    "worker.family.grace.modal.title": "Signaler des vêtements supplémentaires",
    "worker.family.grace.permission.denied": "Permission caméra requise.",
    "worker.family.grace.permission.settings_cta": "Ouvrir les Réglages",
    "worker.family.grace.permission.title": "Accès caméra refusé",
    "worker.family.grace.success.laves": "Vêtements lavés et signalés. Le foyer a été notifié.",
    "worker.family.grace.success.refuses": "Vêtements refusés selon le contrat. Le foyer a été notifié.",
    "worker.family.grace.success.title": "Signalement enregistré",
    "worker.family.roster.age_unit": "ans",
    "worker.family.roster.error": "Impossible de charger le foyer pour le moment.",
    "worker.family.roster.head_of_household": "Chef de foyer",
    "worker.family.roster.housemaid_badge": "Personnel",
    "worker.family.roster.loading": "Chargement du foyer…",
    "worker.family.roster.member_count": "{count} membre(s)",
    "worker.family.roster.paid_extra_badge": "Siège payant",
    "worker.family.roster.relationship.autre": "Autre",
    "worker.family.roster.relationship.epouse": "Épouse",
    "worker.family.roster.relationship.epoux": "Époux",
    "worker.family.roster.relationship.fille": "Fille",
    "worker.family.roster.relationship.fils": "Fils",
    "worker.family.roster.relationship.parent": "Parent",
    "worker.family.roster.relationship.personnel_domestique": "Personnel domestique",
    "worker.family.roster.title": "Foyer",
    "worker.family.scope.essentiel.checked_count": "{checked} / 9 articles cochés",
    "worker.family.scope.essentiel.cleared": "Tout décocher",
    "worker.family.scope.essentiel.cleared_confirm": "Décocher tous les articles ?",
    "worker.family.scope.essentiel.cleared_confirm_no": "Annuler",
    "worker.family.scope.essentiel.cleared_confirm_yes": "Décocher",
    "worker.family.scope.essentiel.excluded.title": "Articles hors contrat à laisser au foyer",
    "worker.family.scope.essentiel.help": "Cochez les articles que vous lavez. C'est un aide-mémoire, pas une obligation.",
    "worker.family.scope.essentiel.title": "Vêtements à laver aujourd'hui",
    "worker.help.faq.app_crash.answer": "Fermez et rouvrez l'application. Vos données sont sauvegardées. Si la visite était en cours, reprenez là où vous étiez via l'écran Tournée.",
    "worker.help.faq.app_crash.question": "L'application plante pendant une visite, comment continuer ?",
    "worker.help.faq.cancellation_policy.answer": "Si une cliente annule moins de 24 heures avant, vous recevez 500 XOF de compensation. Si vous étiez déjà arrivée sur place, vous recevez votre prime complète.",
    "worker.help.faq.cancellation_policy.question": "Que faire si une cliente annule ?",
    "worker.help.faq.device_change.answer": "Téléchargez l'application sur le nouveau téléphone, connectez-vous avec votre numéro. Le bureau valide le changement sous 24 heures.",
    "worker.help.faq.device_change.question": "Je change de téléphone, comment garder mon compte ?",
    "worker.help.faq.payout_delay.answer": "Les versements partent automatiquement chaque mois le 5. L'argent arrive sur Mixx by Yas ou Flooz en quelques minutes. Si rien après 24 heures, contactez le bureau.",
    "worker.help.faq.payout_delay.question": "Quand je reçois mon argent ?",
    "worker.help.faq.pin_lost.answer": "Contactez le bureau. Le bureau peut vous envoyer un code de récupération par WhatsApp.",
    "worker.help.faq.pin_lost.question": "J'ai oublié mon code PIN.",
    "worker.help.faq.subscriber_not_home.answer": "Attendez 10 minutes, essayez d'appeler. Si toujours rien, signalez 'cliente absente' dans l'app. Vous serez compensée.",
    "worker.help.faq.subscriber_not_home.question": "La cliente n'est pas chez elle, je fais quoi ?",
    "worker.help.w_22.about_link": "À propos",
    "worker.help.w_22.call_bureau": "Appeler le bureau",
    "worker.help.w_22.kicker": "AIDE",
    "worker.help.w_22.note": "Hub onglet aide. Numéros bureau + FAQ.",
    "worker.help.w_22.section.faq": "Questions fréquentes",
    "worker.help.w_22.title": "Aide",
    "worker.help.w_22_a.credit": "Conçu et fabriqué à Lomé.",
    "worker.help.w_22_a.kicker": "↩ AIDE",
    "worker.help.w_22_a.legal_link": "Mentions légales",
    "worker.help.w_22_a.note": "Sous-modal de W-22. Version, légal, équipe.",
    "worker.help.w_22_a.privacy_link": "Confidentialité",
    "worker.help.w_22_a.title": "À propos",
    "worker.help.w_22_a.version_label": "Version",
    "worker.help.w_22_f.back_link": "Retour à l'aide",
    "worker.help.w_22_f.kicker": "↩ AIDE · QUESTIONS FRÉQUENTES",
    "worker.help.w_22_f.not_found": "Question introuvable.",
    "worker.help.w_22_f.note": "Réponse à une question fréquente.",
    "worker.help.w_22_f.title": "Comment annuler une visite ?",
    "worker.help.w_x_c.kicker": "↩ AIDE · MESSAGE BUREAU",
    "worker.help.w_x_c.note": "Conversation directe avec le bureau · in-app.",
    "worker.help.w_x_c.title": "Bureau",
    "worker.inbox.w_18.kicker": "NOTIFICATION",
    "worker.inbox.w_18.note": "Annulation reçue. Compense affichée si éligible.",
    "worker.inbox.w_18.title": "Visite annulée",
    "worker.inbox.w_20.kicker": "NOTIFICATIONS",
    "worker.inbox.w_20.note": "Liste centralisée. Reçus, alertes, bureau.",
    "worker.inbox.w_20.title": "Notifications",
    "worker.inbox.w_20_0.kicker": "NOTIFICATIONS",
    "worker.inbox.w_20_0.note": "Inbox vide · zéro état calme.",
    "worker.inbox.w_20_0.title": "Tout est calme.",
    "worker.inbox.w_20_d.kicker": "↩ NOTIFICATIONS",
    "worker.inbox.w_20_d.note": "Sous-modal de W-20. Détail d'une notification.",
    "worker.inbox.w_20_d.title": "Visite annulée",
    "worker.login.cta": "Entrer",
    "worker.login.forgot": "PIN oublié ? Appelez le bureau · {phone}",
    "worker.login.greeting": "Bonjour",
    "worker.login.header": "Connexion",
    "worker.login.help": "Le numéro inscrit chez Washed.",
    "worker.login.phone_label": "Numéro",
    "worker.login.pin_label": "Code PIN — 4 chiffres",
    "worker.login.prompt": "Votre numéro ?",
    "worker.nav.gains": "Gains",
    "worker.nav.planning": "Planning",
    "worker.nav.profil": "Profil",
    "worker.nav.tournee": "Tournée",
    "worker.notifications.bell_aria": "Notifications, {count} non lue",
    "worker.notifications.mark_read_cta": "Marquer comme lu",
    "worker.notifications.type.bureau_message": "Message du bureau",
    "worker.notifications.type.payout_settled": "Versement effectué",
    "worker.notifications.type.visit_cancelled": "Visite annulée",
    "worker.notifications.w_20.kicker": "NOTIFICATIONS",
    "worker.notifications.w_20.title": "Notifications",
    "worker.notifications.w_20_0.kicker": "NOTIFICATIONS",
    "worker.notifications.w_20_0.note": "Aucune notification non lue. Le bureau vous contacte ici en cas de nouveauté.",
    "worker.notifications.w_20_0.title": "Tout est calme.",
    "worker.notifications.w_20_d.back_cta": "Notifications",
    "worker.notifications.w_20_d.error_message": "Impossible de charger cette notification. Vérifiez votre connexion.",
    "worker.notifications.w_20_d.error_retry": "Réessayer",
    "worker.notifications.w_20_d.error_retry_aria": "Réessayer de charger la notification",
    "worker.notifications.w_20_d.loading_aria": "Chargement de la notification…",
    "worker.office.sms_cta": "Envoyer un SMS au bureau",
    "worker.office.whatsapp_cta": "Appeler le bureau sur WhatsApp",
    "worker.offline.banner.failures_link": "Voir les échecs ({count})",
    "worker.offline.banner.offline": "Hors-ligne — synchronisation en attente",
    "worker.offline.banner.syncing": "Synchronisation · {count} élément",
    "worker.onboarding.w_00_a.copy": "Le bureau a noté ce numéro à votre inscription. On vous envoie un code pour confirmer.",
    "worker.onboarding.w_00_a.cta": "Recevoir le code",
    "worker.onboarding.w_00_a.field_label": "Téléphone",
    "worker.onboarding.w_00_a.kicker": "ÉTAPE 1 / 8",
    "worker.onboarding.w_00_a.muted": "Numéro non transmis aux abonnés. Sert uniquement au bureau.",
    "worker.onboarding.w_00_a.note": "Numéro confirmé par le bureau.",
    "worker.onboarding.w_00_a.phone_placeholder": "90 12 34 56",
    "worker.onboarding.w_00_a.title": "Votre numéro",
    "worker.onboarding.w_00_b.copy": "Six chiffres envoyés au {phone}.",
    "worker.onboarding.w_00_b.copy_office": "Appelez le bureau au {phone} : il vous le donne.",
    "worker.onboarding.w_00_b.copy_office_whatsapp": "Écrivez au bureau sur WhatsApp au {phone} : il vous le donne.",
    "worker.onboarding.w_00_b.cta": "Vérifier",
    "worker.onboarding.w_00_b.error_expired": "Le code a expiré. Recommencez avec un nouveau numéro.",
    "worker.onboarding.w_00_b.error_generic": "Quelque chose s'est cassé. Réessayez ou appelez le bureau.",
    "worker.onboarding.w_00_b.error_invalid_code": "Code incorrect. Vérifiez les 6 chiffres.",
    "worker.onboarding.w_00_b.error_network": "Pas de connexion. Vérifiez le réseau puis réessayez.",
    "worker.onboarding.w_00_b.field_label": "Code SMS",
    "worker.onboarding.w_00_b.field_label_code": "Code à six chiffres",
    "worker.onboarding.w_00_b.field_label_whatsapp": "Code WhatsApp",
    "worker.onboarding.w_00_b.kicker": "ÉTAPE 2 / 8",
    "worker.onboarding.w_00_b.not_ready_copy": "Le bureau doit encore configurer votre compte. Appelez le {phone} pour qu'il finalise votre inscription.",
    "worker.onboarding.w_00_b.not_ready_copy_whatsapp": "Le bureau doit encore configurer votre compte. Écrivez-lui sur WhatsApp au {phone} pour qu'il finalise votre inscription.",
    "worker.onboarding.w_00_b.not_ready_cta": "Appeler le bureau",
    "worker.onboarding.w_00_b.not_ready_title": "Votre compte n'est pas encore prêt",
    "worker.onboarding.w_00_b.note": "OTP six chiffres.",
    "worker.onboarding.w_00_b.title": "Le code reçu par SMS",
    "worker.onboarding.w_00_b.title_office": "Le code du bureau",
    "worker.onboarding.w_00_b.title_whatsapp": "Le code reçu sur WhatsApp",
    "worker.onboarding.w_00_c.copy": "Le bureau a déjà saisi votre prénom et nom. Vérifiez et corrigez si besoin.",
    "worker.onboarding.w_00_c.cta": "Continuer",
    "worker.onboarding.w_00_c.field_cni": "Numéro CNI (facultatif)",
    "worker.onboarding.w_00_c.field_first_name": "Prénom",
    "worker.onboarding.w_00_c.field_last_name": "Nom",
    "worker.onboarding.w_00_c.kicker": "ÉTAPE 3 / 8",
    "worker.onboarding.w_00_c.note": "Pré-rempli par le bureau · à confirmer.",
    "worker.onboarding.w_00_c.title": "Vos informations",
    "worker.onboarding.w_00_d.copy": "Le bureau utilise votre quartier pour vous proposer des visites proches.",
    "worker.onboarding.w_00_d.cta": "Continuer",
    "worker.onboarding.w_00_d.field_landmark": "Repère (facultatif)",
    "worker.onboarding.w_00_d.field_neighborhood": "Quartier",
    "worker.onboarding.w_00_d.field_street": "Rue / détail",
    "worker.onboarding.w_00_d.kicker": "ÉTAPE 4 / 8",
    "worker.onboarding.w_00_d.neighborhood_placeholder": "Choisissez un quartier",
    "worker.onboarding.w_00_d.note": "Où vit la laveuse — sert au routage.",
    "worker.onboarding.w_00_d.title": "Où habitez-vous ?",
    "worker.onboarding.w_00_e.copy": "Une photo claire de votre visage. Les abonnés la voient avant chaque visite — c'est ce qui crée la confiance.",
    "worker.onboarding.w_00_e.cta_capture": "Prendre un selfie",
    "worker.onboarding.w_00_e.cta_continue": "Continuer",
    "worker.onboarding.w_00_e.cta_retake": "Reprendre",
    "worker.onboarding.w_00_e.hint": "Vous pourrez la changer plus tard depuis les réglages.",
    "worker.onboarding.w_00_e.kicker": "ÉTAPE 5 / 8",
    "worker.onboarding.w_00_e.map_consent_label": "Autoriser l'affichage de cette photo sur la carte en direct pour les abonnés.",
    "worker.onboarding.w_00_e.note": "Selfie · visible aux abonnés (X-18 Worker Profile).",
    "worker.onboarding.w_00_e.placeholder_label": "Aucune photo pour l'instant.",
    "worker.onboarding.w_00_e.title": "Votre photo",
    "worker.onboarding.w_00_e.uploading": "Envoi…",
    "worker.onboarding.w_00_f.copy": "Le bureau active votre compte sous 24h. Vous recevrez un message WhatsApp dès que votre première tournée est prête.",
    "worker.onboarding.w_00_f.cta": "Définir mon code PIN",
    "worker.onboarding.w_00_f.kicker": "BIENVENUE",
    "worker.onboarding.w_00_f.note": "Compte en attente de validation bureau.",
    "worker.onboarding.w_00_f.status_badge": "Compte créé",
    "worker.onboarding.w_00_f.title": "Bienvenue chez Washed",
    "worker.onboarding.w_00_g.copy": "On en a besoin pour vérifier que vous êtes bien chez la cliente avant de démarrer la visite. Sans cela, le check-in ne peut pas se faire.",
    "worker.onboarding.w_00_g.cta_activate": "Autoriser la localisation",
    "worker.onboarding.w_00_g.cta_skip": "Continuer sans",
    "worker.onboarding.w_00_g.denied_copy": "Sans localisation, le check-in chez la cliente devra être fait à la main par le bureau. Vous pourrez activer la permission plus tard depuis les réglages du téléphone.",
    "worker.onboarding.w_00_g.kicker": "ÉTAPE 6 / 8",
    "worker.onboarding.w_00_g.note": "Permission iOS/Android · le geofence en dépend.",
    "worker.onboarding.w_00_g.title": "Activer la localisation",
    "worker.onboarding.w_00_h.copy": "Le bureau vous alerte par notification quand une nouvelle visite est proposée, ou quand une cliente annule. Sans notifications, vous risquez de manquer une assignation.",
    "worker.onboarding.w_00_h.cta_activate": "Autoriser les notifications",
    "worker.onboarding.w_00_h.cta_skip": "Continuer sans",
    "worker.onboarding.w_00_h.denied_copy": "Sans notifications, le bureau vous joindra par WhatsApp pour les assignations et annulations. Vous pourrez activer la permission plus tard depuis les réglages du téléphone.",
    "worker.onboarding.w_00_h.kicker": "ÉTAPE 7 / 8",
    "worker.onboarding.w_00_h.note": "Push pour assignations, annulations, urgences.",
    "worker.onboarding.w_00_h.title": "Recevoir les notifications",
    "worker.onboarding.w_00_i.copy": "Chaque visite demande deux photos — avant lavage et après. C'est ce qui protège la cliente et la laveuse en cas de doute.",
    "worker.onboarding.w_00_i.cta_activate": "Autoriser l'appareil photo",
    "worker.onboarding.w_00_i.cta_skip": "Continuer sans",
    "worker.onboarding.w_00_i.denied_copy": "Sans appareil photo, vous ne pourrez pas clore une visite seule — le bureau devra valider à la main. Vous pourrez activer la permission plus tard depuis les réglages du téléphone.",
    "worker.onboarding.w_00_i.kicker": "ÉTAPE 8 / 8",
    "worker.onboarding.w_00_i.note": "Photos avant/après obligatoires pour clore une visite.",
    "worker.onboarding.w_00_i.title": "Activer l'appareil photo",
    "worker.onboarding.w_01_o1.already_set_error": "Un code est déjà défini. Appelez le bureau pour le réinitialiser.",
    "worker.onboarding.w_01_o1.copy_confirm": "Retapez le même code pour confirmer.",
    "worker.onboarding.w_01_o1.copy_enter": "4 chiffres faciles à retenir. Le bureau ne peut pas le voir.",
    "worker.onboarding.w_01_o1.cta": "Continuer",
    "worker.onboarding.w_01_o1.invalid_format_error": "Format invalide. Le code doit faire 4 chiffres.",
    "worker.onboarding.w_01_o1.kicker": "CONFIGURATION · 1 / 3",
    "worker.onboarding.w_01_o1.mismatch_error": "Les codes ne correspondent pas. Réessayez.",
    "worker.onboarding.w_01_o1.note": "Onboarding. PIN choisi à l'inscription.",
    "worker.onboarding.w_01_o1.security_note": "Vous pourrez le réinitialiser en appelant le bureau.",
    "worker.onboarding.w_01_o1.title": "Choisissez un code",
    "worker.onboarding.w_01_o2.copy": "Choisissez où Washed envoie vos paiements chaque vendredi.",
    "worker.onboarding.w_01_o2.cta": "Continuer",
    "worker.onboarding.w_01_o2.field_account": "Numéro Mobile Money",
    "worker.onboarding.w_01_o2.field_provider": "Opérateur",
    "worker.onboarding.w_01_o2.invalid_account_error": "Numéro invalide. Vérifiez et réessayez.",
    "worker.onboarding.w_01_o2.invalid_provider_error": "Choisissez un opérateur Mobile Money valide.",
    "worker.onboarding.w_01_o2.kicker": "CONFIGURATION · 2 / 3",
    "worker.onboarding.w_01_o2.note": "Onboarding. Numéro de versement.",
    "worker.onboarding.w_01_o2.notice": "Le numéro doit être au nom inscrit chez Washed.",
    "worker.onboarding.w_01_o2.option_flooz": "Flooz",
    "worker.onboarding.w_01_o2.option_mixx": "Mixx by Yas",
    "worker.onboarding.w_01_o2.title": "Recevez vos gains",
    "worker.onboarding.w_01_o3.copy": "Trois choses essentielles avant de commencer votre première tournée.",
    "worker.onboarding.w_01_o3.cta_next": "Suivant",
    "worker.onboarding.w_01_o3.cta_start": "Commencer",
    "worker.onboarding.w_01_o3.error_generic": "Impossible de finaliser. Réessayez ou contactez le bureau.",
    "worker.onboarding.w_01_o3.error_prerequisites": "Votre compte n'est pas encore prêt. Contactez le bureau au {phone}.",
    "worker.onboarding.w_01_o3.kicker": "CONFIGURATION · 3 / 3",
    "worker.onboarding.w_01_o3.note": "Onboarding. Spotlight 3 étapes.",
    "worker.onboarding.w_01_o3.tip_1_body": "Votre tournée du jour s'affiche dès l'ouverture de l'app. Toutes vos visites, dans l'ordre.",
    "worker.onboarding.w_01_o3.tip_1_title": "Votre tournée",
    "worker.onboarding.w_01_o3.tip_2_body": "Vos gains sont versés chaque vendredi sur votre compte Mobile Money. Suivez le total dans l'onglet Gains.",
    "worker.onboarding.w_01_o3.tip_2_title": "Vos gains",
    "worker.onboarding.w_01_o3.tip_3_body": "En cas de danger pendant une visite, le bouton SOS appelle directement le bureau. Disponible sur chaque visite.",
    "worker.onboarding.w_01_o3.tip_3_title": "SOS",
    "worker.onboarding.w_01_o3.tip_progress": "{current} / {total}",
    "worker.onboarding.w_01_o3.title": "Comment ça marche",
    "worker.paid_visit.access_label": "Accès",
    "worker.paid_visit.arrival_by_office": "Arrivée confirmée par le bureau.",
    "worker.paid_visit.check_in_far": "Vous êtes à {meters} m de l'adresse (100 m au plus). Rapprochez-vous puis réessayez.",
    "worker.paid_visit.check_in_far_office": "Le téléphone vous place encore à {meters} m de l'adresse. Si vous êtes bien à la porte, appelez le bureau : il peut confirmer votre arrivée. Touchez ensuite « Je suis arrivée » à nouveau.",
    "worker.paid_visit.check_in_no_location": "Adresse non renseignée : appelez le bureau. Une fois l'adresse ajoutée, touchez « Je suis arrivée » à nouveau.",
    "worker.paid_visit.contacts": "Essais de contact : {count}",
    "worker.paid_visit.cta_call": "Appeler le client",
    "worker.paid_visit.cta_check_in": "Je suis arrivée",
    "worker.paid_visit.cta_complete": "Terminer la visite",
    "worker.paid_visit.cta_directions": "Itinéraire",
    "worker.paid_visit.cta_door": "J'ai frappé à la porte",
    "worker.paid_visit.cta_no_show": "Client absent",
    "worker.paid_visit.cta_safety": "Je pars pour ma sécurité",
    "worker.paid_visit.cta_start": "Commencer le lavage",
    "worker.paid_visit.cta_whatsapp": "Écrire sur WhatsApp",
    "worker.paid_visit.done_body": "Merci. La visite est enregistrée et comptée dans vos gains.",
    "worker.paid_visit.error": "Action impossible pour le moment. Réessayez ou appelez le bureau.",
    "worker.paid_visit.flags_title": "Quelque chose à signaler ?",
    "worker.paid_visit.location_missing": "Adresse à confirmer : appelez le bureau.",
    "worker.paid_visit.location_needed": "Activez la localisation pour confirmer votre arrivée.",
    "worker.paid_visit.location_unverified": "Position à confirmer sur place",
    "worker.paid_visit.no_show_wait": "« Client absent » possible à {time}, après un essai de contact.",
    "worker.paid_visit.safety_body": "L'équipe vous contacte et examine la situation. Mettez-vous en sécurité.",
    "worker.paid_visit.safety_note": "Un seul appui suffit. Aucune photo, aucune attente : l'équipe prend le relais.",
    "worker.paid_visit.section_today": "Passages confirmés",
    "worker.paid_visit.section_upcoming": "À venir",
    "worker.paid_visit.state_arrived": "Arrivée confirmée",
    "worker.paid_visit.state_closed": "Clôturée",
    "worker.paid_visit.state_completed": "Terminée",
    "worker.paid_visit.state_due": "À faire",
    "worker.paid_visit.state_in_service": "Lavage en cours",
    "worker.paid_visit.state_no_show": "Client absent",
    "worker.paid_visit.state_on_hold": "En attente : ne vous déplacez pas",
    "worker.paid_visit.state_under_review": "Revue par l'équipe",
    "worker.paid_visit.state_upcoming": "À venir",
    "worker.paid_visit.window_am": "Matin (8 h–12 h)",
    "worker.paid_visit.window_day": "Journée complète",
    "worker.paid_visit.window_pm": "Après-midi (13 h–17 h)",
    "worker.planning.empty_day": "Aucune visite",
    "worker.planning.time_window.afternoon": "Après-midi",
    "worker.planning.time_window.morning": "Matin",
    "worker.planning.visits_count": "{count} visite",
    "worker.planning.w_14.body": "Votre semaine confirmée par le bureau, avec chaque visite prévue.",
    "worker.planning.w_14.empty_body": "Réessayez quand le réseau est stable.",
    "worker.planning.w_14.empty_title": "Planning indisponible",
    "worker.planning.w_14.kicker": "SEMAINE 19",
    "worker.planning.w_14.leave_cta": "Demander un congé",
    "worker.planning.w_14.note": "Vue semaine. Demande de congé via modal.",
    "worker.planning.w_14.title": "Planning",
    "worker.planning.w_14_m.cancel": "Annuler",
    "worker.planning.w_14_m.confirm": "Confirmer",
    "worker.planning.w_14_m.end_date_error": "La date de fin doit être après la date de début",
    "worker.planning.w_14_m.end_date_label": "Date de fin",
    "worker.planning.w_14_m.kicker": "↩ PLANNING",
    "worker.planning.w_14_m.note": "Sous-modal de W-14. Plage de dates + motif.",
    "worker.planning.w_14_m.queued_toast": "Envoi différé",
    "worker.planning.w_14_m.reason_label": "Motif",
    "worker.planning.w_14_m.reason_max_error": "Le motif ne doit pas dépasser 500 caractères",
    "worker.planning.w_14_m.reason_min_error": "Le motif doit contenir au moins 5 caractères",
    "worker.planning.w_14_m.start_date_label": "Date de début",
    "worker.planning.w_14_m.title": "Demander un congé",
    "worker.preferences.family_routes.confirm.body": "Les routes Famille rapportent en moyenne plus que les routes individuelles.",
    "worker.preferences.family_routes.confirm.cancel": "Annuler",
    "worker.preferences.family_routes.confirm.refuse": "Refuser les routes Famille",
    "worker.preferences.family_routes.confirm.title": "Êtes-vous sûr ?",
    "worker.preferences.family_routes.help": "Les visites Famille rapportent plus mais durent plus longtemps.",
    "worker.preferences.family_routes.section_title": "Routes Famille",
    "worker.preferences.family_routes.toggle_label": "Accepter les visites Famille",
    "worker.profile.aide_link": "Aide",
    "worker.profile.payout.unset": "À configurer",
    "worker.profile.settings_link": "Réglages",
    "worker.profile.settings_placeholder.coming_soon": "Bientôt",
    "worker.profile.sos_chip": "SOS",
    "worker.profile.w_15.body": "Vos quartiers, votre capacité et le compte de paiement actif.",
    "worker.profile.w_15.field.capacity": "Capacité max",
    "worker.profile.w_15.field.name": "Nom",
    "worker.profile.w_15.field.neighborhoods": "Quartiers",
    "worker.profile.w_15.field.payout": "Paiement",
    "worker.profile.w_15.field.status": "Statut",
    "worker.profile.w_15.kicker": "PROFIL",
    "worker.profile.w_15.note": "Hub onglet profil. Identité + adresse + payout + liens.",
    "worker.profile.w_15.payout_value": "%1$s · **** %2$s",
    "worker.profile.w_15.status.active": "Active",
    "worker.profile.w_15.status.blocked": "Bloquée",
    "worker.profile.w_15.status.onboarding": "En validation",
    "worker.profile.w_15.status.suspended": "Suspendue",
    "worker.profile.w_15.title": "Votre profil",
    "worker.profile.w_15_0.kicker": "PROFIL",
    "worker.profile.w_15_0.note": "Nouvelle laveuse · pas encore de foyers réguliers.",
    "worker.profile.w_15_0.title": "Votre profil",
    "worker.profile.w_15_d.kicker": "↩ MES FOYERS",
    "worker.profile.w_15_d.note": "Sous-modal de W-15. Histoire d'un foyer régulier.",
    "worker.profile.w_15_d.title": "Mme Adjoa K.",
    "worker.profile.w_15_d_r.kicker": "↩ MME ADJOA K.",
    "worker.profile.w_15_d_r.no_reviews": "Pas encore d'avis",
    "worker.profile.w_15_d_r.note": "Sous-modal de W-15.D. Commentaires des abonnées.",
    "worker.profile.w_15_d_r.title": "Notes & avis",
    "worker.profile.w_15_s.kicker": "↩ PROFIL",
    "worker.profile.w_15_s.note": "Sous-modal de W-15. Modifier toutes les infos profil.",
    "worker.profile.w_15_s.row.address": "Modifier mon adresse",
    "worker.profile.w_15_s.row.appearance": "Apparence",
    "worker.profile.w_15_s.row.identity": "Modifier mes informations",
    "worker.profile.w_15_s.row.language": "Langue",
    "worker.profile.w_15_s.row.logout": "Se déconnecter",
    "worker.profile.w_15_s.row.notifications": "Notifications",
    "worker.profile.w_15_s.row.offline_mode": "Mode hors-ligne",
    "worker.profile.w_15_s.row.payout": "Mobile Money",
    "worker.profile.w_15_s.row.photo": "Modifier ma photo",
    "worker.profile.w_15_s.row.pin": "Changer mon code PIN",
    "worker.profile.w_15_s.section.account": "COMPTE",
    "worker.profile.w_15_s.section.payment": "PAIEMENT",
    "worker.profile.w_15_s.section.preferences": "PRÉFÉRENCES",
    "worker.profile.w_15_s.section.profile": "PROFIL",
    "worker.profile.w_15_s.section.security": "SÉCURITÉ",
    "worker.profile.w_15_s.title": "Réglages",
    "worker.profile.w_15_s_a.field_landmark": "Point de repère (optionnel)",
    "worker.profile.w_15_s_a.field_neighborhood": "Quartier",
    "worker.profile.w_15_s_a.field_street": "Rue / avenue",
    "worker.profile.w_15_s_a.kicker": "RÉGLAGES",
    "worker.profile.w_15_s_a.neighborhood_placeholder": "Choisissez un quartier",
    "worker.profile.w_15_s_a.note": "Adresse personnelle de la laveuse.",
    "worker.profile.w_15_s_a.pending_banner": "En attente de validation par le bureau · soumis le {date}",
    "worker.profile.w_15_s_a.save": "Enregistrer",
    "worker.profile.w_15_s_a.saving": "Enregistrement…",
    "worker.profile.w_15_s_a.title": "Votre adresse",
    "worker.profile.w_15_s_appearance.kicker": "PRÉFÉRENCES",
    "worker.profile.w_15_s_appearance.option.dark": "Sombre",
    "worker.profile.w_15_s_appearance.option.dark_desc": "Mode nuit",
    "worker.profile.w_15_s_appearance.option.light": "Clair",
    "worker.profile.w_15_s_appearance.option.light_desc": "Mode jour",
    "worker.profile.w_15_s_appearance.option.system": "Système",
    "worker.profile.w_15_s_appearance.option.system_desc": "Suit votre téléphone",
    "worker.profile.w_15_s_appearance.title": "Apparence",
    "worker.profile.w_15_s_i.field_date_of_birth": "Date de naissance",
    "worker.profile.w_15_s_i.field_first_name": "Prénom légal",
    "worker.profile.w_15_s_i.field_last_name": "Nom de famille légal",
    "worker.profile.w_15_s_i.kicker": "RÉGLAGES",
    "worker.profile.w_15_s_i.note": "Identité éditable · validation bureau requise.",
    "worker.profile.w_15_s_i.pending_banner": "En attente de validation par le bureau · soumis le {date}",
    "worker.profile.w_15_s_i.save": "Enregistrer",
    "worker.profile.w_15_s_i.saving": "Enregistrement…",
    "worker.profile.w_15_s_i.title": "Vos informations",
    "worker.profile.w_15_s_l.kicker": "RÉGLAGES",
    "worker.profile.w_15_s_l.note": "Picker FR/EN.",
    "worker.profile.w_15_s_l.option.en": "English",
    "worker.profile.w_15_s_l.option.en.body": "Interface et messages en anglais.",
    "worker.profile.w_15_s_l.option.fr": "Français",
    "worker.profile.w_15_s_l.option.fr.body": "Langue actuelle",
    "worker.profile.w_15_s_l.title": "Langue de l'application",
    "worker.profile.w_15_s_m.kicker": "RÉGLAGES",
    "worker.profile.w_15_s_m.note": "Numéro de versement payout.",
    "worker.profile.w_15_s_m.phone_error": "Le numéro doit contenir exactement 8 chiffres.",
    "worker.profile.w_15_s_m.phone_label": "Numéro de compte (8 chiffres)",
    "worker.profile.w_15_s_m.phone_placeholder": "Ex. 90123456",
    "worker.profile.w_15_s_m.provider_label": "Opérateur Mobile Money",
    "worker.profile.w_15_s_m.queued_toast": "Modification enregistrée · envoi à la reconnexion.",
    "worker.profile.w_15_s_m.save": "Enregistrer",
    "worker.profile.w_15_s_m.saving": "Enregistrement…",
    "worker.profile.w_15_s_m.title": "Mobile Money",
    "worker.profile.w_15_s_n.kicker": "RÉGLAGES",
    "worker.profile.w_15_s_n.note": "Toggles par catégorie.",
    "worker.profile.w_15_s_n.row.push_assignments": "Rappels de visite",
    "worker.profile.w_15_s_n.row.push_cancellations": "Annulations",
    "worker.profile.w_15_s_n.row.push_payouts": "Versements",
    "worker.profile.w_15_s_n.row.push_urgent": "Messages du bureau",
    "worker.profile.w_15_s_n.row.sms_fallback": "Conseils et actualités",
    "worker.profile.w_15_s_n.title": "Notifications",
    "worker.profile.w_15_s_n.toggle_error": "Modification non enregistrée. Réessayez.",
    "worker.profile.w_15_s_o.kicker": "RÉGLAGES",
    "worker.profile.w_15_s_o.note": "Picker comportement réseau.",
    "worker.profile.w_15_s_o.option.auto": "Automatique",
    "worker.profile.w_15_s_o.option.auto.body": "Synchronise dès que vous êtes connectée",
    "worker.profile.w_15_s_o.option.manual": "Manuel",
    "worker.profile.w_15_s_o.option.manual.body": "Synchronisez manuellement quand vous le souhaitez",
    "worker.profile.w_15_s_o.option.wifi_only": "Wi-Fi uniquement",
    "worker.profile.w_15_s_o.option.wifi_only.body": "Économise les données mobiles",
    "worker.profile.w_15_s_o.title": "Mode hors-ligne",
    "worker.profile.w_15_s_p.cta_capture": "Prendre une photo",
    "worker.profile.w_15_s_p.cta_retake": "Reprendre la photo",
    "worker.profile.w_15_s_p.deferred_toast": "Envoi différé",
    "worker.profile.w_15_s_p.error_capture_failed": "Impossible de prendre une photo. Réessayez.",
    "worker.profile.w_15_s_p.kicker": "RÉGLAGES",
    "worker.profile.w_15_s_p.note": "Sous-modal de W-15.S. Reprise du flux W-00.E.",
    "worker.profile.w_15_s_p.saving": "Enregistrement…",
    "worker.profile.w_15_s_p.selfie_alt": "Votre photo de profil actuelle",
    "worker.profile.w_15_s_p.success_toast": "Photo mise à jour",
    "worker.profile.w_15_s_p.title": "Modifier votre photo",
    "worker.profile.w_15_s_p.uploading": "Téléchargement…",
    "worker.profile.w_15_s_pin.confirm_mismatch": "Les codes PIN ne correspondent pas.",
    "worker.profile.w_15_s_pin.current_pin_error": "PIN actuel incorrect.",
    "worker.profile.w_15_s_pin.kicker": "RÉGLAGES",
    "worker.profile.w_15_s_pin.network_error": "Connectez-vous pour changer votre code PIN.",
    "worker.profile.w_15_s_pin.next_cta": "Continuer",
    "worker.profile.w_15_s_pin.note": "Changement volontaire (vs reset W-02.R).",
    "worker.profile.w_15_s_pin.step1_label": "Code PIN actuel",
    "worker.profile.w_15_s_pin.step2_label": "Nouveau code PIN",
    "worker.profile.w_15_s_pin.step3_label": "Confirmer le nouveau code PIN",
    "worker.profile.w_15_s_pin.submit_cta": "Changer mon code PIN",
    "worker.profile.w_15_s_pin.title": "Nouveau code PIN",
    "worker.profile.w_15_s_x.body": "Voulez-vous vraiment vous déconnecter ? Vous devrez vous reconnecter avec votre numéro et votre code PIN.",
    "worker.profile.w_15_s_x.cta_cancel": "Annuler",
    "worker.profile.w_15_s_x.cta_confirm": "Se déconnecter",
    "worker.profile.w_15_s_x.kicker": "RÉGLAGES",
    "worker.profile.w_15_s_x.logging_out": "Déconnexion…",
    "worker.profile.w_15_s_x.note": "Confirmation. Efface session locale.",
    "worker.profile.w_15_s_x.title": "Se déconnecter ?",
    "worker.recap.average_rating": "{rating} ★ moyenne",
    "worker.recap.missed_visits": "{count} manquée{plural}",
    "worker.recap.total_earnings_line": "{amount} gagnés",
    "worker.recap.visit_status_cancelled": "annulée",
    "worker.recap.visit_status_completed": "clôturée",
    "worker.recap.visit_status_no_show": "absent",
    "worker.recap.visits_completed": "{count} visite{plural} clôturée{plural}",
    "worker.safety.w_16.kicker": "↩ TOURNÉE",
    "worker.safety.w_16.note": "Bouton rouge plein. 6 motifs. Appel direct bureau.",
    "worker.safety.w_16.title": "Urgence",
    "worker.safety.w_19.add_photo_cta": "Ajouter une photo",
    "worker.safety.w_19.body_label": "Décrivez le problème",
    "worker.safety.w_19.body_max_error": "Maximum 2 000 caractères.",
    "worker.safety.w_19.body_min_error": "Minimum 10 caractères.",
    "worker.safety.w_19.body_placeholder": "Expliquez ce qui s'est passé…",
    "worker.safety.w_19.cancel_cta": "Annuler",
    "worker.safety.w_19.kicker": "↩ VISITE",
    "worker.safety.w_19.note": "Formulaire libre. Photo optionnelle.",
    "worker.safety.w_19.offline_hint": "Envoi différé",
    "worker.safety.w_19.remove_photo_cta": "Retirer",
    "worker.safety.w_19.submit_cta": "Envoyer",
    "worker.safety.w_19.title": "Signaler un souci",
    "worker.safety.w_19_s.back_cta": "Retour profil",
    "worker.safety.w_19_s.kicker": "ENVOYÉ",
    "worker.safety.w_19_s.note": "Confirmation après W-19 submit.",
    "worker.safety.w_19_s.title": "Bien reçu",
    "worker.sos.call_in_progress": "Appel en cours…",
    "worker.sos.call_police": "Appeler la police · 161",
    "worker.sos.callback": "Choisissez ce qui se passe. L'alerte part au bureau, avec votre position si elle est disponible.",
    "worker.sos.cancel": "Annuler",
    "worker.sos.confirm_cta": "Appeler le bureau",
    "worker.sos.dismiss": "Terminer",
    "worker.sos.failed_body": "Appelez le bureau maintenant.",
    "worker.sos.failed_title": "L'alerte n'est pas partie",
    "worker.sos.no_location": "Sans position GPS : dites au bureau où vous êtes.",
    "worker.sos.option.client_issue": "Problème avec la cliente",
    "worker.sos.option.client_issue_detail": "Refus, agressivité, malentendu",
    "worker.sos.option.danger": "Je suis en danger",
    "worker.sos.option.danger_detail": "Alerte immédiate + GPS partagé",
    "worker.sos.option.medical": "Accident / blessure",
    "worker.sos.option.medical_detail": "Médical · transport",
    "worker.sos.panic": "SOS",
    "worker.sos.queued_body": "Pas de réseau : elle part dès que possible. Appelez le bureau maintenant si vous le pouvez.",
    "worker.sos.queued_title": "Alerte enregistrée",
    "worker.sos.safety": "Mettez-vous en sécurité. Si vous êtes en danger maintenant, appelez la police : 161 depuis un portable (117 depuis un fixe), ou les pompiers : 118.",
    "worker.sos.sending_title": "Envoi de l'alerte…",
    "worker.sos.sent_body": "Le bureau vous rappelle. Si vous le pouvez, appelez-le maintenant.",
    "worker.sos.sent_title": "Alerte envoyée au bureau",
    "worker.sos.title": "Que se passe-t-il ?",
    "worker.splash.sync": "Synchronisation…",
    "worker.splash.tagline": "L'appli laveuse",
    "worker.system-states.w_17.kicker": "CONNEXION",
    "worker.system-states.w_17.note": "État dégradé. Sync en attente visible partout.",
    "worker.system-states.w_17.title": "Pas de réseau",
    "worker.system-states.w_x_nf.action_kind.advance.request": "Demande d'avance",
    "worker.system-states.w_x_nf.action_kind.concern.report": "Signalement",
    "worker.system-states.w_x_nf.action_kind.leave.request": "Demande de congé",
    "worker.system-states.w_x_nf.action_kind.notification.mark_read": "Marquer comme lu",
    "worker.system-states.w_x_nf.action_kind.settings.notification_preferences.update": "Mise à jour des notifications",
    "worker.system-states.w_x_nf.action_kind.settings.payout_destination.update": "Mise à jour Mobile Money",
    "worker.system-states.w_x_nf.action_kind.settings.personal_details.update": "Mise à jour des informations",
    "worker.system-states.w_x_nf.action_kind.settings.selfie.update": "Mise à jour de la photo",
    "worker.system-states.w_x_nf.action_kind.sos.event": "Alerte SOS",
    "worker.system-states.w_x_nf.action_kind.unknown": "Action en attente",
    "worker.system-states.w_x_nf.action_kind.visit.after_photo": "Photo après",
    "worker.system-states.w_x_nf.action_kind.visit.before_photo": "Photo avant",
    "worker.system-states.w_x_nf.action_kind.visit.check_in": "Pointage d'arrivée",
    "worker.system-states.w_x_nf.action_kind.visit.check_out": "Pointage de départ",
    "worker.system-states.w_x_nf.action_kind.visit.issue": "Signalement de visite",
    "worker.system-states.w_x_nf.attempts_count": "{count} tentatives",
    "worker.system-states.w_x_nf.delete_confirm_body": "L'action sera perdue.",
    "worker.system-states.w_x_nf.delete_confirm_no": "Annuler",
    "worker.system-states.w_x_nf.delete_confirm_title": "Supprimer définitivement ?",
    "worker.system-states.w_x_nf.delete_confirm_yes": "Oui, supprimer",
    "worker.system-states.w_x_nf.delete_cta": "Supprimer",
    "worker.system-states.w_x_nf.empty": "Aucun échec — tout est synchronisé.",
    "worker.system-states.w_x_nf.kicker": "↩ CHECK-OUT",
    "worker.system-states.w_x_nf.note": "Action échouée hors-ligne · conservée pour synchro.",
    "worker.system-states.w_x_nf.retry_cta": "Réessayer",
    "worker.system-states.w_x_nf.screen_kicker": "ÉCHECS DE SYNCHRONISATION",
    "worker.system-states.w_x_nf.screen_title": "Actions en échec",
    "worker.system-states.w_x_nf.title": "Envoi en attente",
    "worker.system-states.w_x_r.kicker": "FOYER PROPOSÉ",
    "worker.system-states.w_x_r.note": "Recommandation algorithmique · 1 visite proposée.",
    "worker.system-states.w_x_r.title": "Mme Akouwa, près de chez vous",
    "worker.system-states.w_x_s.body": "Votre compte est temporairement suspendu par le bureau. Vous ne pouvez pas démarrer de nouvelles visites pendant la suspension.",
    "worker.system-states.w_x_s.contact_bureau_cta": "Appeler le bureau",
    "worker.system-states.w_x_s.expires_on_label": "Levée prévue le",
    "worker.system-states.w_x_s.kicker": "COMPTE SUSPENDU",
    "worker.system-states.w_x_s.note": "État pleine page · accès bloqué.",
    "worker.system-states.w_x_s.reason_default": "À discuter avec le bureau",
    "worker.system-states.w_x_s.reason_label": "Motif",
    "worker.system-states.w_x_s.sign_out_cta": "Se déconnecter",
    "worker.system-states.w_x_s.suspended_on_label": "Suspendu le",
    "worker.system-states.w_x_s.title": "Accès bloqué",
    "worker.system-states.w_x_t.kicker": "POURBOIRE REÇU",
    "worker.system-states.w_x_t.note": "Pourboire facultatif d'une cliente · état de gratitude.",
    "worker.system-states.w_x_t.title": "Mme Adjoa vous remercie",
    "worker.system-states.w_x_u.body": "Une mise à jour de l'application est nécessaire pour continuer. Cela prend moins d'une minute.",
    "worker.system-states.w_x_u.current_version_label": "Votre version",
    "worker.system-states.w_x_u.kicker": "MISE À JOUR",
    "worker.system-states.w_x_u.note": "Version trop ancienne · mise à jour forcée.",
    "worker.system-states.w_x_u.required_version_label": "Version requise",
    "worker.system-states.w_x_u.title": "Nouvelle version",
    "worker.system-states.w_x_u.update_cta": "Mettre à jour",
    "worker.toast.address.success": "Adresse enregistrée",
    "worker.toast.checkout.error": "Échec de la fin de visite",
    "worker.toast.checkout.success": "Visite terminée",
    "worker.toast.identity.success": "Identité enregistrée",
    "worker.toast.issue.error": "Échec de l'envoi",
    "worker.toast.issue.success": "Incident signalé",
    "worker.toast.photo_after.success": "Photo après envoyée",
    "worker.toast.photo_before.success": "Photo avant envoyée",
    "worker.toast.pin.success": "Code PIN modifié",
    "worker.today.plan.cta": "Commencer la journée",
    "worker.today.plan.greeting": "Bonjour {name}. {count} visites aujourd'hui.",
    "worker.today.plan.map_label": "Carte des visites du jour",
    "worker.today.plan.stats.km": "km au total",
    "worker.today.plan.stats.visits": "visites",
    "worker.today.plan.stats.xof": "XOF estimés",
    "worker.today.session.cta": "Arrivée chez {name}",
    "worker.today.session.cta_hint": "Glissez à l'arrivée pour démarrer la visite",
    "worker.today.session.distance_label": "distance",
    "worker.today.session.eta_label": "arrivée",
    "worker.today.session.eyebrow": "Visite {current} sur {total} · vers",
    "worker.today.session.window_label": "fenêtre",
    "worker.today.w_03.cta_start": "Démarrer",
    "worker.today.w_03.error_body": "Vérifiez votre connexion. La tournée se rechargera automatiquement.",
    "worker.today.w_03.error_retry": "Réessayer",
    "worker.today.w_03.error_title": "Tournée indisponible.",
    "worker.today.w_03.kicker": "MARDI 5 MAI",
    "worker.today.w_03.loading": "Chargement…",
    "worker.today.w_03.note": "Hub par défaut. Tri chronologique. 1er = état actif.",
    "worker.today.w_03.status_completed": "Terminée",
    "worker.today.w_03.status_en_route": "En route",
    "worker.today.w_03.status_in_progress": "En cours",
    "worker.today.w_03.status_no_show": "Non visite",
    "worker.today.w_03.status_scheduled": "À venir",
    "worker.today.w_03.subscriber_unknown": "Cliente",
    "worker.today.w_03.summary_count": "{count} visite{plural}",
    "worker.today.w_03.summary_window": "{first} → {last}",
    "worker.today.w_03.title": "Bonjour Akouvi.",
    "worker.today.w_03_0.kicker": "JEUDI 7 MAI",
    "worker.today.w_03_0.note": "Aucune visite aujourd'hui · état de repos.",
    "worker.today.w_03_0.title": "Repos.",
    "worker.today.w_03_session.kicker": "Visite 2 sur 4 · vers",
    "worker.today.w_03_session.title": "En route",
    "worker.tour.day_label": "{weekday} {day} {month}",
    "worker.tour.detail.back": "Tournée · visite {index} / {count}",
    "worker.tour.detail.call_office": "Appeler bureau",
    "worker.tour.detail.client_note": "« Le portail est ouvert le mardi matin, entrez directement. »",
    "worker.tour.detail.cta_start": "Démarrer la route",
    "worker.tour.detail.first_visit": "Première visite",
    "worker.tour.detail.itinerary": "Itinéraire",
    "worker.tour.detail.note_label": "Note de la cliente",
    "worker.tour.detail.tenure": "{months}e mois",
    "worker.tour.detail.tier_label": "Tarif T{n}",
    "worker.tour.detail.when_label": "Quand",
    "worker.tour.detail.where_label": "Où",
    "worker.tour.empty.body": "Le bureau vous prévient dès qu'une cliente confirme.",
    "worker.tour.empty.title": "Pas de visite aujourd'hui",
    "worker.tour.greeting": "Bonjour {name}",
    "worker.tour.next_label": "Prochaine",
    "worker.tour.summary.earn_label": "À gagner",
    "worker.tour.summary.visits": "{count} visites",
    "worker.visit-lifecycle.w_04.kicker": "↩ TOURNÉE · 1 / 5",
    "worker.visit-lifecycle.w_04.note": "Avant départ. Notes cliente visibles.",
    "worker.visit-lifecycle.w_04.title": "Mme Adjoa K.",
    "worker.visit-lifecycle.w_04_p.kicker": "NOUVELLE VISITE",
    "worker.visit-lifecycle.w_04_p.note": "Modal blocking. Accepter/refuser une visite.",
    "worker.visit-lifecycle.w_04_p.title": "Mme Komi K.",
    "worker.visit-lifecycle.w_04_pr.kicker": "↩ ASSIGNATION",
    "worker.visit-lifecycle.w_04_pr.note": "Sous-modal de W-04.P. Liste de motifs courts.",
    "worker.visit-lifecycle.w_04_pr.title": "Pourquoi refuser ?",
    "worker.visit-lifecycle.w_05.kicker": "↩ MME ADJOA K.",
    "worker.visit-lifecycle.w_05.note": "ETA + distance restante. GPS continu.",
    "worker.visit-lifecycle.w_05.title": "En route",
    "worker.visit-lifecycle.w_06.kicker": "↩ MME ADJOA K.",
    "worker.visit-lifecycle.w_06.note": "GPS dans rayon 50m → CTA s'active.",
    "worker.visit-lifecycle.w_06.title": "Vous y êtes ?",
    "worker.visit-lifecycle.w_07.kicker": "VISITE 1 / 5",
    "worker.visit-lifecycle.w_07.note": "Confirmation présence. Photo avant.",
    "worker.visit-lifecycle.w_07.title": "Check-in",
    "worker.visit-lifecycle.w_08.kicker": "EN COURS",
    "worker.visit-lifecycle.w_08.note": "Timer croissant. Phase = libellé contextuel.",
    "worker.visit-lifecycle.w_08.title": "Lavage",
    "worker.visit-lifecycle.w_08_o.kicker": "EN COURS · DÉPASSEMENT",
    "worker.visit-lifecycle.w_08_o.note": "Timer au-delà de la cible · état attention.",
    "worker.visit-lifecycle.w_08_o.title": "Lavage",
    "worker.visit-lifecycle.w_09.kicker": "↩ LAVAGE",
    "worker.visit-lifecycle.w_09.note": "Capture de fin avant check-out.",
    "worker.visit-lifecycle.w_09.title": "Photo après",
    "worker.visit-lifecycle.w_10.kicker": "VISITE 1 / 5",
    "worker.visit-lifecycle.w_10.note": "Confirmation fin. GPS + photo après valides.",
    "worker.visit-lifecycle.w_10.title": "Check-out",
    "worker.visit-lifecycle.w_11.kicker": "VISITE 1 / 5",
    "worker.visit-lifecycle.w_11.note": "Bilan + transition vers visite suivante.",
    "worker.visit-lifecycle.w_11.title": "Bien joué.",
    "worker.visit-lifecycle.w_12.kicker": "EN PAUSE",
    "worker.visit-lifecycle.w_12.note": "Sous-modal de W-08. Timer en jaune.",
    "worker.visit-lifecycle.w_12.title": "Pause",
    "worker.visit.checkout.body": "Choisissez ce qui correspond le mieux à la visite.",
    "worker.visit.checkout.commercial_use": "Linge d’un commerce (hôtel, restaurant…)",
    "worker.visit.checkout.cta_send": "Terminer la visite",
    "worker.visit.checkout.kicker": "CLÔTURE",
    "worker.visit.checkout.mismatch": "Plus de personnes que prévu",
    "worker.visit.checkout.no_surcharge_hint": "Aucun supplément n’est facturé ici. Le bureau confirme avec la cliente.",
    "worker.visit.checkout.option_good": "Tout va bien",
    "worker.visit.checkout.option_major": "Gros souci",
    "worker.visit.checkout.option_minor": "Petit souci",
    "worker.visit.checkout.resolution_remainder": "Linge restant laissé",
    "worker.visit.checkout.third_party": "Linge d’une autre maison",
    "worker.visit.checkout.title": "Tout s'est bien passé ?",
    "worker.visit.checkout.volume_exceptional": "Beaucoup plus de linge que d’habitude",
    "worker.visit.checkout.volume_normal": "Volume habituel",
    "worker.visit.closed_by_office": "Le bureau a clôturé cette visite. Il n’y a plus rien à faire ici.",
    "worker.visit.enroute.cta_arrived": "J'arrive",
    "worker.visit.enroute.cta_report_problem": "Mauvaise adresse ?",
    "worker.visit.enroute.distance_far": "Encore {meters} m. Continuez vers la cliente.",
    "worker.visit.enroute.distance_near": "Vous êtes à l'adresse. Touchez « J'arrive » pour confirmer.",
    "worker.visit.enroute.label": "EN ROUTE · {time} — {name}",
    "worker.visit.enroute.signal_lost": "Signal perdu · dernière position connue",
    "worker.visit.geofence.body": "GPS confirmé à {meters} m près. Vous pouvez démarrer la visite.",
    "worker.visit.geofence.body_far": "GPS estime que vous êtes à {meters} m. Confirmer quand même ?",
    "worker.visit.geofence.cta_anyway": "Confirmer quand même",
    "worker.visit.geofence.cta_check_in": "Confirmer ma présence",
    "worker.visit.geofence.error_body": "Vérifiez votre connexion. La visite se rechargera automatiquement.",
    "worker.visit.geofence.error_retry": "Réessayer",
    "worker.visit.geofence.error_title": "Visite indisponible.",
    "worker.visit.geofence.kicker": "ARRIVÉE",
    "worker.visit.geofence.loading": "Vérification GPS…",
    "worker.visit.geofence.title": "Vous êtes arrivée",
    "worker.visit.geofence.wrong_place": "Mauvais endroit ? Signaler",
    "worker.visit.issue.category_cancelled_on_arrival": "Annulée sur place",
    "worker.visit.issue.category_no_subscriber": "Cliente absente",
    "worker.visit.issue.category_other": "Autre",
    "worker.visit.issue.category_unsafe": "Situation dangereuse",
    "worker.visit.issue.category_wrong_address": "Mauvaise adresse",
    "worker.visit.issue.cta_cancel": "Retour",
    "worker.visit.issue.cta_send": "Envoyer le signalement",
    "worker.visit.issue.error_send": "Envoi impossible. Veuillez réessayer.",
    "worker.visit.issue.kicker": "SIGNALEMENT",
    "worker.visit.issue.notes_label": "Détails (optionnel)",
    "worker.visit.issue.notes_placeholder": "Décrivez la situation en quelques mots…",
    "worker.visit.issue.title": "Qu'est-ce qui ne va pas ?",
    "worker.visit.next_visit.all_done_body": "Bravo. Reposez-vous bien et à demain !",
    "worker.visit.next_visit.all_done_title": "Tournées terminées",
    "worker.visit.next_visit.cta_continue": "Préparer la prochaine",
    "worker.visit.next_visit.cta_home": "Retour à l'accueil",
    "worker.visit.next_visit.error_body": "Vérifiez votre connexion. La liste se rechargera automatiquement.",
    "worker.visit.next_visit.error_retry": "Réessayer",
    "worker.visit.next_visit.error_title": "Suivant indisponible.",
    "worker.visit.next_visit.kicker": "SUITE",
    "worker.visit.next_visit.title": "Prochaine cliente",
    "worker.visit.not_paid": "Le paiement de ce foyer n’est pas encore reçu. Ne commencez pas : appelez le bureau.",
    "worker.visit.payment_unconfirmed_offline": "Pas de réseau : le paiement de ce foyer n’a pas pu être vérifié. Ne commencez pas : réessayez avec du réseau ou appelez le bureau.",
    "worker.visit.photo_after.body": "Photographiez le linge propre, plié et prêt pour la cliente.",
    "worker.visit.photo_after.cta_capture": "Prendre la photo",
    "worker.visit.photo_after.cta_confirm": "Confirmer et envoyer",
    "worker.visit.photo_after.cta_retake": "Reprendre",
    "worker.visit.photo_after.error_capture": "Caméra indisponible. Veuillez réessayer.",
    "worker.visit.photo_after.kicker": "PHOTO APRÈS",
    "worker.visit.photo_after.title": "Photo « après » du linge",
    "worker.visit.photo_before.body": "Photographiez le panier de linge sale, posé près de la bassine.",
    "worker.visit.photo_before.cta_capture": "Prendre la photo",
    "worker.visit.photo_before.cta_confirm": "Confirmer et envoyer",
    "worker.visit.photo_before.cta_retake": "Reprendre",
    "worker.visit.photo_before.error_capture": "Caméra indisponible. Veuillez réessayer.",
    "worker.visit.photo_before.kicker": "PHOTO AVANT",
    "worker.visit.photo_before.title": "Photo « avant » du linge",
    "worker.visit.recap.completed": "VISITE {n} / {total} TERMINÉE",
    "worker.visit.recap.credited": "crédité dans votre solde",
    "worker.visit.recap.cta_next": "Voir la prochaine tournée",
    "worker.visit.recap.earn": "+ {amount} XOF",
    "worker.visit.recap.kicker": "RÉCAP",
    "worker.visit.recap.queued_body": "Pas de réseau : elle part dès que possible. Tout est sauvegardé, vous pouvez continuer votre journée.",
    "worker.visit.recap.queued_title": "Fin de visite enregistrée",
    "worker.visit.w_04.address_label": "Adresse",
    "worker.visit.w_04.cta_prepare": "Préparer ma tournée",
    "worker.visit.w_04.kicker": "BRIEFING VISITE",
    "worker.visit.w_04.subscriber_label": "Cliente",
    "worker.visit.w_04.title": "Préparation",
    "worker.visit.w_04.window_afternoon": "Après-midi · 13 h–17 h",
    "worker.visit.w_04.window_label": "Créneau",
    "worker.visit.w_04.window_morning": "Matin · 8 h–12 h",
    "worker.visit.w_04_p.cta_continue": "Continuer",
    "worker.visit.w_04_p.item_bag": "Sac de transport",
    "worker.visit.w_04_p.item_phone": "Téléphone chargé",
    "worker.visit.w_04_p.item_supplies": "Savon et fournitures",
    "worker.visit.w_04_p.kicker": "CHECKLIST",
    "worker.visit.w_04_p.title": "Avant de partir",
    "worker.visit.w_04_pr.body": "Cliquez sur démarrer dès que vous êtes en route vers la cliente.",
    "worker.visit.w_04_pr.cta_start": "Démarrer la tournée",
    "worker.visit.w_04_pr.kicker": "PRÊTE À PARTIR",
    "worker.visit.w_04_pr.title": "Bonne route !",
    "worker.visit.washing.body": "Pas besoin de regarder l'écran. L'application tourne en arrière-plan.",
    "worker.visit.washing.cta_done": "Linge prêt — photo après",
    "worker.visit.washing.cta_issue": "Signaler un souci",
    "worker.visit.washing.kicker": "LAVAGE",
    "worker.visit.washing.timer_label": "Temps écoulé",
    "worker.visit.washing.title": "Lavage en cours"
}
